(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CCC", [], factory);
	else if(typeof exports === 'object')
		exports["CCC"] = factory();
	else
		root["CCC"] = factory();
})(self, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 338:
/***/ (function(module) {

(function (global, factory) {
   true ? module.exports = factory() :
  0;
}(this, (function () { 'use strict';

  /*
   * https://github.com/kraaden/autocomplete
   * Copyright (c) 2016 Denys Krasnoshchok
   * MIT License
   */
  function autocomplete(settings) {
      // just an alias to minimize JS file size
      var doc = document;
      var container = settings.container || doc.createElement("div");
      var containerStyle = container.style;
      var userAgent = navigator.userAgent;
      var mobileFirefox = userAgent.indexOf("Firefox") !== -1 && userAgent.indexOf("Mobile") !== -1;
      var debounceWaitMs = settings.debounceWaitMs || 0;
      var preventSubmit = settings.preventSubmit || false;
      var disableAutoSelect = settings.disableAutoSelect || false;
      // 'keyup' event will not be fired on Mobile Firefox, so we have to use 'input' event instead
      var keyUpEventName = mobileFirefox ? "input" : "keyup";
      var items = [];
      var inputValue = "";
      var minLen = 2;
      var showOnFocus = settings.showOnFocus;
      var selected;
      var keypressCounter = 0;
      var debounceTimer;
      if (settings.minLength !== undefined) {
          minLen = settings.minLength;
      }
      if (!settings.input) {
          throw new Error("input undefined");
      }
      var input = settings.input;
      container.className = "autocomplete " + (settings.className || "");
      // IOS implementation for fixed positioning has many bugs, so we will use absolute positioning
      containerStyle.position = "absolute";
      /**
       * Detach the container from DOM
       */
      function detach() {
          var parent = container.parentNode;
          if (parent) {
              parent.removeChild(container);
          }
      }
      /**
       * Clear debouncing timer if assigned
       */
      function clearDebounceTimer() {
          if (debounceTimer) {
              window.clearTimeout(debounceTimer);
          }
      }
      /**
       * Attach the container to DOM
       */
      function attach() {
          if (!container.parentNode) {
              doc.body.appendChild(container);
          }
      }
      /**
       * Check if container for autocomplete is displayed
       */
      function containerDisplayed() {
          return !!container.parentNode;
      }
      /**
       * Clear autocomplete state and hide container
       */
      function clear() {
          // prevent the update call if there are pending AJAX requests
          keypressCounter++;
          items = [];
          inputValue = "";
          selected = undefined;
          detach();
      }
      /**
       * Update autocomplete position
       */
      function updatePosition() {
          if (!containerDisplayed()) {
              return;
          }
          containerStyle.height = "auto";
          containerStyle.width = input.offsetWidth + "px";
          var maxHeight = 0;
          var inputRect;
          function calc() {
              var docEl = doc.documentElement;
              var clientTop = docEl.clientTop || doc.body.clientTop || 0;
              var clientLeft = docEl.clientLeft || doc.body.clientLeft || 0;
              var scrollTop = window.pageYOffset || docEl.scrollTop;
              var scrollLeft = window.pageXOffset || docEl.scrollLeft;
              inputRect = input.getBoundingClientRect();
              var top = inputRect.top + input.offsetHeight + scrollTop - clientTop;
              var left = inputRect.left + scrollLeft - clientLeft;
              containerStyle.top = top + "px";
              containerStyle.left = left + "px";
              maxHeight = window.innerHeight - (inputRect.top + input.offsetHeight);
              if (maxHeight < 0) {
                  maxHeight = 0;
              }
              containerStyle.top = top + "px";
              containerStyle.bottom = "";
              containerStyle.left = left + "px";
              containerStyle.maxHeight = maxHeight + "px";
          }
          // the calc method must be called twice, otherwise the calculation may be wrong on resize event (chrome browser)
          calc();
          calc();
          if (settings.customize && inputRect) {
              settings.customize(input, inputRect, container, maxHeight);
          }
      }
      /**
       * Redraw the autocomplete div element with suggestions
       */
      function update() {
          // delete all children from autocomplete DOM container
          while (container.firstChild) {
              container.removeChild(container.firstChild);
          }
          // function for rendering autocomplete suggestions
          var render = function (item, currentValue) {
              var itemElement = doc.createElement("div");
              itemElement.textContent = item.label || "";
              return itemElement;
          };
          if (settings.render) {
              render = settings.render;
          }
          // function to render autocomplete groups
          var renderGroup = function (groupName, currentValue) {
              var groupDiv = doc.createElement("div");
              groupDiv.textContent = groupName;
              return groupDiv;
          };
          if (settings.renderGroup) {
              renderGroup = settings.renderGroup;
          }
          var fragment = doc.createDocumentFragment();
          var prevGroup = "#9?$";
          items.forEach(function (item) {
              if (item.group && item.group !== prevGroup) {
                  prevGroup = item.group;
                  var groupDiv = renderGroup(item.group, inputValue);
                  if (groupDiv) {
                      groupDiv.className += " group";
                      fragment.appendChild(groupDiv);
                  }
              }
              var div = render(item, inputValue);
              if (div) {
                  div.addEventListener("click", function (ev) {
                      settings.onSelect(item, input);
                      clear();
                      ev.preventDefault();
                      ev.stopPropagation();
                  });
                  if (item === selected) {
                      div.className += " selected";
                  }
                  fragment.appendChild(div);
              }
          });
          container.appendChild(fragment);
          if (items.length < 1) {
              if (settings.emptyMsg) {
                  var empty = doc.createElement("div");
                  empty.className = "empty";
                  empty.textContent = settings.emptyMsg;
                  container.appendChild(empty);
              }
              else {
                  clear();
                  return;
              }
          }
          attach();
          updatePosition();
          updateScroll();
      }
      function updateIfDisplayed() {
          if (containerDisplayed()) {
              update();
          }
      }
      function resizeEventHandler() {
          updateIfDisplayed();
      }
      function scrollEventHandler(e) {
          if (e.target !== container) {
              updateIfDisplayed();
          }
          else {
              e.preventDefault();
          }
      }
      function keyupEventHandler(ev) {
          var keyCode = ev.which || ev.keyCode || 0;
          var ignore = [38 /* Up */, 13 /* Enter */, 27 /* Esc */, 39 /* Right */, 37 /* Left */, 16 /* Shift */, 17 /* Ctrl */, 18 /* Alt */, 20 /* CapsLock */, 91 /* WindowsKey */, 9 /* Tab */];
          for (var _i = 0, ignore_1 = ignore; _i < ignore_1.length; _i++) {
              var key = ignore_1[_i];
              if (keyCode === key) {
                  return;
              }
          }
          if (keyCode >= 112 /* F1 */ && keyCode <= 123 /* F12 */) {
              return;
          }
          // the down key is used to open autocomplete
          if (keyCode === 40 /* Down */ && containerDisplayed()) {
              return;
          }
          startFetch(0 /* Keyboard */);
      }
      /**
       * Automatically move scroll bar if selected item is not visible
       */
      function updateScroll() {
          var elements = container.getElementsByClassName("selected");
          if (elements.length > 0) {
              var element = elements[0];
              // make group visible
              var previous = element.previousElementSibling;
              if (previous && previous.className.indexOf("group") !== -1 && !previous.previousElementSibling) {
                  element = previous;
              }
              if (element.offsetTop < container.scrollTop) {
                  container.scrollTop = element.offsetTop;
              }
              else {
                  var selectBottom = element.offsetTop + element.offsetHeight;
                  var containerBottom = container.scrollTop + container.offsetHeight;
                  if (selectBottom > containerBottom) {
                      container.scrollTop += selectBottom - containerBottom;
                  }
              }
          }
      }
      /**
       * Select the previous item in suggestions
       */
      function selectPrev() {
          if (items.length < 1) {
              selected = undefined;
          }
          else {
              if (selected === items[0]) {
                  selected = items[items.length - 1];
              }
              else {
                  for (var i = items.length - 1; i > 0; i--) {
                      if (selected === items[i] || i === 1) {
                          selected = items[i - 1];
                          break;
                      }
                  }
              }
          }
      }
      /**
       * Select the next item in suggestions
       */
      function selectNext() {
          if (items.length < 1) {
              selected = undefined;
          }
          if (!selected || selected === items[items.length - 1]) {
              selected = items[0];
              return;
          }
          for (var i = 0; i < (items.length - 1); i++) {
              if (selected === items[i]) {
                  selected = items[i + 1];
                  break;
              }
          }
      }
      function keydownEventHandler(ev) {
          var keyCode = ev.which || ev.keyCode || 0;
          if (keyCode === 38 /* Up */ || keyCode === 40 /* Down */ || keyCode === 27 /* Esc */) {
              var containerIsDisplayed = containerDisplayed();
              if (keyCode === 27 /* Esc */) {
                  clear();
              }
              else {
                  if (!containerIsDisplayed || items.length < 1) {
                      return;
                  }
                  keyCode === 38 /* Up */
                      ? selectPrev()
                      : selectNext();
                  update();
              }
              ev.preventDefault();
              if (containerIsDisplayed) {
                  ev.stopPropagation();
              }
              return;
          }
          if (keyCode === 13 /* Enter */) {
              if (selected) {
                  settings.onSelect(selected, input);
                  clear();
              }
              if (preventSubmit) {
                  ev.preventDefault();
              }
          }
      }
      function focusEventHandler() {
          if (showOnFocus) {
              startFetch(1 /* Focus */);
          }
      }
      function startFetch(trigger) {
          // If multiple keys were pressed, before we get an update from server,
          // this may cause redrawing autocomplete multiple times after the last key was pressed.
          // To avoid this, the number of times keyboard was pressed will be saved and checked before redraw.
          var savedKeypressCounter = ++keypressCounter;
          var val = input.value;
          if (val.length >= minLen || trigger === 1 /* Focus */) {
              clearDebounceTimer();
              debounceTimer = window.setTimeout(function () {
                  settings.fetch(val, function (elements) {
                      if (keypressCounter === savedKeypressCounter && elements) {
                          items = elements;
                          inputValue = val;
                          selected = (items.length < 1 || disableAutoSelect) ? undefined : items[0];
                          update();
                      }
                  }, trigger);
              }, trigger === 0 /* Keyboard */ ? debounceWaitMs : 0);
          }
          else {
              clear();
          }
      }
      function blurEventHandler() {
          // we need to delay clear, because when we click on an item, blur will be called before click and remove items from DOM
          setTimeout(function () {
              if (doc.activeElement !== input) {
                  clear();
              }
          }, 200);
      }
      /**
       * Fixes #26: on long clicks focus will be lost and onSelect method will not be called
       */
      container.addEventListener("mousedown", function (evt) {
          evt.stopPropagation();
          evt.preventDefault();
      });
      /**
       * Fixes #30: autocomplete closes when scrollbar is clicked in IE
       * See: https://stackoverflow.com/a/9210267/13172349
       */
      container.addEventListener("focus", function () { return input.focus(); });
      /**
       * This function will remove DOM elements and clear event handlers
       */
      function destroy() {
          input.removeEventListener("focus", focusEventHandler);
          input.removeEventListener("keydown", keydownEventHandler);
          input.removeEventListener(keyUpEventName, keyupEventHandler);
          input.removeEventListener("blur", blurEventHandler);
          window.removeEventListener("resize", resizeEventHandler);
          doc.removeEventListener("scroll", scrollEventHandler, true);
          clearDebounceTimer();
          clear();
      }
      // setup event handlers
      input.addEventListener("keydown", keydownEventHandler);
      input.addEventListener(keyUpEventName, keyupEventHandler);
      input.addEventListener("blur", blurEventHandler);
      input.addEventListener("focus", focusEventHandler);
      window.addEventListener("resize", resizeEventHandler);
      doc.addEventListener("scroll", scrollEventHandler, true);
      return {
          destroy: destroy
      };
  }

  return autocomplete;

})));
//# sourceMappingURL=autocomplete.js.map


/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(537);
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(645);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions-both-sides {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.actions-left {\r\n    align-self: flex-start;\r\n    justify-content: left;\r\n    width: 100%;\r\n}\r\n\r\n.actions-right {\r\n    align-self: flex-end;\r\n}\r\n\r\n.input-wrapper {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    cursor: text;\r\n}\r\n\r\n.input-wrapper .input {\r\n    flex: auto;\r\n    /* Both border and outline marked as important only for BI Reporting */\r\n    border: none !important;\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n    min-width: 1px;\r\n    max-width: 100%;\r\n    height: auto;\r\n    padding: 0;\r\n    line-height: 1.4285714286;\r\n    text-overflow: ellipsis;\r\n\r\n    /* to occupy all the available input-wrapper space by default */\r\n    /* the suffix, prefix and stepper are still count because the input-wrapper is a flex block */\r\n    width: 100%;\r\n}\r\n\r\n.input-wrapper .rup-select__icon {\r\n    /* RFBI-1717 to prevent the icon width from changing when the HTMLInput width changes */\r\n    min-width: 1rem;\r\n}\r\n\r\n.input-wrapper .input::-ms-clear {\r\n    display: none;\r\n}\r\n\r\n.input-wrapper .input::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.input-wrapper .input::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.input-wrapper .input[type=number] {\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n.input-wrapper > .prefix {\r\n    justify-content: flex-start;\r\n    margin-right: 0.4rem;\r\n}\r\n\r\n.input-wrapper > .suffix {\r\n    margin-left: 0.4rem;\r\n}\r\n\r\n.input-wrapper > .stepper {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    margin-left: auto;\r\n}\r\n\r\n.input-wrapper > .stepper > button {\r\n    height: 1.25rem;\r\n    width: 1.25rem;\r\n}\r\n\r\n/* Remove after migration to the latest RUP */\r\n@media not all and (min-resolution: 0.001dpcm) {\r\n    @supports (-webkit-appearance: none) {\r\n        .rup-loader::before {\r\n            -webkit-animation: RUP-Loader-ie-turn 1.35s linear infinite;\r\n            animation: RUP-Loader-ie-turn 1.35s linear infinite;\r\n        }\r\n    }\r\n}\r\n\r\n/* fix the strange RUP rule with min height */\r\n.rup-application {\r\n    min-height: auto;\r\n}\r\n\r\n/* because RUP has a bug with order of normalization styles */\r\nh1, h2, h3, h4, h5, h6, hr, p, pre {\r\n    margin: 0;\r\n}\r\n\r\n/* to restore minimum width and fix problem with modal windows*/\r\n.rup-application__content {\r\n    min-width: 900px;\r\n    z-index: auto;\r\n}\r\n\r\n.rup-select__icon {\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.rup-select select {\r\n    height: 36px;\r\n}\r\n\r\n.rup-select {\r\n    /* TODO: remove after migration to the latest RUP version*/\r\n    line-height: 2.4285714286;\r\n}\r\n\r\n.rup-overline.rup-overline--regular {\r\n    color: #6c8293;\r\n}\r\n\r\n.rup-overline.rup-overline--medium {\r\n    color: #485b6e;\r\n    font-weight: 500;\r\n}\r\n\r\n/*RFBI-1741 Safari*/\r\n.rup-dialog {\r\n    outline: none;\r\n}\r\n\r\n/*RFBI-1741*/\r\nbutton.rup-icon-btn:focus,\r\nbutton.rup-icon-btn:focus-visible {\r\n    outline: 0;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.tooltip-icon {\r\n    margin-left: 4px;\r\n    margin-top: -5px;\r\n    margin-bottom: -3px;\r\n    vertical-align: middle;\r\n    color: #1479cc;\r\n    height: 1rem;\r\n    width: 1rem;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.tooltip-icon--warning {\r\n    margin-left: 4px;\r\n    margin-top: -5px;\r\n    margin-bottom: -3px;\r\n    vertical-align: middle;\r\n    color: #8a6500;\r\n    height: 1rem;\r\n    width: 1rem;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.rup-form-item__info--warning {\r\n    color: #8a6500;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/styles/common.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,sEAAsE;IACtE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,uBAAuB;;IAEvB,+DAA+D;IAC/D,6FAA6F;IAC7F,WAAW;AACf;;AAEA;IACI,uFAAuF;IACvF,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI;QACI;YACI,2DAA2D;YAC3D,mDAAmD;QACvD;IACJ;AACJ;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,SAAS;AACb;;AAEA,+DAA+D;AAC/D;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0DAA0D;IAC1D,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,aAAa;AACjB;;AAEA,YAAY;AACZ;;IAEI,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".actions-both-sides {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.actions-left {\r\n    align-self: flex-start;\r\n    justify-content: left;\r\n    width: 100%;\r\n}\r\n\r\n.actions-right {\r\n    align-self: flex-end;\r\n}\r\n\r\n.input-wrapper {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    cursor: text;\r\n}\r\n\r\n.input-wrapper .input {\r\n    flex: auto;\r\n    /* Both border and outline marked as important only for BI Reporting */\r\n    border: none !important;\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n    min-width: 1px;\r\n    max-width: 100%;\r\n    height: auto;\r\n    padding: 0;\r\n    line-height: 1.4285714286;\r\n    text-overflow: ellipsis;\r\n\r\n    /* to occupy all the available input-wrapper space by default */\r\n    /* the suffix, prefix and stepper are still count because the input-wrapper is a flex block */\r\n    width: 100%;\r\n}\r\n\r\n.input-wrapper .rup-select__icon {\r\n    /* RFBI-1717 to prevent the icon width from changing when the HTMLInput width changes */\r\n    min-width: 1rem;\r\n}\r\n\r\n.input-wrapper .input::-ms-clear {\r\n    display: none;\r\n}\r\n\r\n.input-wrapper .input::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.input-wrapper .input::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n.input-wrapper .input[type=number] {\r\n    -moz-appearance: textfield;\r\n}\r\n\r\n.input-wrapper > .prefix {\r\n    justify-content: flex-start;\r\n    margin-right: 0.4rem;\r\n}\r\n\r\n.input-wrapper > .suffix {\r\n    margin-left: 0.4rem;\r\n}\r\n\r\n.input-wrapper > .stepper {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    margin-left: auto;\r\n}\r\n\r\n.input-wrapper > .stepper > button {\r\n    height: 1.25rem;\r\n    width: 1.25rem;\r\n}\r\n\r\n/* Remove after migration to the latest RUP */\r\n@media not all and (min-resolution: 0.001dpcm) {\r\n    @supports (-webkit-appearance: none) {\r\n        .rup-loader::before {\r\n            -webkit-animation: RUP-Loader-ie-turn 1.35s linear infinite;\r\n            animation: RUP-Loader-ie-turn 1.35s linear infinite;\r\n        }\r\n    }\r\n}\r\n\r\n/* fix the strange RUP rule with min height */\r\n.rup-application {\r\n    min-height: auto;\r\n}\r\n\r\n/* because RUP has a bug with order of normalization styles */\r\nh1, h2, h3, h4, h5, h6, hr, p, pre {\r\n    margin: 0;\r\n}\r\n\r\n/* to restore minimum width and fix problem with modal windows*/\r\n.rup-application__content {\r\n    min-width: 900px;\r\n    z-index: auto;\r\n}\r\n\r\n.rup-select__icon {\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.rup-select select {\r\n    height: 36px;\r\n}\r\n\r\n.rup-select {\r\n    /* TODO: remove after migration to the latest RUP version*/\r\n    line-height: 2.4285714286;\r\n}\r\n\r\n.rup-overline.rup-overline--regular {\r\n    color: #6c8293;\r\n}\r\n\r\n.rup-overline.rup-overline--medium {\r\n    color: #485b6e;\r\n    font-weight: 500;\r\n}\r\n\r\n/*RFBI-1741 Safari*/\r\n.rup-dialog {\r\n    outline: none;\r\n}\r\n\r\n/*RFBI-1741*/\r\nbutton.rup-icon-btn:focus,\r\nbutton.rup-icon-btn:focus-visible {\r\n    outline: 0;\r\n    box-shadow: none !important;\r\n}\r\n\r\n.tooltip-icon {\r\n    margin-left: 4px;\r\n    margin-top: -5px;\r\n    margin-bottom: -3px;\r\n    vertical-align: middle;\r\n    color: #1479cc;\r\n    height: 1rem;\r\n    width: 1rem;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.tooltip-icon--warning {\r\n    margin-left: 4px;\r\n    margin-top: -5px;\r\n    margin-bottom: -3px;\r\n    vertical-align: middle;\r\n    color: #8a6500;\r\n    height: 1rem;\r\n    width: 1rem;\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.rup-form-item__info--warning {\r\n    color: #8a6500;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ __webpack_exports__["Z"] = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ 645:
/***/ (function(module) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";

      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }

      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }

      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }

      content += cssWithMappingToString(item);

      if (needLayer) {
        content += "}";
      }

      if (item[2]) {
        content += "}";
      }

      if (item[4]) {
        content += "}";
      }

      return content;
    }).join("");
  }; // import a list of modules into the list


  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }

      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }

      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }

      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ 537:
/***/ (function(module) {

"use strict";


module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || "").concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join("\n");
  }

  return [content].join("\n");
};

/***/ }),

/***/ 379:
/***/ (function(module) {

"use strict";


var stylesInDOM = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };

    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);

  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }

      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };

  return updater;
}

module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();

        stylesInDOM.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 569:
/***/ (function(module) {

"use strict";


var memo = {};
/* istanbul ignore next  */

function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }

    memo[target] = styleTarget;
  }

  return memo[target];
}
/* istanbul ignore next  */


function insertBySelector(insert, style) {
  var target = getTarget(insert);

  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }

  target.appendChild(style);
}

module.exports = insertBySelector;

/***/ }),

/***/ 216:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}

module.exports = insertStyleElement;

/***/ }),

/***/ 565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;

  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}

module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 795:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";

  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }

  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }

  var needLayer = typeof obj.layer !== "undefined";

  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }

  css += obj.css;

  if (needLayer) {
    css += "}";
  }

  if (obj.media) {
    css += "}";
  }

  if (obj.supports) {
    css += "}";
  }

  var sourceMap = obj.sourceMap;

  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  options.styleTagTransform(css, styleElement, options.options);
}

function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }

  styleElement.parentNode.removeChild(styleElement);
}
/* istanbul ignore next  */


function domAPI(options) {
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}

module.exports = domAPI;

/***/ }),

/***/ 589:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }

    styleElement.appendChild(document.createTextNode(css));
  }
}

module.exports = styleTagTransform;

/***/ }),

/***/ 822:
/***/ (function() {

/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
(function () {
    // ClassList polyfill for SVG Element in IE.
    if (!('classList' in SVGElement.prototype)) {
        Object.defineProperty(SVGElement.prototype, 'classList', {
            get() {
                return {
                    contains: (className) => this.className.baseVal.split(' ').indexOf(className) !== -1,
                    add: (className) => {
                        if (!className) {
                            return;
                        }
                        if (this.classList.contains(className)) {
                            return;
                        }
                        const currentClass = (this.getAttribute('class') || '').trim();
                        this.setAttribute('class', currentClass + ' ' + className.trim());
                    },
                    remove: (className) => {
                        const currentClass = this.getAttribute('class') || '';
                        const otherClasses = currentClass.replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
                        if (this.classList.contains(className)) {
                            this.setAttribute('class', otherClasses);
                        }
                    },
                    toggle: (className, force) => {
                        const needToAdd = force == undefined ? !this.classList.contains(className) : force;
                        if (needToAdd) {
                            this.classList.add(className);
                        }
                        else {
                            this.classList.remove(className);
                        }
                    }
                };
            }
        });
    }
    // support the 'force' argument
    const nativeToggle = DOMTokenList.prototype.toggle;
    DOMTokenList.prototype.toggle = function (className, force) {
        if (force == undefined) {
            return nativeToggle.call(this, className, force);
        }
        if (force) {
            this.add(className);
            return true;
        }
        this.remove(className);
        return false;
    };
    // matches polyfill for HTML Element in IE.
    if (!('matches' in document.documentElement)) {
        (function (e) {
            const matches = e.matches ||
                e.matchesSelector ||
                e.webkitMatchesSelector ||
                e.mozMatchesSelector ||
                e.msMatchesSelector ||
                e.oMatchesSelector;
            if (!matches) {
                e.matches = e.matchesSelector = function matches(selector) {
                    const matches = document.querySelectorAll(selector);
                    return Array.prototype.some.call(matches, (e) => e === this);
                };
            }
            else {
                e.matches = e.matchesSelector = matches;
            }
        })(Element.prototype);
    }
    // NodeList forEach
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
            thisArg = thisArg || window;
            for (let i = 0; i < this.length; i++) {
                callback.call(thisArg, this[i], i, this);
            }
        };
    }
    // eslint-disable-next-line @typescript-eslint/ban-types
    function CreateMethodProperty(object, methodName, func) {
        const attributes = { value: func, writable: !0, enumerable: !1, configurable: !0 };
        Object.defineProperty(object, methodName, attributes);
    }
    function ToObject(value) {
        if (null === value || value === undefined) {
            throw TypeError();
        }
        return Object(value);
    }
    if (!Object.values) {
        // eslint-disable-next-line prettier/prettier
        const toString = {}.toString;
        const split = ''.split;
        CreateMethodProperty(Object, 'values', function values(object) {
            const obj = toString.call(object) == '[object String]' ? split.call(object, '') : ToObject(object);
            const nameList = Object.keys(obj).map(function (key) {
                return obj[key];
            });
            return nameList;
        });
    }
    if (!('Element' in self && 'after' in Element.prototype)) {
        const _mutation = (function () {
            function e(e) {
                return 'function' == typeof Node
                    ? e instanceof Node
                    : e && 'object' == typeof e && e.nodeName && e.nodeType >= 1 && e.nodeType <= 12;
            }
            return function n(t) {
                if (1 === t.length) {
                    return e(t[0]) ? t[0] : document.createTextNode(t[0] + '');
                }
                let o, r;
                for (o = document.createDocumentFragment(), r = 0; r < t.length; r++) {
                    o.appendChild(e(t[r]) ? t[r] : document.createTextNode(t[r] + ''));
                }
                return o;
            };
        })();
        Element.prototype.after = function t() {
            if (this.parentNode) {
                for (
                // eslint-disable-next-line no-var
                var t = Array.prototype.slice.call(arguments), e = this.nextSibling, o = e ? t.indexOf(e) : -1; -1 !== o && (e = e.nextSibling);) {
                    o = t.indexOf(e);
                }
                this.parentNode.insertBefore(_mutation(arguments), e);
            }
        };
    }
    if (typeof window.CustomEvent !== 'function') {
        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            const evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }
        CustomEvent.prototype = window.Event.prototype;
        window.CustomEvent = CustomEvent;
    }
})();


/***/ }),

/***/ 916:
/***/ (function() {

/*
 * l10n.js
 * 2016-05-17
 *
 * By Eli Grey, http://eligrey.com
 * Licensed under the MIT License
 *   See https://github.com/eligrey/l10n.js/blob/master/LICENSE.md
 */

/*global XMLHttpRequest, setTimeout, document, navigator, ActiveXObject*/

/*! @source http://purl.eligrey.com/github/l10n.js/blob/master/l10n.js*/

(function () {
    'use strict';

    var undef_type = 'undefined',
        string_type = 'string',
        nav = self.navigator,
        String_ctr = String,
        has_own_prop = Object.prototype.hasOwnProperty,
        load_queues = {},
        localizations = {},
        FALSE = !1,
        TRUE = !0,
        // the official format is application/vnd.oftn.l10n+json, though l10n.js will also
        // accept application/x-l10n+json and application/l10n+json
        l10n_js_media_type = /^\s*application\/(?:vnd\.oftn\.|x-)?l10n\+json\s*(?:$|;)/i,
        XHR,
        // property minification aids
        $locale = 'locale',
        $default_locale = 'defaultLocale',
        $to_locale_string = 'toLocaleString',
        $to_lowercase = 'toLowerCase',
        array_index_of =
            Array.prototype.indexOf ||
            function (item) {
                var len = this.length,
                    i = 0;
                for (; i < len; i++) {
                    if (i in this && this[i] === item) {
                        return i;
                    }
                }

                return -1;
            },
        request_JSON = function (uri) {
            var req = new XHR(),
                data = {};

            // sadly, this has to be blocking to allow for a graceful degrading API
            req.open('GET', uri, FALSE);
            req.send(null);

            // Status codes can be inconsistent across browsers so we simply try to parse
            // the response text and catch any errors. This deals with failed requests as
            // well as malformed json files.
            try {
                data = JSON.parse(req.responseText);
            } catch (e) {
                // warn about error without stopping execution
                setTimeout(function () {
                    // Error messages are not localized as not to cause an infinite loop
                    var l10n_err = new Error('Unable to load localization data: ' + uri);
                    l10n_err.name = 'Localization Error';
                    throw l10n_err;
                }, 0);
            }

            return data;
        },
        load = (String_ctr[$to_locale_string] = function (data) {
            // don't handle function.toLocaleString(indentationAmount:Number)
            if (arguments.length > 0 && typeof data !== 'number') {
                if (typeof data === string_type) {
                    load(request_JSON(data));
                } else if (data === FALSE) {
                    // reset all localizations
                    localizations = {};
                } else {
                    // Extend current localizations instead of completely overwriting them
                    var locale, localization, message;
                    for (locale in data) {
                        if (has_own_prop.call(data, locale)) {
                            localization = data[locale];
                            locale = locale[$to_lowercase]();

                            if (!(locale in localizations) || localization === FALSE) {
                                // reset locale if not existing or reset flag is specified
                                localizations[locale] = {};
                            }

                            if (localization === FALSE) {
                                continue;
                            }

                            // URL specified
                            if (typeof localization === string_type) {
                                if (String_ctr[$locale][$to_lowercase]().indexOf(locale) === 0) {
                                    localization = request_JSON(localization);
                                } else {
                                    // queue loading locale if not needed
                                    if (!(locale in load_queues)) {
                                        load_queues[locale] = [];
                                    }
                                    load_queues[locale].push(localization);
                                    continue;
                                }
                            }

                            for (message in localization) {
                                if (has_own_prop.call(localization, message)) {
                                    localizations[locale][message] = localization[message];
                                }
                            }
                        }
                    }
                }
            }
            // Return what function.toLocaleString() normally returns
            return Function.prototype[$to_locale_string].apply(String_ctr, arguments);
        }),
        process_load_queue = function (locale) {
            var queue = load_queues[locale],
                i = 0,
                len = queue.length,
                localization;

            for (; i < len; i++) {
                localization = {};
                localization[locale] = request_JSON(queue[i]);
                load(localization);
            }

            delete load_queues[locale];
        },
        use_default,
        localize = (String_ctr.prototype[$to_locale_string] = function () {
            var using_default = use_default,
                current_locale = String_ctr[using_default ? $default_locale : $locale],
                parts = current_locale[$to_lowercase]().split('-'),
                i = parts.length,
                this_val = this.valueOf(),
                locale;

            use_default = FALSE;

            // Iterate through locales starting at most-specific until a localization is found
            do {
                locale = parts.slice(0, i).join('-');
                // load locale if not loaded
                if (locale in load_queues) {
                    process_load_queue(locale);
                }
                if (locale in localizations && this_val in localizations[locale]) {
                    return localizations[locale][this_val];
                }
            } while (i--);

            if (!using_default && String_ctr[$default_locale]) {
                use_default = TRUE;
                return localize.call(this_val);
            }

            return this_val;
        });
    if (typeof XMLHttpRequest === undef_type && typeof ActiveXObject !== undef_type) {
        var AXO = ActiveXObject;

        XHR = function () {
            try {
                return new AXO('Msxml2.XMLHTTP.6.0');
            } catch (xhrEx1) {}
            try {
                return new AXO('Msxml2.XMLHTTP.3.0');
            } catch (xhrEx2) {}
            try {
                return new AXO('Msxml2.XMLHTTP');
            } catch (xhrEx3) {}

            throw new Error('XMLHttpRequest not supported by this browser.');
        };
    } else {
        XHR = XMLHttpRequest;
    }

    String_ctr[$default_locale] = String_ctr[$default_locale] || '';
    if (!String_ctr[$locale]) {
        String_ctr[$locale] = (nav && (nav.language || nav.userLanguage)) || '';
    }

    if (typeof document !== undef_type) {
        var elts = document.getElementsByTagName('link'),
            i = elts.length,
            localization;

        while (i--) {
            var elt = elts[i],
                rel = (elt.getAttribute('rel') || '')[$to_lowercase]().split(/\s+/);
            if (l10n_js_media_type.test(elt.type)) {
                if (array_index_of.call(rel, 'localizations') !== -1) {
                    // multiple localizations
                    load(elt.getAttribute('href'));
                } else if (array_index_of.call(rel, 'localization') !== -1) {
                    // single localization
                    localization = {};
                    localization[(elt.getAttribute('hreflang') || '')[$to_lowercase]()] = elt.getAttribute('href');
                    load(localization);
                }
            }
        }
    }
})();


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	!function() {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ActionsBar": function() { return /* reexport */ ActionsBar; },
  "Colors": function() { return /* reexport */ colors; },
  "GlobalFilters": function() { return /* reexport */ GlobalFilters; },
  "GoogleAnalyticsService": function() { return /* reexport */ GoogleAnalyticsService; },
  "Header": function() { return /* reexport */ Header; },
  "HeaderAppSwitcher": function() { return /* reexport */ AppSwitcher; },
  "HeaderApplicationMenuGroup": function() { return /* reexport */ ApplicationMenuGroup; },
  "HeaderApplicationMenuItem": function() { return /* reexport */ ApplicationMenuItem; },
  "HeaderControlsGroup": function() { return /* reexport */ ControlsGroup; },
  "HeaderGlobalControlsGroup": function() { return /* reexport */ GlobalControlsGroup; },
  "HeaderIconButton": function() { return /* reexport */ IconButton; },
  "HeaderLiveChat": function() { return /* reexport */ LiveChat; },
  "HeaderLocalControlsGroup": function() { return /* reexport */ LocalControlsGroup; },
  "HeaderLogo": function() { return /* reexport */ Logo; },
  "HeaderUserInfo": function() { return /* reexport */ UserInfo; },
  "HtmlUtils": function() { return /* reexport */ htmlUtils_namespaceObject; },
  "Icons": function() { return /* reexport */ icons_namespaceObject; },
  "InlineParameter": function() { return /* reexport */ InlineParameter; },
  "InlineParametersContainer": function() { return /* reexport */ InlineParametersContainer; },
  "Menu": function() { return /* reexport */ Menu; },
  "MenuGroupItem": function() { return /* reexport */ GroupMenuItem; },
  "MenuItem": function() { return /* reexport */ MenuItem; },
  "MultiSelect": function() { return /* reexport */ MultiSelect; },
  "RupAutoComplete": function() { return /* reexport */ RupAutoComplete; },
  "RupInput": function() { return /* reexport */ RupInput; },
  "RupNotification": function() { return /* reexport */ RupNotification; },
  "RupNumberInput": function() { return /* reexport */ RupNumberInput; },
  "RupSelect": function() { return /* reexport */ RupSelect; },
  "SelectUtils": function() { return /* binding */ SelectUtils; },
  "SimpleFooter": function() { return /* reexport */ SimpleFooter; },
  "actionTokenLabels": function() { return /* reexport */ actionTokenLabels; },
  "componentTokenLabels": function() { return /* reexport */ componentTokenLabels; },
  "downloadBlob": function() { return /* reexport */ downloadBlob; },
  "encodeFileToBase64Async": function() { return /* reexport */ encodeFileToBase64Async; },
  "localize": function() { return /* reexport */ localize; },
  "parameterTokenLabels": function() { return /* reexport */ parameterTokenLabels; },
  "toQueryString": function() { return /* reexport */ toQueryString; }
});

// NAMESPACE OBJECT: ./src/icons/icons.ts
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, {
  "AddIcon": function() { return AddIcon; },
  "ApplyIcon": function() { return ApplyIcon; },
  "AudioDocTypeIcon": function() { return AudioDocTypeIcon; },
  "BackIcon": function() { return BackIcon; },
  "BellIcon": function() { return BellIcon; },
  "BookmarkIcon": function() { return BookmarkIcon; },
  "BreakEvenAnalysisIcon": function() { return BreakEvenAnalysisIcon; },
  "BudgetAuditIcon": function() { return BudgetAuditIcon; },
  "Bullet": function() { return Bullet; },
  "CalendarIcon": function() { return CalendarIcon; },
  "CancelIcon": function() { return CancelIcon; },
  "CartIcon": function() { return CartIcon; },
  "ChartTypeIcon": function() { return ChartTypeIcon; },
  "ChatIcon": function() { return ChatIcon; },
  "CheckAlternateIcon": function() { return CheckAlternateIcon; },
  "CheckMarkIcon": function() { return CheckMarkIcon; },
  "ChevronDownIcon": function() { return ChevronDownIcon; },
  "ChevronLeftIcon": function() { return ChevronLeftIcon; },
  "ChevronRightIcon": function() { return ChevronRightIcon; },
  "ChevronUpIcon": function() { return ChevronUpIcon; },
  "ClearFilterIcon": function() { return ClearFilterIcon; },
  "ClearIcon": function() { return ClearIcon; },
  "CloseIcon": function() { return CloseIcon; },
  "CommentsIcon": function() { return CommentsIcon; },
  "ConfigureIcon": function() { return ConfigureIcon; },
  "CopyIcon": function() { return CopyIcon; },
  "CopyrightIcon": function() { return CopyrightIcon; },
  "DangerIcon": function() { return DangerIcon; },
  "DocumentIcon": function() { return DocumentIcon; },
  "DocumentNotReadStatus": function() { return DocumentNotReadStatus; },
  "DocumentReadStatus": function() { return DocumentReadStatus; },
  "DownloadIcon": function() { return DownloadIcon; },
  "DraggableIcon": function() { return DraggableIcon; },
  "DropdownArrowsIcon": function() { return DropdownArrowsIcon; },
  "DropdownIcon": function() { return DropdownIcon; },
  "DuplicateIcon": function() { return DuplicateIcon; },
  "EditIcon": function() { return EditIcon; },
  "ErrorIcon": function() { return ErrorIcon; },
  "ExcelDocTypeIcon": function() { return ExcelDocTypeIcon; },
  "ExitIcon": function() { return ExitIcon; },
  "ExportIcon": function() { return ExportIcon; },
  "FilterIcon": function() { return FilterIcon; },
  "FolderOpenIcon": function() { return FolderOpenIcon; },
  "GridIcon": function() { return GridIcon; },
  "ImageDocTypeIcon": function() { return ImageDocTypeIcon; },
  "ImportIcon": function() { return ImportIcon; },
  "InfoIcon": function() { return InfoIcon; },
  "InsertIcon": function() { return InsertIcon; },
  "ItemOfInterestDocTypeIcon": function() { return ItemOfInterestDocTypeIcon; },
  "LibraryViewIcon": function() { return LibraryViewIcon; },
  "LinkoutDocTypeIcon": function() { return LinkoutDocTypeIcon; },
  "ListAddIcon": function() { return ListAddIcon; },
  "MailIcon": function() { return MailIcon; },
  "MenuToggleIcon": function() { return MenuToggleIcon; },
  "MinusIcon": function() { return MinusIcon; },
  "ModalCloseIcon": function() { return ModalCloseIcon; },
  "MoreIcon": function() { return MoreIcon; },
  "MyProfile": function() { return MyProfile; },
  "OpenInNewTabIcon": function() { return OpenInNewTabIcon; },
  "OrderDocIcon": function() { return OrderDocIcon; },
  "OtherDocTypeIcon": function() { return OtherDocTypeIcon; },
  "PDFDocTypeIcon": function() { return PDFDocTypeIcon; },
  "PercentIcon": function() { return PercentIcon; },
  "PinButton": function() { return PinButton; },
  "PowerpointDocTypeIcon": function() { return PowerpointDocTypeIcon; },
  "PrintIcon": function() { return PrintIcon; },
  "QuestionIcon": function() { return QuestionIcon; },
  "RFBILogo": function() { return RFBILogo; },
  "RadioDefaultIcon": function() { return RadioDefaultIcon; },
  "RadioSelectedIcon": function() { return RadioSelectedIcon; },
  "RefreshIcon": function() { return RefreshIcon; },
  "RemoveIcon": function() { return RemoveIcon; },
  "RestoreIcon": function() { return RestoreIcon; },
  "RightFindEnterprise": function() { return RightFindEnterprise; },
  "RightFindNavigate": function() { return RightFindNavigate; },
  "RightsDirectLogo": function() { return RightsDirectLogo; },
  "SaveIcon": function() { return SaveIcon; },
  "SearchIcon": function() { return SearchIcon; },
  "SearchResults": function() { return SearchResults; },
  "SettingsIcon": function() { return SettingsIcon; },
  "ShareIcon": function() { return ShareIcon; },
  "SignOut": function() { return SignOut; },
  "SimpleFooterLogo": function() { return SimpleFooterLogo; },
  "SortIcon": function() { return SortIcon; },
  "SourceSelectorIcon": function() { return SourceSelectorIcon; },
  "StarFilledIcon": function() { return StarFilledIcon; },
  "StarIcon": function() { return StarIcon; },
  "SuiteIcon": function() { return SuiteIcon; },
  "SwitchIcon": function() { return SwitchIcon; },
  "TagIcon": function() { return TagIcon; },
  "TypesIcon": function() { return TypesIcon; },
  "UploadIcon": function() { return UploadIcon; },
  "VariantsIcon": function() { return VariantsIcon; },
  "VideoDocTypeIcon": function() { return VideoDocTypeIcon; },
  "WarningIcon": function() { return WarningIcon; },
  "WidgetCommentsIcon": function() { return WidgetCommentsIcon; },
  "WidgetOptionsIcon": function() { return WidgetOptionsIcon; },
  "WordDocTypeIcon": function() { return WordDocTypeIcon; },
  "WrenchIcon": function() { return WrenchIcon; }
});

// NAMESPACE OBJECT: ./src/utils/htmlUtils.ts
var htmlUtils_namespaceObject = {};
__webpack_require__.r(htmlUtils_namespaceObject);
__webpack_require__.d(htmlUtils_namespaceObject, {
  "animateAsync": function() { return animateAsync; },
  "createEvent": function() { return createEvent; },
  "default": function() { return htmlUtils; },
  "getFont": function() { return getFont; },
  "getTextWidth": function() { return getTextWidth; },
  "offset": function() { return offset; },
  "positionDropdown": function() { return positionDropdown; }
});

// EXTERNAL MODULE: ./src/utils/polyfills.ts
var polyfills = __webpack_require__(822);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js
var injectStylesIntoStyleTag = __webpack_require__(379);
var injectStylesIntoStyleTag_default = /*#__PURE__*/__webpack_require__.n(injectStylesIntoStyleTag);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleDomAPI.js
var styleDomAPI = __webpack_require__(795);
var styleDomAPI_default = /*#__PURE__*/__webpack_require__.n(styleDomAPI);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertBySelector.js
var insertBySelector = __webpack_require__(569);
var insertBySelector_default = /*#__PURE__*/__webpack_require__.n(insertBySelector);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js
var setAttributesWithoutAttributes = __webpack_require__(565);
var setAttributesWithoutAttributes_default = /*#__PURE__*/__webpack_require__.n(setAttributesWithoutAttributes);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/insertStyleElement.js
var insertStyleElement = __webpack_require__(216);
var insertStyleElement_default = /*#__PURE__*/__webpack_require__.n(insertStyleElement);
// EXTERNAL MODULE: ./node_modules/style-loader/dist/runtime/styleTagTransform.js
var styleTagTransform = __webpack_require__(589);
var styleTagTransform_default = /*#__PURE__*/__webpack_require__.n(styleTagTransform);
// EXTERNAL MODULE: ./node_modules/css-loader/dist/cjs.js!./src/styles/common.css
var common = __webpack_require__(21);
;// CONCATENATED MODULE: ./src/styles/common.css

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (styleTagTransform_default());
options.setAttributes = (setAttributesWithoutAttributes_default());

      options.insert = insertBySelector_default().bind(null, "head");
    
options.domAPI = (styleDomAPI_default());
options.insertStyleElement = (insertStyleElement_default());

var update = injectStylesIntoStyleTag_default()(common/* default */.Z, options);




       /* harmony default export */ var styles_common = (common/* default */.Z && common/* default.locals */.Z.locals ? common/* default.locals */.Z.locals : undefined);

;// CONCATENATED MODULE: ./src/icons/icons.ts
const WrenchIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6835 13.9885C11.4098 13.7568 12.2047 13.9499 12.7438 14.489L17.7947 19.5399L19.5399 17.7948L14.4891 12.744C13.9499 12.2049 13.7568 11.41 13.9885 10.6836C14.1437 10.1972 14.2282 9.67695 14.2282 9.13302C14.2282 6.31912 11.947 4.03801 9.1331 4.03801C9.1161 4.03801 9.09911 4.03809 9.08214 4.03825L11.5439 6.49999C11.9261 6.88219 12.1408 7.40057 12.1408 7.94108C12.1408 8.48159 11.9261 8.99997 11.5439 9.38217L9.38225 11.5438C9.00005 11.926 8.48167 12.1407 7.94115 12.1407C7.40063 12.1407 6.88225 11.926 6.50004 11.5438L4.03828 9.08206C4.03811 9.09903 4.03803 9.11601 4.03803 9.13302C4.03803 11.9469 6.31917 14.228 9.1331 14.228C9.67695 14.228 10.1971 14.1435 10.6835 13.9885ZM15.9302 11.3029C16.1484 10.6187 16.2662 9.88962 16.2662 9.13302C16.2662 5.19356 13.0726 2 9.1331 2C8.16749 2 7.24668 2.19187 6.40674 2.53956C5.80581 2.78831 5.72158 3.55991 6.18147 4.01979L10.1028 7.94108L7.94115 10.1027L4.01981 6.18142C3.55993 5.72154 2.78832 5.80577 2.53956 6.40669C2.19187 7.24662 2 8.16742 2 9.13302C2 13.0725 5.1936 16.266 9.1331 16.266C9.88958 16.266 10.6185 16.1483 11.3027 15.9301L17.0742 21.7015C17.4721 22.0995 18.1173 22.0995 18.5153 21.7015L21.7015 18.5153C22.0995 18.1174 22.0995 17.4722 21.7015 17.0742L15.9302 11.3029Z" fill="#4C5961"/>' +
    '</svg>';
const ChatIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-chat"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M8.674 18H3a1 1 0 01-.6-1.8c.49-.367.836-.65 1.077-.875.148-.14.237-.24.29-.307A7.97 7.97 0 012 10a8 8 0 0115.881-1.381 7.001 7.001 0 012.741 10.552c.055.063.123.139.21.232.214.227.497.512.875.89A1 1 0 0121 22h-6a7 7 0 01-6.326-4zM4 10a6 6 0 0111.67-1.968A7 7 0 008.07 16H5.518c.033-.053.064-.108.092-.163a1.72 1.72 0 00.153-1.235c-.097-.378-.31-.679-.478-.89A5.97 5.97 0 014 10zm6 5a5 5 0 118.88 3.155c-.14.171-.351.469-.384.885-.031.397.11.724.255.96h-3.75a5 5 0 01-5-5zm10.451 3.946l.002.004a.085.085 0 01-.002-.004zm-.036.492l.004-.006-.003.005-.001.001z"/></svg>';
const QuestionIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-help"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4 12a8 8 0 1116 0 8 8 0 01-16 0zm8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm-1 8a1 1 0 111 1 1 1 0 00-1 1v1a1 1 0 102 0v-.17A3.001 3.001 0 109 10a1 1 0 102 0zm2 5.75a1 1 0 10-2 0V16a1 1 0 102 0v-.25z"/></svg>';
const SuiteIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-apps"><path class="primary" d="M7 5a2 2 0 11-4 0 2 2 0 014 0zM21 5a2 2 0 11-4 0 2 2 0 014 0zM12 7a2 2 0 100-4 2 2 0 000 4zM7 12a2 2 0 11-4 0 2 2 0 014 0zM19 14a2 2 0 100-4 2 2 0 000 4zM14 12a2 2 0 11-4 0 2 2 0 014 0zM5 21a2 2 0 100-4 2 2 0 000 4zM21 19a2 2 0 11-4 0 2 2 0 014 0zM12 21a2 2 0 100-4 2 2 0 000 4z"/></svg>';
const RFBILogo = '<svg width="186" height="40" viewBox="0 0 186 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0 1.01523V15.2284H2.472V9.42132H3.34917L7.33627 15.2284H10.4063L6.08033 9.17767C7.71504 8.71066 9.27001 7.49239 9.27001 5.19797C9.27001 2.17259 6.51891 1.01523 4.30607 1.01523H0ZM3.84755 7.26904H2.472V3.16751H4.24626C5.68162 3.16751 6.65846 4 6.65846 5.25888C6.65846 6.6802 5.46233 7.26904 3.84755 7.26904Z" fill="#00326E"/>' +
    '<path d="M12.2603 4.77157V15.2284H14.6725V4.77157H12.2603ZM12.2603 0.771575V3.06599H14.6725V0.771575H12.2603Z" fill="#00326E"/>' +
    '<path d="M22.1779 19.8173C24.0917 19.8173 25.8461 19.1472 26.7631 17.4416C27.1618 16.7107 27.3811 15.797 27.3811 14.6802V4.77157H25.1683L25.0487 5.96954C24.2712 4.97462 22.9754 4.52792 21.8789 4.52792C18.9285 4.52792 16.915 7.00508 16.915 9.84772C16.915 12.8731 19.0281 15.2284 21.8191 15.2284C22.9156 15.2284 24.2114 14.802 24.949 13.7665V14.9442C24.949 16.8528 23.693 17.665 22.1181 17.665C20.9818 17.665 19.5066 17.198 18.4301 16.3655L17.533 18.3959C18.8886 19.3503 20.603 19.8173 22.1779 19.8173ZM22.2776 13.0761C20.5034 13.0761 19.367 11.5939 19.367 9.90863C19.367 8.32487 20.3239 6.6802 22.3374 6.6802C23.2744 6.6802 24.2512 7.0863 24.949 8V11.4721C24.3708 12.5888 23.2545 13.0761 22.2776 13.0761Z" fill="#00326E"/>' +
    '<path d="M30.249 0V15.2284H32.6612V8.28426C33.2593 7.30965 34.2561 6.6802 35.213 6.6802C35.9506 6.6802 36.4689 6.94416 36.7679 7.47208C37.1467 8.12183 37.1666 9.09645 37.1666 9.96954V15.2284H39.5788V9.7868C39.5788 8.26396 39.4193 6.88325 38.6618 5.86802C38.0239 5.03553 37.067 4.52792 35.831 4.52792C34.6348 4.52792 33.4586 5.07614 32.6612 6.19289V0H30.249Z" fill="#00326E"/>' +
    '<path d="M45.7246 15.4518C46.4821 15.4518 47.3593 15.2487 47.9574 14.9036L47.2397 13.0355C46.9008 13.2183 46.5419 13.3198 46.1034 13.3198C45.3657 13.3198 45.1066 12.9137 45.0069 12.1015C44.967 11.7767 44.967 11.4721 44.967 11.1675V6.84264H47.6783V4.77157H44.967V2.37564H42.7941L42.5349 4.77157H41.259V6.84264H42.5349V11.533C42.5349 12.2234 42.5947 12.9137 42.7941 13.4619C43.2127 14.6599 44.1895 15.4518 45.7246 15.4518Z" fill="#00326E"/>' +
    '<path d="M50.0919 1.01523V15.2284H52.5639V9.3401H57.5477V7.18782H52.5639V3.16751H57.5477V1.01523H50.0919Z" fill="#00326E"/>' +
    '<path d="M59.8603 4.77157V15.2284H62.2724V4.77157H59.8603ZM59.8603 0.771575V3.06599H62.2724V0.771575H59.8603Z" fill="#00326E"/>' +
    '<path d="M65.2724 4.77157V15.2284H67.6846V8.28426C68.2827 7.30965 69.2795 6.6802 70.2364 6.6802C70.974 6.6802 71.4923 6.94416 71.7914 7.47208C72.1701 8.12183 72.1901 9.09645 72.1901 9.96954V15.2284H74.6023V9.7868C74.6023 8.26396 74.4428 6.90355 73.6852 5.86802C73.0672 5.01523 72.0904 4.52792 70.8544 4.52792C69.6184 4.52792 68.4023 5.11675 67.585 6.31472L67.4653 4.77157H65.2724Z" fill="#00326E"/>' +
    '<path d="M81.665 15.4721C82.8014 15.4721 84.137 15.0254 84.8746 13.8883L84.9943 15.2284H87.2071V0H84.775V5.84772C83.9776 4.95432 82.7615 4.52792 81.7049 4.52792C78.7544 4.52792 76.741 7.1066 76.741 9.96954C76.741 13.0152 78.8342 15.4721 81.665 15.4721ZM82.1236 13.3198C80.3094 13.3198 79.193 11.736 79.193 10.0305C79.193 8.4264 80.1499 6.6802 82.1634 6.6802C83.1004 6.6802 84.0772 7.0863 84.775 8V11.6954C84.1968 12.8325 83.0805 13.3198 82.1236 13.3198Z" fill="#00326E"/>' +
    '<path d="M0.358839 21.3198V35.533H3.48871C4.78452 35.533 6.04046 35.3909 7.03723 34.9442C8.31311 34.3756 9.17033 33.3604 9.17033 31.5736C9.17033 29.8071 8.31311 28.6497 6.35943 28.1624C8.01407 27.5736 8.61214 26.4975 8.61214 25.0761C8.61214 23.7563 8.07388 22.8629 7.25653 22.2741C6.27969 21.5838 4.90414 21.3198 3.56846 21.3198H0.358839ZM1.83407 34.1523V28.9543H4.36588C6.4591 28.9543 7.59543 30.0305 7.59543 31.5736C7.59543 32.7107 7.07711 33.3604 6.31956 33.7056C5.40252 34.132 4.12665 34.1523 3.07007 34.1523H1.83407ZM1.83407 22.7005H2.97039C4.28613 22.7005 5.48226 22.7817 6.25975 23.2893C6.81794 23.6548 7.13691 24.2437 7.13691 25.1777C7.13691 26.8426 5.72149 27.5736 3.42891 27.5736H1.83407V22.7005Z" fill="#00326E"/>' +
    '<path d="M20.7571 35.533V25.6244H19.4015V32.203C18.7635 33.4619 17.5873 34.5178 16.132 34.5178C13.9591 34.5178 13.6202 32.6294 13.6202 30.7614V25.6244H12.2645V30.9848C12.2645 33.9695 13.1616 35.7766 15.9327 35.7766C17.4278 35.7766 18.624 35.1066 19.4015 33.7868V35.533H20.7571Z" fill="#00326E"/>' +
    '<path d="M29.66 26.335C28.9024 25.7056 28.0053 25.3807 26.9886 25.3807C25.3539 25.3807 23.9584 26.335 23.9584 28.0406C23.9584 29.8477 25.334 30.4365 26.6099 30.9645C27.7063 31.4112 28.743 31.8173 28.743 32.9543C28.743 34.0914 27.6465 34.599 26.7095 34.599C25.7925 34.599 25.0549 34.1929 24.4768 33.5635L23.6594 34.4365C24.4568 35.3299 25.5732 35.7766 26.6697 35.7766C28.3044 35.7766 30.0986 34.7208 30.0986 32.9746C30.0986 31.2081 28.9224 30.5178 27.7262 30.0102C26.4902 29.4822 25.2343 29.0964 25.2343 27.9188C25.2343 26.9848 26.1912 26.5584 26.9488 26.5584C27.6664 26.5584 28.3841 26.8426 28.9224 27.269L29.66 26.335Z" fill="#00326E"/>' +
    '<path d="M34.4739 35.533V25.6244H33.1183V35.533H34.4739ZM34.4739 23.4112V21.5025H33.1183V23.4112H34.4739Z" fill="#00326E"/>' +
    '<path d="M38.1022 25.6244V35.533H39.4578V28.9543C40.0958 27.6954 41.2719 26.6396 42.7272 26.6396C44.9002 26.6396 45.2391 28.5279 45.2391 30.3959V35.533H46.5947V30.1726C46.5947 27.1878 45.6976 25.3807 42.9266 25.3807C41.4314 25.3807 40.2353 26.0508 39.4578 27.3706V25.6244H38.1022Z" fill="#00326E"/>' +
    '<path d="M58.2089 30.9239C58.2288 30.7411 58.2687 30.335 58.2687 30.0102C58.2687 27.5533 56.4546 25.3807 53.9427 25.3807C51.2913 25.3807 49.1781 27.5939 49.1781 30.5178C49.1781 33.4213 50.9125 35.7766 54.1022 35.7766C55.5774 35.7766 57.2719 35.0051 58.0494 33.5228L57.0925 32.8934C56.3947 34.2335 55.2983 34.599 54.0025 34.599C51.8893 34.599 50.6533 32.8325 50.5337 30.9239H58.2089ZM56.933 29.7462H50.5736C50.8527 27.8985 52.0687 26.5584 53.9427 26.5584C55.5973 26.5584 56.8533 28.0812 56.933 29.7462Z" fill="#00326E"/>' +
    '<path d="M66.2798 26.335C65.5223 25.7056 64.6252 25.3807 63.6084 25.3807C61.9737 25.3807 60.5782 26.335 60.5782 28.0406C60.5782 29.8477 61.9538 30.4365 63.2297 30.9645C64.3261 31.4112 65.3628 31.8173 65.3628 32.9543C65.3628 34.0914 64.2663 34.599 63.3293 34.599C62.4123 34.599 61.6747 34.1929 61.0966 33.5635L60.2792 34.4365C61.0766 35.3299 62.193 35.7766 63.2895 35.7766C64.9242 35.7766 66.7184 34.7208 66.7184 32.9746C66.7184 31.2081 65.5422 30.5178 64.3461 30.0102C63.1101 29.4822 61.8541 29.0964 61.8541 27.9188C61.8541 26.9848 62.811 26.5584 63.5686 26.5584C64.2862 26.5584 65.0039 26.8426 65.5422 27.269L66.2798 26.335Z" fill="#00326E"/>' +
    '<path d="M75.0211 26.335C74.2635 25.7056 73.3664 25.3807 72.3497 25.3807C70.715 25.3807 69.3195 26.335 69.3195 28.0406C69.3195 29.8477 70.695 30.4365 71.9709 30.9645C73.0674 31.4112 74.104 31.8173 74.104 32.9543C74.104 34.0914 73.0076 34.599 72.0706 34.599C71.1536 34.599 70.416 34.1929 69.8378 33.5635L69.0205 34.4365C69.8179 35.3299 70.9343 35.7766 72.0307 35.7766C73.6654 35.7766 75.4596 34.7208 75.4596 32.9746C75.4596 31.2081 74.2834 30.5178 73.0873 30.0102C71.8513 29.4822 70.5954 29.0964 70.5954 27.9188C70.5954 26.9848 71.5523 26.5584 72.3098 26.5584C73.0275 26.5584 73.7452 26.8426 74.2834 27.269L75.0211 26.335Z" fill="#00326E"/>' +
    '<path d="M85.1777 35.533V21.3198H83.7025V35.533H85.1777Z" fill="#00326E"/>' +
    '<path d="M89.0507 25.6244V35.533H90.4063V28.9543C91.0442 27.6954 92.2204 26.6396 93.6757 26.6396C95.8487 26.6396 96.1876 28.5279 96.1876 30.3959V35.533H97.5432V30.1726C97.5432 27.1878 96.6461 25.3807 93.8751 25.3807C92.3799 25.3807 91.1838 26.0508 90.4063 27.3706V25.6244H89.0507Z" fill="#00326E"/>' +
    '<path d="M105.409 26.8832V25.6244H102.579V23.1472H101.223V25.6244H99.8475V26.8832H101.223V32.5076C101.223 34.5584 102.16 35.7157 104.054 35.7157C104.632 35.7157 105.17 35.533 105.609 35.2893L105.27 34.1929C104.831 34.3553 104.433 34.4569 104.074 34.4569C103.177 34.4569 102.579 34.132 102.579 32.3452V26.8832H105.409Z" fill="#00326E"/>' +
    '<path d="M115.874 30.9239C115.894 30.7411 115.934 30.335 115.934 30.0102C115.934 27.5533 114.12 25.3807 111.608 25.3807C108.956 25.3807 106.843 27.5939 106.843 30.5178C106.843 33.4213 108.577 35.7766 111.767 35.7766C113.242 35.7766 114.937 35.0051 115.714 33.5228L114.758 32.8934C114.06 34.2335 112.963 34.599 111.668 34.599C109.554 34.599 108.318 32.8325 108.199 30.9239H115.874ZM114.598 29.7462H108.239C108.518 27.8985 109.734 26.5584 111.608 26.5584C113.262 26.5584 114.518 28.0812 114.598 29.7462Z" fill="#00326E"/>' +
    '<path d="M120.018 21.3198H118.662V35.533H120.018V21.3198Z" fill="#00326E"/>' +
    '<path d="M125.001 21.3198H123.646V35.533H125.001V21.3198Z" fill="#00326E"/>' +
    '<path d="M129.985 35.533V25.6244H128.63V35.533H129.985ZM129.985 23.4112V21.5025H128.63V23.4112H129.985Z" fill="#00326E"/>' +
    '<path d="M142.186 25.6244H140.83V26.599C139.993 25.8071 138.817 25.3807 137.72 25.3807C134.869 25.3807 132.716 27.797 132.716 30.4975C132.716 33.198 134.85 35.533 137.7 35.533C138.896 35.533 140.093 35.0051 140.83 34.0102V35.3909C140.83 37.8274 139.096 38.7411 137.262 38.7411C135.866 38.7411 134.431 38.132 133.574 37.4416L133.015 38.599C134.232 39.4315 135.787 40 137.282 40C139.873 40 142.186 38.4569 142.186 34.9645V25.6244ZM140.83 32.4061C140.272 33.5634 138.936 34.2741 137.74 34.2741C135.607 34.2741 134.112 32.4264 134.112 30.4162C134.112 28.4264 135.627 26.6396 137.74 26.6396C138.857 26.6396 140.113 27.2487 140.83 28.203V32.4061Z" fill="#00326E"/>' +
    '<path d="M153.818 30.9239C153.837 30.7411 153.877 30.335 153.877 30.0102C153.877 27.5533 152.063 25.3807 149.551 25.3807C146.9 25.3807 144.787 27.5939 144.787 30.5178C144.787 33.4213 146.521 35.7766 149.711 35.7766C151.186 35.7766 152.881 35.0051 153.658 33.5228L152.701 32.8934C152.003 34.2335 150.907 34.599 149.611 34.599C147.498 34.599 146.262 32.8325 146.142 30.9239H153.818ZM152.542 29.7462H146.182C146.461 27.8985 147.677 26.5584 149.551 26.5584C151.206 26.5584 152.462 28.0812 152.542 29.7462Z" fill="#00326E"/>' +
    '<path d="M156.606 25.6244V35.533H157.961V28.9543C158.599 27.6954 159.775 26.6396 161.231 26.6396C163.404 26.6396 163.742 28.5279 163.742 30.3959V35.533H165.098V30.1726C165.098 27.1878 164.201 25.3807 161.43 25.3807C159.935 25.3807 158.739 26.0508 157.961 27.3706V25.6244H156.606Z" fill="#00326E"/>' +
    '<path d="M174.778 33.868C174.3 34.2335 173.343 34.5178 172.725 34.5178C170.472 34.5178 169.077 32.8122 169.077 30.5787C169.077 28.4467 170.472 26.6396 172.685 26.6396C173.343 26.6396 174.18 26.8426 174.719 27.2081L175.217 26.0508C174.519 25.6447 173.682 25.3807 172.785 25.3807C169.815 25.3807 167.681 27.6751 167.681 30.5787C167.681 33.5431 169.795 35.7766 172.825 35.7766C173.842 35.7766 174.679 35.4721 175.476 34.9239L174.778 33.868Z" fill="#00326E"/>' +
    '<path d="M185.94 30.9239C185.96 30.7411 186 30.335 186 30.0102C186 27.5533 184.186 25.3807 181.674 25.3807C179.023 25.3807 176.909 27.5939 176.909 30.5178C176.909 33.4213 178.644 35.7766 181.833 35.7766C183.309 35.7766 185.003 35.0051 185.781 33.5228L184.824 32.8934C184.126 34.2335 183.03 34.599 181.734 34.599C179.621 34.599 178.385 32.8325 178.265 30.9239H185.94ZM184.664 29.7462H178.305C178.584 27.8985 179.8 26.5584 181.674 26.5584C183.329 26.5584 184.585 28.0812 184.664 29.7462Z" fill="#00326E"/>' +
    '</svg>';
const MyProfile = '<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.67567 4.41922C8.633 5.85605 7.45482 7.00772 6.00766 7.00772C4.55413 7.00772 3.37196 5.8459 3.33915 4.40025C3.33869 4.37973 3.33846 4.35915 3.33846 4.33852C3.33846 2.86436 4.5335 1.66932 6.00766 1.66932C7.48182 1.66932 8.67686 2.86436 8.67686 4.33852C8.67686 4.36551 8.67646 4.39242 8.67567 4.41922ZM9.65199 8.23942C9.40573 8.05115 9.14448 7.8815 8.87033 7.73258C8.72973 7.6562 8.58575 7.58528 8.43865 7.52008C8.80986 7.23602 9.12991 6.88845 9.38257 6.49361C9.78067 5.87146 10.0115 5.13194 10.0115 4.33852C10.0115 2.12728 8.2189 0.334717 6.00766 0.334717C3.79642 0.334717 2.00385 2.12728 2.00385 4.33852C2.00385 5.13194 2.23464 5.87146 2.63275 6.49361C2.85874 6.84678 3.13865 7.16213 3.46087 7.42805C3.49888 7.45942 3.53749 7.49011 3.57666 7.52008C3.14275 7.71239 2.73588 7.9546 2.36332 8.23942C0.927895 9.33685 0.00195312 11.067 0.00195312 13.0134C0.00195312 13.382 0.300714 13.6807 0.669254 13.6807C1.03779 13.6807 1.33655 13.382 1.33655 13.0134C1.33655 12.7753 1.35437 12.5414 1.38875 12.3128C1.72681 10.0654 3.66601 8.34232 6.00766 8.34232C8.21531 8.34232 10.0653 9.87382 10.553 11.9323C10.6353 12.2794 10.6788 12.6414 10.6788 13.0134C10.6788 13.382 10.9775 13.6807 11.3461 13.6807C11.7146 13.6807 12.0134 13.382 12.0134 13.0134C12.0134 11.067 11.0874 9.33685 9.65199 8.23942Z" fill="#B0C1CC"/>' +
    '</svg>';
const SignOut = '<svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2.66663 0.333252C1.56206 0.333252 0.666626 1.22868 0.666626 2.33325L0.666626 4.33325C0.666626 4.70144 0.965103 4.99992 1.33329 4.99992C1.70148 4.99992 1.99996 4.70144 1.99996 4.33325L1.99996 2.33325C1.99996 1.96506 2.29844 1.66659 2.66663 1.66659L9.33329 1.66659C9.70148 1.66659 9.99996 1.96506 9.99996 2.33325L9.99996 11.6666C9.99996 12.0348 9.70148 12.3333 9.33329 12.3333L2.66663 12.3333C2.29844 12.3333 1.99996 12.0348 1.99996 11.6666L1.99996 9.66659C1.99996 9.2984 1.70148 8.99992 1.33329 8.99992C0.965103 8.99992 0.666626 9.2984 0.666626 9.66659L0.666626 11.6666C0.666626 12.7712 1.56206 13.6666 2.66663 13.6666L9.33329 13.6666C10.4379 13.6666 11.3333 12.7712 11.3333 11.6666L11.3333 2.33325C11.3333 1.22868 10.4379 0.333252 9.33329 0.333252L2.66663 0.333252Z" fill="#B0C1CC"/>' +
    '<path d="M0.861889 7.47132C0.736864 7.3463 0.666626 7.17673 0.666626 6.99992C0.666626 6.82311 0.736864 6.65354 0.861889 6.52852C0.986913 6.40349 1.15648 6.33325 1.33329 6.33325L6.39329 6.33325L4.85996 4.80659C4.7978 4.74443 4.74849 4.67063 4.71485 4.58942C4.68121 4.50821 4.6639 4.42116 4.6639 4.33325C4.6639 4.24535 4.68121 4.1583 4.71485 4.07709C4.74849 3.99587 4.7978 3.92208 4.85996 3.85992C4.92212 3.79776 4.99591 3.74845 5.07713 3.71481C5.15834 3.68117 5.24539 3.66386 5.33329 3.66386C5.4212 3.66386 5.50824 3.68117 5.58946 3.71481C5.67067 3.74845 5.74447 3.79776 5.80663 3.85992L8.47329 6.52659C8.53399 6.58999 8.58156 6.66475 8.61329 6.74659C8.67997 6.90889 8.67997 7.09095 8.61329 7.25325C8.58156 7.33509 8.53399 7.40985 8.47329 7.47325L5.80663 10.1399C5.74465 10.2024 5.67092 10.252 5.58968 10.2858C5.50844 10.3197 5.4213 10.3371 5.33329 10.3371C5.24529 10.3371 5.15815 10.3197 5.07691 10.2858C4.99567 10.252 4.92194 10.2024 4.85996 10.1399C4.79747 10.0779 4.74788 10.0042 4.71403 9.92297C4.68019 9.84173 4.66276 9.75459 4.66276 9.66659C4.66276 9.57858 4.68019 9.49144 4.71403 9.4102C4.74788 9.32896 4.79747 9.25523 4.85996 9.19325L6.39329 7.66659L1.33329 7.66659C1.15648 7.66659 0.986913 7.59635 0.861889 7.47132Z" fill="#B0C1CC"/>' +
    '</svg>';
const MenuToggleIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-menu-close"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M8.293 5.293a1 1 0 011.414 1.414L4.414 12l5.293 5.293a1 1 0 01-1.414 1.414l-6-6a1 1 0 010-1.414l6-6zM13 5a1 1 0 100 2h8a1 1 0 100-2h-8zm8 6h-8a1 1 0 100 2h8a1 1 0 100-2zm-9 7a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1z"/></svg>';
const RightFindEnterprise = '<svg width="89" height="40" viewBox="0 0 89 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0 1V15H2.46421V9.28H3.3386L7.31312 15H10.3735L6.06115 9.04C7.6907 8.58 9.24077 7.38 9.24077 5.12C9.24077 2.14 6.49835 1 4.29249 1H0ZM3.83542 7.16H2.46421V3.12H4.23287C5.6637 3.12 6.63746 3.94 6.63746 5.18C6.63746 6.58 5.4451 7.16 3.83542 7.16Z" fill="#00326E"/>' +
    '<path d="M12.2217 4.7V15H14.6262V4.7H12.2217ZM12.2217 0.760001V3.02H14.6262V0.760001H12.2217Z" fill="#00326E"/>' +
    '<path d="M22.108 19.52C24.0158 19.52 25.7645 18.86 26.6787 17.18C27.0761 16.46 27.2947 15.56 27.2947 14.46V4.7H25.0889L24.9696 5.88C24.1946 4.9 22.9029 4.46 21.8099 4.46C18.8687 4.46 16.8616 6.9 16.8616 9.7C16.8616 12.68 18.9681 15 21.7503 15C22.8433 15 24.135 14.58 24.8703 13.56V14.72C24.8703 16.6 23.6183 17.4 22.0484 17.4C20.9156 17.4 19.445 16.94 18.3719 16.12L17.4777 18.12C18.829 19.06 20.538 19.52 22.108 19.52ZM22.2073 12.88C20.4387 12.88 19.3059 11.42 19.3059 9.76C19.3059 8.2 20.2598 6.58 22.267 6.58C23.201 6.58 24.1747 6.98 24.8703 7.88V11.3C24.294 12.4 23.1811 12.88 22.2073 12.88Z" fill="#00326E"/>' +
    '<path d="M30.1536 0V15H32.5582V8.16C33.1544 7.2 34.148 6.58 35.1019 6.58C35.8372 6.58 36.3539 6.84 36.6519 7.36C37.0295 8 37.0494 8.96 37.0494 9.82V15H39.454V9.64C39.454 8.14 39.295 6.78 38.5398 5.78C37.9039 4.96 36.95 4.46 35.7179 4.46C34.5256 4.46 33.3531 5 32.5582 6.1V0H30.1536Z" fill="#00326E"/>' +
    '<path d="M45.5803 15.22C46.3355 15.22 47.2099 15.02 47.8061 14.68L47.0907 12.84C46.7528 13.02 46.3951 13.12 45.9579 13.12C45.2226 13.12 44.9643 12.72 44.8649 11.92C44.8252 11.6 44.8252 11.3 44.8252 11V6.74H47.5279V4.7H44.8252V2.34H42.6591L42.4007 4.7H41.1289V6.74H42.4007V11.36C42.4007 12.04 42.4603 12.72 42.6591 13.26C43.0764 14.44 44.0501 15.22 45.5803 15.22Z" fill="#00326E"/>' +
    '<path d="M49.9338 1V15H52.398V9.2H57.3662V7.08H52.398V3.12H57.3662V1H49.9338Z" fill="#00326E"/>' +
    '<path d="M59.6714 4.7V15H62.076V4.7H59.6714ZM59.6714 0.760001V3.02H62.076V0.760001H59.6714Z" fill="#00326E"/>' +
    '<path d="M65.0665 4.7V15H67.4711V8.16C68.0673 7.2 69.0609 6.58 70.0148 6.58C70.7501 6.58 71.2668 6.84 71.5649 7.36C71.9425 8 71.9623 8.96 71.9623 9.82V15H74.3669V9.64C74.3669 8.14 74.2079 6.8 73.4528 5.78C72.8367 4.94 71.863 4.46 70.6309 4.46C69.3988 4.46 68.1865 5.04 67.3718 6.22L67.2525 4.7H65.0665Z" fill="#00326E"/>' +
    '<path d="M81.4074 15.24C82.5402 15.24 83.8716 14.8 84.6069 13.68L84.7262 15H86.932V0H84.5075V5.76C83.7126 4.88 82.5004 4.46 81.4472 4.46C78.506 4.46 76.4989 7 76.4989 9.82C76.4989 12.82 78.5855 15.24 81.4074 15.24ZM81.8645 13.12C80.0561 13.12 78.9432 11.56 78.9432 9.88C78.9432 8.3 79.8971 6.58 81.9042 6.58C82.8382 6.58 83.812 6.98 84.5075 7.88V11.52C83.9312 12.64 82.8184 13.12 81.8645 13.12Z" fill="#00326E"/>' +
    '<path d="M8.44586 35V33.64H1.82828V28.44H8.44586V27.08H1.82828V22.36H8.44586V21H0.357707V35H8.44586Z" fill="#00326E"/>' +
    '<path d="M11.6469 25.24V35H12.9982V28.52C13.6342 27.28 14.8067 26.24 16.2574 26.24C18.4235 26.24 18.7613 28.1 18.7613 29.94V35H20.1126V29.72C20.1126 26.78 19.2184 25 16.4561 25C14.9656 25 13.7733 25.66 12.9982 26.96V25.24H11.6469Z" fill="#00326E"/>' +
    '<path d="M27.9541 26.48V25.24H25.1322V22.8H23.7808V25.24H22.4096V26.48H23.7808V32.02C23.7808 34.04 24.7149 35.18 26.6028 35.18C27.1791 35.18 27.7156 35 28.1528 34.76L27.815 33.68C27.3778 33.84 26.9803 33.94 26.6226 33.94C25.7284 33.94 25.1322 33.62 25.1322 31.86V26.48H27.9541Z" fill="#00326E"/>' +
    '<path d="M38.3855 30.46C38.4054 30.28 38.4451 29.88 38.4451 29.56C38.4451 27.14 36.6367 25 34.1328 25C31.4897 25 29.3832 27.18 29.3832 30.06C29.3832 32.92 31.1121 35.24 34.2918 35.24C35.7623 35.24 37.4515 34.48 38.2265 33.02L37.2727 32.4C36.5771 33.72 35.4841 34.08 34.1924 34.08C32.0859 34.08 30.8538 32.34 30.7346 30.46H38.3855ZM37.1137 29.3H30.7743C31.0525 27.48 32.2648 26.16 34.1328 26.16C35.7822 26.16 37.0342 27.66 37.1137 29.3Z" fill="#00326E"/>' +
    '<path d="M42.5161 25.24H41.1647V35H42.5161V28.48C43.2116 27.24 43.9469 26.4 45.0598 26.4C45.4374 26.4 45.6758 26.44 45.9739 26.58L46.1528 25.08C45.8745 25.02 45.5963 25 45.338 25C43.9866 25 43.0526 26 42.5161 27.08V25.24Z" fill="#00326E"/>' +
    '<path d="M48.0736 25.24V40H49.4249V34.04C50.2596 34.82 51.432 35.24 52.525 35.24C55.3668 35.24 57.5131 32.86 57.5131 30.08C57.5131 27.3 55.3867 25 52.5449 25C51.3526 25 50.1602 25.52 49.4249 26.5V25.24H48.0736ZM49.4249 28.08C49.9813 26.94 51.3128 26.24 52.5052 26.24C54.6315 26.24 56.122 28.06 56.122 30.16C56.122 32.24 54.6117 34 52.5052 34C51.3923 34 50.1403 33.4 49.4249 32.46V28.08Z" fill="#00326E"/>' +
    '<path d="M61.593 25.24H60.2417V35H61.593V28.48C62.2886 27.24 63.0238 26.4 64.1367 26.4C64.5143 26.4 64.7528 26.44 65.0509 26.58L65.2297 25.08C64.9515 25.02 64.6733 25 64.4149 25C63.0636 25 62.1296 26 61.593 27.08V25.24Z" fill="#00326E"/>' +
    '<path d="M68.5019 35V25.24H67.1505V35H68.5019ZM68.5019 23.06V21.18H67.1505V23.06H68.5019Z" fill="#00326E"/>' +
    '<path d="M77.3849 25.94C76.6298 25.32 75.7355 25 74.722 25C73.0924 25 71.7013 25.94 71.7013 27.62C71.7013 29.4 73.0726 29.98 74.3444 30.5C75.4374 30.94 76.4708 31.34 76.4708 32.46C76.4708 33.58 75.3778 34.08 74.4438 34.08C73.5296 34.08 72.7943 33.68 72.218 33.06L71.4033 33.92C72.1982 34.8 73.311 35.24 74.404 35.24C76.0336 35.24 77.8221 34.2 77.8221 32.48C77.8221 30.74 76.6496 30.06 75.4573 29.56C74.2252 29.04 72.9732 28.66 72.9732 27.5C72.9732 26.58 73.9271 26.16 74.6822 26.16C75.3977 26.16 76.1131 26.44 76.6496 26.86L77.3849 25.94Z" fill="#00326E"/>' +
    '<path d="M88.9404 30.46C88.9603 30.28 89 29.88 89 29.56C89 27.14 87.1916 25 84.6876 25C82.0446 25 79.9381 27.18 79.9381 30.06C79.9381 32.92 81.667 35.24 84.8466 35.24C86.3172 35.24 88.0064 34.48 88.7814 33.02L87.8275 32.4C87.132 33.72 86.039 34.08 84.7473 34.08C82.6408 34.08 81.4087 32.34 81.2894 30.46H88.9404ZM87.6685 29.3H81.3292C81.6074 27.48 82.8196 26.16 84.6876 26.16C86.3371 26.16 87.589 27.66 87.6685 29.3Z" fill="#00326E"/>' +
    '</svg>';
const RightFindNavigate = '<svg width="88" height="40" viewBox="0 0 88 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M0 0.990099V14.8515H2.49448V9.18812H3.37962L7.40297 14.8515H10.501L6.13561 8.9505C7.78519 8.49505 9.35429 7.30693 9.35429 5.06931C9.35429 2.11881 6.57818 0.990099 4.34522 0.990099H0ZM3.88254 7.08911H2.49448V3.08911H4.28487C5.73328 3.08911 6.719 3.90099 6.719 5.12871C6.719 6.51485 5.51199 7.08911 3.88254 7.08911Z" fill="#00326E"/>' +
    '<path d="M12.3718 4.65346V14.8515H14.8059V4.65346H12.3718ZM12.3718 0.752476V2.9901H14.8059V0.752476H12.3718Z" fill="#00326E"/>' +
    '<path d="M22.3796 19.3267C24.3108 19.3267 26.0811 18.6733 27.0064 17.0099C27.4088 16.297 27.6301 15.4059 27.6301 14.3168V4.65346H25.3971L25.2764 5.82178C24.4918 4.85149 23.1843 4.41584 22.0778 4.41584C19.1006 4.41584 17.0688 6.83168 17.0688 9.60396C17.0688 12.5545 19.2011 14.8515 22.0175 14.8515C23.1239 14.8515 24.4315 14.4356 25.1758 13.4257V14.5743C25.1758 16.4356 23.9085 17.2277 22.3192 17.2277C21.1726 17.2277 19.6839 16.7723 18.5976 15.9604L17.6924 17.9406C19.0603 18.8713 20.7904 19.3267 22.3796 19.3267ZM22.4802 12.7525C20.6898 12.7525 19.5431 11.3069 19.5431 9.66337C19.5431 8.11881 20.5087 6.51485 22.5405 6.51485C23.486 6.51485 24.4717 6.91089 25.1758 7.80198V11.1881C24.5924 12.2772 23.4659 12.7525 22.4802 12.7525Z" fill="#00326E"/>' +
    '<path d="M30.524 0V14.8515H32.9582V8.07921C33.5617 7.12871 34.5675 6.51485 35.5331 6.51485C36.2774 6.51485 36.8005 6.77228 37.1022 7.28713C37.4844 7.92079 37.5046 8.87129 37.5046 9.72277V14.8515H39.9387V9.54455C39.9387 8.05941 39.7778 6.71287 39.0133 5.72277C38.3696 4.91089 37.404 4.41584 36.1567 4.41584C34.9497 4.41584 33.7628 4.9505 32.9582 6.0396V0H30.524Z" fill="#00326E"/>' +
    '<path d="M46.1403 15.0693C46.9047 15.0693 47.7899 14.8713 48.3934 14.5347L47.6692 12.7129C47.3272 12.8911 46.9651 12.9901 46.5225 12.9901C45.7782 12.9901 45.5167 12.5941 45.4161 11.802C45.3759 11.4851 45.3759 11.1881 45.3759 10.8911V6.67327H48.1118V4.65346H45.3759V2.31683H43.1831L42.9216 4.65346H41.6342V6.67327H42.9216V11.2475C42.9216 11.9208 42.982 12.5941 43.1831 13.1287C43.6056 14.297 44.5913 15.0693 46.1403 15.0693Z" fill="#00326E"/>' +
    '<path d="M50.5473 0.990099V14.8515H53.0418V9.10891H58.071V7.0099H53.0418V3.08911H58.071V0.990099H50.5473Z" fill="#00326E"/>' +
    '<path d="M60.4045 4.65346V14.8515H62.8386V4.65346H60.4045ZM60.4045 0.752476V2.9901H62.8386V0.752476H60.4045Z" fill="#00326E"/>' +
    '<path d="M65.8659 4.65346V14.8515H68.3V8.07921C68.9035 7.12871 69.9094 6.51485 70.875 6.51485C71.6193 6.51485 72.1423 6.77228 72.4441 7.28713C72.8263 7.92079 72.8464 8.87129 72.8464 9.72277V14.8515H75.2805V9.54455C75.2805 8.05941 75.1196 6.73267 74.3552 5.72277C73.7316 4.89109 72.7458 4.41584 71.4986 4.41584C70.2514 4.41584 69.0242 4.9901 68.1994 6.15842L68.0787 4.65346H65.8659Z" fill="#00326E"/>' +
    '<path d="M82.4075 15.0891C83.5542 15.0891 84.902 14.6535 85.6463 13.5446L85.767 14.8515H88V0H85.5458V5.70297C84.7411 4.83168 83.514 4.41584 82.4478 4.41584C79.4705 4.41584 77.4387 6.93069 77.4387 9.72277C77.4387 12.6931 79.551 15.0891 82.4075 15.0891ZM82.8702 12.9901C81.0396 12.9901 79.9131 11.4455 79.9131 9.78218C79.9131 8.21782 80.8787 6.51485 82.9105 6.51485C83.8559 6.51485 84.8417 6.91089 85.5458 7.80198V11.4059C84.9624 12.5149 83.8358 12.9901 82.8702 12.9901Z" fill="#00326E"/>' +
    '<path d="M11.2855 35.6436V21.7822H9.87733V32.9307L1.46852 21.7822H0.362102V35.6436H1.77028V24.5149L10.159 35.6436H11.2855Z" fill="#00326E"/>' +
    '<path d="M21.1834 35.6436H22.4105V29.7426C22.4105 27.2475 21.5053 25.7426 18.5884 25.7426C17.3009 25.7426 15.772 26.1782 14.8668 26.5941L15.3294 27.802C16.0939 27.3861 17.3814 26.9703 18.528 26.9703C20.2379 26.9703 21.0426 27.8614 21.0426 29.4653V30C20.1575 29.7822 19.4735 29.703 18.8096 29.703C16.7175 29.703 14.4644 30.6337 14.4644 33.0099C14.4644 34.8317 16.0536 35.8812 17.8642 35.8812C18.9907 35.8812 20.1374 35.5247 21.0828 34.5149L21.1834 35.6436ZM21.0426 31.0891V33.3267C20.1172 34.198 19.0309 34.7723 17.9044 34.7723C16.7577 34.7723 15.8324 34.0198 15.8324 32.8515C15.8324 31.3465 17.4015 30.8119 18.7493 30.8119C19.4534 30.8119 20.1977 30.8911 21.0426 31.0891Z" fill="#00326E"/>' +
    '<path d="M27.8055 35.6436H29.4953L33.1565 25.9802H31.688L28.7308 34.1584L25.9547 25.9802H24.4661L27.8055 35.6436Z" fill="#00326E"/>' +
    '<path d="M36.5947 35.6436V25.9802H35.2268V35.6436H36.5947ZM36.5947 23.8218V21.9604H35.2268V23.8218H36.5947Z" fill="#00326E"/>' +
    '<path d="M48.9062 25.9802H47.5383V26.9307C46.6934 26.1584 45.5065 25.7426 44.4001 25.7426C41.5234 25.7426 39.3507 28.099 39.3507 30.7327C39.3507 33.3663 41.5032 35.6436 44.3799 35.6436C45.5869 35.6436 46.7939 35.1287 47.5383 34.1584V35.5049C47.5383 37.8812 45.7881 38.7723 43.9374 38.7723C42.5292 38.7723 41.0808 38.1782 40.2158 37.5049L39.6525 38.6337C40.8796 39.4455 42.4487 40 43.9575 40C46.5727 40 48.9062 38.495 48.9062 35.0891V25.9802ZM47.5383 32.5941C46.975 33.7228 45.6272 34.4158 44.4202 34.4158C42.2677 34.4158 40.7589 32.6139 40.7589 30.6535C40.7589 28.7129 42.2878 26.9703 44.4202 26.9703C45.5467 26.9703 46.8141 27.5644 47.5383 28.495V32.5941Z" fill="#00326E"/>' +
    '<path d="M58.4309 35.6436H59.658V29.7426C59.658 27.2475 58.7527 25.7426 55.8358 25.7426C54.5483 25.7426 53.0195 26.1782 52.1142 26.5941L52.5769 27.802C53.3413 27.3861 54.6288 26.9703 55.7755 26.9703C57.4854 26.9703 58.29 27.8614 58.29 29.4653V30C57.4049 29.7822 56.7209 29.703 56.0571 29.703C53.9649 29.703 51.7119 30.6337 51.7119 33.0099C51.7119 34.8317 53.3011 35.8812 55.1116 35.8812C56.2381 35.8812 57.3848 35.5247 58.3303 34.5149L58.4309 35.6436ZM58.29 31.0891V33.3267C57.3647 34.198 56.2784 34.7723 55.1518 34.7723C54.0052 34.7723 53.0798 34.0198 53.0798 32.8515C53.0798 31.3465 54.6489 30.8119 55.9967 30.8119C56.7008 30.8119 57.4451 30.8911 58.29 31.0891Z" fill="#00326E"/>' +
    '<path d="M67.6077 27.2079V25.9802H64.7511V23.5644H63.3832V25.9802H61.9951V27.2079H63.3832V32.6931C63.3832 34.6931 64.3287 35.8218 66.2398 35.8218C66.8232 35.8218 67.3663 35.6436 67.8089 35.4059L67.4669 34.3366C67.0243 34.495 66.622 34.5941 66.2599 34.5941C65.3547 34.5941 64.7511 34.2772 64.7511 32.5347V27.2079H67.6077Z" fill="#00326E"/>' +
    '<path d="M78.1673 31.1485C78.1874 30.9703 78.2277 30.5743 78.2277 30.2574C78.2277 27.8614 76.397 25.7426 73.8623 25.7426C71.1868 25.7426 69.0544 27.901 69.0544 30.7525C69.0544 33.5842 70.8046 35.8812 74.0232 35.8812C75.5119 35.8812 77.2218 35.1287 78.0064 33.6832L77.0408 33.0693C76.3367 34.3762 75.2303 34.7327 73.9227 34.7327C71.7903 34.7327 70.543 33.0099 70.4223 31.1485H78.1673ZM76.8798 30H70.4626C70.7442 28.198 71.9713 26.8911 73.8623 26.8911C75.532 26.8911 76.7994 28.3762 76.8798 30Z" fill="#00326E"/>' +
    '</svg>';
const SimpleFooterLogo = '<svg class="ccc" fill="none" xmlns="http://www.w3.org/2000/svg" width="56" viewBox="0 0 276 96" shape-rendering="geometricprecision" style="-webkit-font-smoothing: none;" role="img"><path d="M47 23c-13.9 0-23 11.522-23 25 0 13.264 9 25 23 25C37 77 19.054 67.274.5 49c-.338-.333-.5-.5-.5-1C0 22.1 19 0 47 0c.5 0 .657.266 1 .5C57.025 6.654 72.506 19.212 68.5 37c-.075.332 0 .5-.5 1-2.729-9.37-11.23-15-21-15z" fill="url(#ccc_logo_0_linear)"></path><path d="M47 73c9.576 0 18.285-5.598 21-15 .5.5.49.668.5 1 .388 11.8 2 37-21.5 37C19 96 0 74.486 0 48c20 19 35 25 47 25z" fill="url(#ccc_logo_1_linear)"></path><path d="M68 58l22 7c-4.851 18.778-20 31-43 31 12-5 21-18 21-38z" fill="url(#ccc_logo_2_linear)"></path><path d="M47 0c20 0 38.002 11.75 43 31l-22 7C72 19 55 6 47 0z" fill="url(#ccc_logo_3_linear)"></path><path d="M140 23c-13.901 0-23 11.522-23 25 0 13.264 8 25 23 25-10 4-27.438-5.214-46-23.5-.332-.328-1-1-1-1.5 0-25.9 19-48 47-48 1 0 1.588.718 2 1 9.048 6.198 23.506 18.354 19.5 36-.075.331 0 .5-.5 1-2.729-9.37-11.229-15-21-15z" fill="url(#ccc_logo_4_linear)"></path><path d="M140 73c9.576 0 18.285-5.598 21-15 .5.5.489.668.5 1 .354 11.067 1.5 37-21.5 37-28 0-47-21.514-47-48 20 19 35 25 47 25z" fill="url(#ccc_logo_5_linear)"></path><path d="M161 58l22 7c-4.851 18.778-21.5 31-43 31 12-5 21-18 21-38z" fill="url(#ccc_logo_6_linear)"></path><path d="M140 0c20 0 38.002 11.75 43 31l-22 7c4-19-13-32-21-38z" fill="url(#ccc_logo_7_linear)"></path><path d="M233 23c-13.901 0-23 11.522-23 25 0 13.264 8 25 23 25-10 4-27.438-5.214-46-23.5-.332-.328-1-1-1-1.5 0-25.9 19-48 47-48 1 0 1.588.718 2 1 9.048 6.198 23.506 18.354 19.5 36-.075.331 0 .5-.5 1-2.729-9.37-11.229-15-21-15z" fill="url(#ccc_logo_8_linear)"></path><path d="M233 73c9.576 0 18.285-5.598 21-15 .5.5.489.668.5 1 .354 11.067 1.5 37-21.5 37-28 0-47-21.514-47-48 20 19 35 25 47 25z" fill="url(#ccc_logo_9_linear)"></path><path d="M254 58l22 7c-4.851 18.778-21.5 31-43 31 12-5 21-18 21-38z" fill="url(#ccc_logo_10_linear)"></path><path d="M233 0c20 0 38.002 11.75 43 31l-22 7c4-19-13-32-21-38z" fill="url(#ccc_logo_11_linear)"></path><defs><linearGradient id="ccc_logo_0_linear" x1="45.031" y1="0.255" x2="45.031" y2="96.146" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B"></stop><stop offset="1" stop-color="#E48E0A"></stop></linearGradient><linearGradient id="ccc_logo_1_linear" x1="90.429" y1="71.993" x2="-0.066" y2="71.993" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B"></stop><stop offset="1" stop-color="#D8740A"></stop></linearGradient><linearGradient id="ccc_logo_2_linear" x1="68.49" y1="95.634" x2="68.49" y2="58.084" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#D1640A"></stop><stop offset="1" stop-color="#E28A0A"></stop></linearGradient><linearGradient id="ccc_logo_3_linear" x1="68.503" y1="0.114" x2="68.503" y2="32.96" gradientUnits="userSpaceOnUse"><stop stop-color="#F4B20B"></stop><stop offset="1" stop-color="#D1650A"></stop></linearGradient><linearGradient id="ccc_logo_4_linear" x1="139.5" y1="0" x2="139.5" y2="95.5" gradientUnits="userSpaceOnUse"><stop stop-color="#00A9E7"></stop><stop offset="1" stop-color="#005FB4"></stop></linearGradient><linearGradient id="ccc_logo_5_linear" x1="182" y1="72" x2="93" y2="72" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00A6E4"></stop><stop offset="1" stop-color="#00538F"></stop></linearGradient><linearGradient id="ccc_logo_6_linear" x1="161.49" y1="95.571" x2="161.49" y2="58.16" gradientUnits="userSpaceOnUse"><stop stop-color="#003D7F"></stop><stop offset="1" stop-color="#005CAF"></stop></linearGradient><linearGradient id="ccc_logo_7_linear" x1="161.503" y1="-0.035" x2="161.503" y2="33.119" gradientUnits="userSpaceOnUse"><stop stop-color="#00A9E7"></stop><stop offset="1" stop-color="#005593"></stop></linearGradient><linearGradient id="ccc_logo_8_linear" x1="232.5" y1="0" x2="232.5" y2="95.5" gradientUnits="userSpaceOnUse"><stop stop-color="#00A9E7"></stop><stop offset="1" stop-color="#005FB4"></stop></linearGradient><linearGradient id="ccc_logo_9_linear" x1="275" y1="72" x2="186" y2="72" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#00A6E4"></stop><stop offset="1" stop-color="#00538F"></stop></linearGradient><linearGradient id="ccc_logo_10_linear" x1="254.49" y1="95.571" x2="254.49" y2="58.16" gradientUnits="userSpaceOnUse"><stop stop-color="#003D7F"></stop><stop offset="1" stop-color="#005CAF"></stop></linearGradient><linearGradient id="ccc_logo_11_linear" x1="254.503" y1="-0.035" x2="254.503" y2="33.119" gradientUnits="userSpaceOnUse"><stop stop-color="#00A9E7"></stop><stop offset="1" stop-color="#005593"></stop></linearGradient></defs></svg>';
const ModalCloseIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-clear"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"/></svg>';
const InfoIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-info"><path class="primary" d="M12 11a1 1 0 011 1v4a1 1 0 11-2 0v-4a1 1 0 011-1zM12 9a1 1 0 100-2 1 1 0 000 2z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"/></svg>';
const SortIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-sort"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M13.617 2.076a1 1 0 011.09.217l4 4a1 1 0 01-1.414 1.414L15 5.414V17a1 1 0 11-2 0V3a1 1 0 01.617-.924zM10 6a1 1 0 011 1v14a1 1 0 01-1.707.707l-4-4a1 1 0 111.414-1.414L9 18.586V7a1 1 0 011-1z"/></svg>';
const ClearFilterIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-filter-clear"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M6 7a1 1 0 00-1 1v1h14V8a1 1 0 00-1-1H6zm11.586 4l-.293.293a1 1 0 001.414 1.414l2-2A1 1 0 0021 10V8a3 3 0 00-3-3H6a3 3 0 00-3 3v2a1 1 0 00.293.707L9 16.414V20a1 1 0 001.447.894l2-1a1 1 0 10-.894-1.788l-.553.276V16a1 1 0 00-.293-.707L6.414 11h11.172zm-2.293 4.293a1 1 0 011.414 0L18 16.586l1.293-1.293a1 1 0 011.414 1.414L19.414 18l1.293 1.293a1 1 0 01-1.414 1.414L18 19.414l-1.293 1.293a1 1 0 01-1.414-1.414L16.586 18l-1.293-1.293a1 1 0 010-1.414z"/></svg>';
const FilterIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-filter"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M6 7a1 1 0 00-1 1v1h14V8a1 1 0 00-1-1H6zm11.586 4H6.414l4.293 4.293A1 1 0 0111 16v2.382l2-1V16a1 1 0 01.293-.707L17.586 11zM3 8a3 3 0 013-3h12a3 3 0 013 3v2a1 1 0 01-.293.707L15 16.414V18a1 1 0 01-.553.894l-4 2A1 1 0 019 20v-3.586l-5.707-5.707A1 1 0 013 10V8z"/></svg>';
const EditIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-edit"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M16.293 2.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-14 14A1 1 0 017 22H3a1 1 0 01-1-1v-4a1 1 0 01.293-.707l14-14zM15.414 6L18 8.586 19.586 7 17 4.414 15.414 6zm1.172 4L14 7.414l-10 10V20h2.586l10-10z"/></svg>';
const WarningIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-warning"><path class="primary" d="M12 19a1 1 0 100-2 1 1 0 000 2zM13 11a1 1 0 10-2 0v4a1 1 0 102 0v-4z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12.886 2.691a1 1 0 00-1.772 0L1.767 20.536A1 1 0 002.653 22h18.694a1 1 0 00.886-1.464L12.886 2.691zM12 5.311L4.305 20h15.39L12 5.31z"/></svg>';
const DangerIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-forbidden"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 4a8 8 0 00-6.439 12.75L16.75 5.56A7.96 7.96 0 0012 4zm6.198 2.941L6.94 18.198A8 8 0 0018.198 6.94zM2 12C2 6.477 6.477 2 12 2a9.97 9.97 0 016.917 2.778A9.974 9.974 0 0122 12c0 5.523-4.477 10-10 10a9.974 9.974 0 01-7.222-3.083A9.97 9.97 0 012 12z"/></svg>';
const AddIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-add"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 5a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 011-1z"/></svg>';
const MinusIcon = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 7.33337C12.3682 7.33337 12.6666 7.63185 12.6666 8.00004C12.6666 8.36823 12.3682 8.66671 12 8.66671C6.85805 8.66671 8.73667 8.66671 3.99998 8.66671C3.63179 8.66671 3.33331 8.36823 3.33331 8.00004C3.33331 7.63185 3.63179 7.33337 3.99998 7.33337C8.73305 7.33337 6.86235 7.33337 12 7.33337Z"/></svg>';
const CalendarIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-calendar"><path class="primary" d="M9 13a1 1 0 11-2 0 1 1 0 012 0zM13 13a1 1 0 11-2 0 1 1 0 012 0zM16 14a1 1 0 100-2 1 1 0 000 2zM9 16a1 1 0 11-2 0 1 1 0 012 0zM12 17a1 1 0 100-2 1 1 0 000 2zM17 16a1 1 0 11-2 0 1 1 0 012 0z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M17 3a1 1 0 10-2 0H9a1 1 0 00-2 0H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2h-2zM7 6V5H5v3h14V5h-2v1a1 1 0 11-2 0V5H9v1a1 1 0 01-2 0zm-2 4h14v9H5v-9z"/></svg>';
const ExportIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12.707 3.293a1 1 0 00-1.414 0l-4 4a1 1 0 001.414 1.414L11 6.414V16a1 1 0 102 0V6.414l2.293 2.293a1 1 0 101.414-1.414l-4-4zM5 14a1 1 0 10-2 0v6a1 1 0 001 1h16a1 1 0 001-1v-6a1 1 0 10-2 0v5H5v-5z"/></svg>';
const DropdownIcon = '<svg viewBox="0 0 10 6" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.528758 0.528758C0.268409 0.789108 0.268409 1.21122 0.528758 1.47157L4.52876 5.47157C4.78911 5.73192 5.21122 5.73192 5.47157 5.47157L9.47157 1.47157C9.73192 1.21122 9.73192 0.789108 9.47157 0.528758C9.21122 0.268409 8.78911 0.268409 8.52876 0.528758L5.00016 4.05735L1.47157 0.528758C1.21122 0.268409 0.789108 0.268409 0.528758 0.528758Z" fill="#485B6E"/></svg>';
const DropdownArrowsIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-select"><path class="primary" d="M6.375 7.22a1 1 0 001.25 1.56L12 5.28l4.375 3.5a1 1 0 001.25-1.56l-5-4a1 1 0 00-1.25 0l-5 4zM7.625 15.22a1 1 0 10-1.25 1.56l5 4a1 1 0 001.25 0l5-4a1 1 0 10-1.25-1.56L12 18.72l-4.375-3.5z"/></svg>';
const InsertIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-add"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 5a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H6a1 1 0 110-2h5V6a1 1 0 011-1z"/></svg>';
const ApplyIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-check-alternate"><path class="primary" d="M14.72 8.79l-4.29 4.3-1.65-1.65a1 1 0 10-1.41 1.41l2.35 2.36a1 1 0 001.41 0l5-5a1.002 1.002 0 10-1.41-1.42zM12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"/></svg>';
const BudgetAuditIcon = '<svg viewBox="0 0 11 15" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.3335 1.66683C1.96531 1.66683 1.66683 1.96531 1.66683 2.3335V11.6668C1.66683 12.035 1.96531 12.3335 2.3335 12.3335H2.78258C3.01998 12.8332 3.34359 13.2841 3.73417 13.6668H2.3335C1.22893 13.6668 0.333496 12.7714 0.333496 11.6668V2.3335C0.333496 1.22893 1.22893 0.333496 2.3335 0.333496H5.27631L9.66683 4.72402V6.50329C9.26416 6.22242 8.81512 6.00342 8.3335 5.86008V5.66683H6.3335C5.22893 5.66683 4.3335 4.7714 4.3335 3.66683V1.66683H2.3335ZM5.66683 2.60964L7.39069 4.3335H6.3335C5.96531 4.3335 5.66683 4.03502 5.66683 3.66683V2.60964Z"/><path d="M8.8049 10.1382C9.06525 9.87788 9.06525 9.45577 8.8049 9.19543C8.54455 8.93508 8.12244 8.93508 7.86209 9.19543L6.66683 10.3907L6.13823 9.86209C5.87788 9.60174 5.45577 9.60174 5.19543 9.86209C4.93508 10.1224 4.93508 10.5446 5.19543 10.8049L6.19543 11.8049C6.45577 12.0653 6.87788 12.0653 7.13823 11.8049L8.8049 10.1382Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.00016 6.3335C4.79102 6.3335 3.00016 8.12436 3.00016 10.3335C3.00016 12.5426 4.79102 14.3335 7.00016 14.3335C9.2093 14.3335 11.0002 12.5426 11.0002 10.3335C11.0002 8.12436 9.2093 6.3335 7.00016 6.3335ZM4.3335 10.3335C4.3335 8.86074 5.5274 7.66683 7.00016 7.66683C8.47292 7.66683 9.66683 8.86074 9.66683 10.3335C9.66683 11.8063 8.47292 13.0002 7.00016 13.0002C5.5274 13.0002 4.3335 11.8063 4.3335 10.3335Z"/></svg>';
const CopyIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-copy"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M7 4a2 2 0 012-2h5a1 1 0 01.707.293l6 6A1 1 0 0121 9v7a2 2 0 01-2 2h-2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h2V4zm0 4H5v11a1 1 0 001 1h8a1 1 0 001-1v-1H9a2 2 0 01-2-2V8zm6-4h-3a1 1 0 00-1 1v11h9a1 1 0 001-1v-5h-4a2 2 0 01-2-2V4zm2 1.414L17.586 8H15V5.414z"/></svg>';
const ImportIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.7071 12.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858V4C11 3.44771 11.4477 3 12 3C12.5523 3 13 3.44771 13 4V13.5858L15.2929 11.2929C15.6834 10.9024 16.3166 10.9024 16.7071 11.2929C17.0976 11.6834 17.0976 12.3166 16.7071 12.7071Z"/><path d="M4 13C4.55228 13 5 13.4477 5 14V19H19V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V14C3 13.4477 3.44772 13 4 13Z"/></svg>';
const PercentIcon = '<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.52843 10.4712C1.26808 10.2109 1.26808 9.78878 1.52843 9.52843L9.52843 1.52843C9.78878 1.26808 10.2109 1.26808 10.4712 1.52843C10.7316 1.78878 10.7316 2.21089 10.4712 2.47124L2.47124 10.4712C2.21089 10.7316 1.78878 10.7316 1.52843 10.4712Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.99984 9.99984C9.55212 9.99984 9.99984 9.55212 9.99984 8.99984C9.99984 8.44755 9.55212 7.99984 8.99984 7.99984C8.44755 7.99984 7.99984 8.44755 7.99984 8.99984C7.99984 9.55212 8.44755 9.99984 8.99984 9.99984ZM8.99984 11.3332C10.2885 11.3332 11.3332 10.2885 11.3332 8.99984C11.3332 7.71117 10.2885 6.6665 8.99984 6.6665C7.71117 6.6665 6.6665 7.71117 6.6665 8.99984C6.6665 10.2885 7.71117 11.3332 8.99984 11.3332Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.99984 3.99984C3.55212 3.99984 3.99984 3.55212 3.99984 2.99984C3.99984 2.44755 3.55212 1.99984 2.99984 1.99984C2.44755 1.99984 1.99984 2.44755 1.99984 2.99984C1.99984 3.55212 2.44755 3.99984 2.99984 3.99984ZM2.99984 5.33317C4.2885 5.33317 5.33317 4.2885 5.33317 2.99984C5.33317 1.71117 4.2885 0.666504 2.99984 0.666504C1.71117 0.666504 0.666504 1.71117 0.666504 2.99984C0.666504 4.2885 1.71117 5.33317 2.99984 5.33317Z"/></svg>';
const RemoveIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-delete"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M11 4a1 1 0 00-1 1v1h4V5a1 1 0 00-1-1h-2zm5 2V5a3 3 0 00-3-3h-2a3 3 0 00-3 3v1H4a1 1 0 000 2h1v11a3 3 0 003 3h8a3 3 0 003-3V8h1a1 1 0 100-2h-4zM7 8v11a1 1 0 001 1h8a1 1 0 001-1V8H7zm3 2a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm4 0a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1z"/></svg>';
const RestoreIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-reset"><path class="primary" d="M5.754 7a8 8 0 111.867 11.695 1 1 0 10-1.094 1.674c4.622 3.023 10.82 1.727 13.842-2.896 3.023-4.622 1.726-10.82-2.896-13.842C13.468 1.01 8.28 1.635 5 4.856V3a1 1 0 10-2 0v5a1 1 0 001 1h5a1 1 0 000-2H5.754z"/></svg>';
const SaveIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-save"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M15 13a3 3 0 11-6 0 3 3 0 016 0zm-2 0a1 1 0 11-2 0 1 1 0 012 0z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V7.828a2 2 0 00-.586-1.414l-2.828-2.828A2 2 0 0016.172 3H5zm1 2v1a3 3 0 003 3h3a3 3 0 003-3V5h1.172L19 7.828V19H5V5h1zm7 0H8v1a1 1 0 001 1h3a1 1 0 001-1V5z"/></svg>';
const BreakEvenAnalysisIcon = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M2.3335 0.333252C1.22893 0.333252 0.333496 1.22868 0.333496 2.33325V11.6666C0.333496 12.7712 1.22893 13.6666 2.3335 13.6666H7.00016C7.36835 13.6666 7.66683 13.3681 7.66683 12.9999C7.66683 12.6317 7.36835 12.3333 7.00016 12.3333H2.3335C1.96531 12.3333 1.66683 12.0348 1.66683 11.6666V2.33325C1.66683 1.96506 1.96531 1.66659 2.3335 1.66659H9.00016C9.36835 1.66659 9.66683 1.96506 9.66683 2.33325V6.33325C9.66683 6.70144 9.96531 6.99992 10.3335 6.99992C10.7017 6.99992 11.0002 6.70144 11.0002 6.33325V2.33325C11.0002 1.22868 10.1047 0.333252 9.00016 0.333252H2.3335Z"/><path d="M3.66683 4.33325C3.29864 4.33325 3.00016 4.63173 3.00016 4.99992C3.00016 5.36811 3.29864 5.66659 3.66683 5.66659H7.66683C8.03502 5.66659 8.3335 5.36811 8.3335 4.99992C8.3335 4.63173 8.03502 4.33325 7.66683 4.33325H3.66683Z"/><path d="M3.66683 6.99992C3.29864 6.99992 3.00016 7.2984 3.00016 7.66659C3.00016 8.03478 3.29864 8.33325 3.66683 8.33325H7.66683C8.03502 8.33325 8.3335 8.03478 8.3335 7.66659C8.3335 7.2984 8.03502 6.99992 7.66683 6.99992H3.66683Z"/><path d="M3.66683 9.66659C3.29864 9.66659 3.00016 9.96506 3.00016 10.3333C3.00016 10.7014 3.29864 10.9999 3.66683 10.9999H6.3335C6.70169 10.9999 7.00016 10.7014 7.00016 10.3333C7.00016 9.96506 6.70169 9.66659 6.3335 9.66659H3.66683Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6936 11.7533L13.4736 12.5266C13.5361 12.5886 13.5857 12.6623 13.6195 12.7435C13.6534 12.8248 13.6708 12.9119 13.6708 12.9999C13.6708 13.0879 13.6534 13.1751 13.6195 13.2563C13.5857 13.3375 13.5361 13.4113 13.4736 13.4733C13.4116 13.5357 13.3379 13.5853 13.2566 13.6192C13.1754 13.653 13.0883 13.6705 13.0003 13.6705C12.9122 13.6705 12.8251 13.653 12.7439 13.6192C12.6626 13.5853 12.5889 13.5357 12.5269 13.4733L11.7536 12.6933C11.4014 12.8874 11.0046 12.986 10.6025 12.9794C10.2004 12.9729 9.80706 12.8613 9.46141 12.6558C9.11576 12.4503 8.82983 12.158 8.632 11.8079C8.43416 11.4578 8.33129 11.062 8.33358 10.6599C8.32478 10.1926 8.45691 9.73351 8.71276 9.34238C8.96862 8.95126 9.33634 8.64626 9.76802 8.46711C10.1997 8.28796 10.6753 8.24298 11.1329 8.33801C11.5905 8.43305 12.0089 8.6637 12.3336 8.99992C12.6864 9.35636 12.9126 9.81862 12.9777 10.3159C13.0427 10.8132 12.9429 11.3181 12.6936 11.7533ZM10.6569 11.6387C10.9183 11.6387 11.1698 11.539 11.3603 11.3599C11.5511 11.1764 11.6614 10.9247 11.6669 10.6599C11.669 10.5249 11.6432 10.3909 11.591 10.2663C11.5389 10.1418 11.4616 10.0293 11.3639 9.93606C11.2663 9.84279 11.1504 9.77071 11.0236 9.72433C10.8967 9.67796 10.7617 9.6583 10.6269 9.66659C10.3763 9.67398 10.138 9.77648 9.96025 9.95325C9.86616 10.0451 9.79165 10.1551 9.74123 10.2766C9.69082 10.398 9.66554 10.5284 9.66692 10.6599C9.66713 10.9218 9.77006 11.1731 9.95358 11.3599C10.144 11.539 10.3955 11.6387 10.6569 11.6387Z"/></svg>';
const CancelIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-clear"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"/></svg>';
const ChevronUpIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-up"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M18.707 15.707a1 1 0 000-1.414l-6-6a1 1 0 00-1.414 0l-6 6a1 1 0 101.414 1.414L12 10.414l5.293 5.293a1 1 0 001.414 0z"/></svg>';
const ChevronDownIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-down"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M5.293 8.293a1 1 0 000 1.414l6 6a1 1 0 001.414 0l6-6a1 1 0 00-1.414-1.414L12 13.586 6.707 8.293a1 1 0 00-1.414 0z"/></svg>';
const ChevronLeftIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-left"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M15.707 5.293a1 1 0 00-1.414 0l-6 6a1 1 0 000 1.414l6 6a1 1 0 001.414-1.414L10.414 12l5.293-5.293a1 1 0 000-1.414z"/></svg>';
const ChevronRightIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-chevron-right"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M8.293 5.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L13.586 12 8.293 6.707a1 1 0 010-1.414z"/></svg>';
const Bullet = '<svg viewBox="0 0 8 8" xmlns="http://www.w3.org/2000/svg"><circle cx="3.99984" cy="3.99984" r="3.33333"/></svg>';
const WidgetOptionsIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-settings"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M7.248 4.23a2.578 2.578 0 002.618-1.084 2.578 2.578 0 014.268 0 2.578 2.578 0 002.618 1.084 2.578 2.578 0 013.018 3.018 2.578 2.578 0 001.084 2.619 2.578 2.578 0 010 4.266 2.578 2.578 0 00-1.084 2.62 2.578 2.578 0 01-3.018 3.017 2.578 2.578 0 00-2.618 1.085 2.578 2.578 0 01-4.268 0 2.578 2.578 0 00-2.618-1.085 2.578 2.578 0 01-3.018-3.018 2.578 2.578 0 00-1.084-2.618 2.578 2.578 0 010-4.267 2.578 2.578 0 001.084-2.62A2.578 2.578 0 017.248 4.23zm5.133-.073a.578.578 0 00-.86.111 4.578 4.578 0 01-4.65 1.926.578.578 0 00-.676.676 4.578 4.578 0 01-1.926 4.65.578.578 0 000 .958 4.578 4.578 0 011.926 4.65.578.578 0 00.676.676 4.578 4.578 0 014.65 1.928c.23.338.728.338.957 0a4.578 4.578 0 014.65-1.927.578.578 0 00.677-.676 4.578 4.578 0 011.927-4.65.579.579 0 000-.957 4.576 4.576 0 01-1.927-4.65.578.578 0 00-.676-.677 4.578 4.578 0 01-4.65-1.927.583.583 0 00-.098-.11zM16 12a4 4 0 11-8 0 4 4 0 018 0zm-4 2a2 2 0 100-4 2 2 0 000 4z"/></svg>';
const WidgetCommentsIcon = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4.66671 6.66668C4.66671 6.29851 4.96517 6.00001 5.33337 6.00001H10.6667C11.0349 6.00001 11.3334 6.29851 11.3334 6.66668C11.3334 7.03484 11.0349 7.33334 10.6667 7.33334H5.33337C4.96517 7.33334 4.66671 7.03484 4.66671 6.66668Z"/><path d="M5.33337 8.66668C4.96517 8.66668 4.66671 8.96518 4.66671 9.33334C4.66671 9.70151 4.96517 10 5.33337 10H9.33337C9.70158 10 10 9.70151 10 9.33334C10 8.96518 9.70158 8.66668 9.33337 8.66668H5.33337Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.28597 12.714C2.07955 11.5077 1.33337 9.84099 1.33337 8.00001C1.33337 4.31804 4.31816 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31804 14.6667 8.00001C14.6667 10.2269 13.5748 12.1989 11.8972 13.4095C10.8011 14.2005 9.455 14.6667 8.00004 14.6667H2.94287C2.34892 14.6667 2.05147 13.9486 2.47148 13.5285L3.28597 12.714ZM11.3828 12.1235C12.5737 11.1454 13.3334 9.66147 13.3334 8.00001C13.3334 5.05453 10.9456 2.66668 8.00004 2.66668C5.05452 2.66668 2.66671 5.05453 2.66671 8.00001C2.66671 9.75001 3.50952 11.3032 4.8114 12.2756C5.04529 12.4504 5.08968 12.7961 4.88322 13.0025L4.55233 13.3333H8.00004C9.28418 13.3333 10.4623 12.8796 11.3828 12.1235Z"/></svg>';
const PinButton = '<svg class="icon-pinned" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.435 2.707a1 1 0 011.414 0l.825.825 3.418 3.418a1 1 0 010 1.414c-.634.634-1.285 1.157-2.007 1.39a2.59 2.59 0 01-1.453.054l-2.037 2.543c.075.241.134.488.177.737.307 1.8-.259 3.683-1.751 5.176a1 1 0 01-1.414 0l-2.829-2.829-3.535 3.536a1 1 0 01-1.414-1.415l3.535-3.535-2.828-2.829a1 1 0 010-1.414c1.492-1.492 3.376-2.058 5.175-1.75.25.042.496.1.737.176l2.543-2.037a2.592 2.592 0 01.054-1.453c.233-.722.757-1.373 1.39-2.007z"/></svg>';
const ChartTypeIcon = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.33353 1.00013C8.33354 0.631953 8.63202 0.333496 9.00019 0.333496C11.5775 0.333496 13.6668 2.42284 13.6668 5.00016C13.6668 5.36835 13.3684 5.66683 13.0002 5.66683H9.0002C8.63202 5.66683 8.33354 5.36836 8.33354 5.00017L8.33353 1.00013ZM9.66686 1.73351L9.66687 4.3335H12.2668C12.0017 3.02741 10.9729 1.99863 9.66686 1.73351ZM5.66683 3.04742C3.4053 3.37091 1.66683 5.31585 1.66683 7.66683C1.66683 10.2442 3.75617 12.3335 6.3335 12.3335C8.68448 12.3335 10.6294 10.595 10.9529 8.3335H6.3335C5.96531 8.3335 5.66683 8.03502 5.66683 7.66683V3.04742ZM0.333496 7.66683C0.333496 4.35312 3.01979 1.66683 6.3335 1.66683C6.70169 1.66683 7.00016 1.96531 7.00016 2.3335V7.00016H11.6668C12.035 7.00016 12.3335 7.29864 12.3335 7.66683C12.3335 10.9805 9.64721 13.6668 6.3335 13.6668C3.01979 13.6668 0.333496 10.9805 0.333496 7.66683Z"/></svg>';
const CloseIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-clear"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"></path></svg>';
const RefreshIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.9384 11.002C20.0066 11.55 20.4477 12 21 12V12C21.5523 12 22.0053 11.551 21.9508 11.0014C21.4497 5.94741 17.1858 2 12 2C9.27455 2 6.80375 3.09032 5 4.85857V3C5 2.44772 4.55228 2 4 2C3.44772 2 3 2.44772 3 3V8C3 8.55228 3.44772 9 4 9H9C9.55228 9 10 8.55229 10 8C10 7.44772 9.55229 7 9 7H5.75463C7.22075 5.17107 9.47362 4 12 4C16.0803 4 19.4471 7.05471 19.9384 11.002Z"/><path d="M19 19.1414C17.1962 20.9097 14.7255 22 12 22C6.81417 22 2.55031 18.0526 2.04924 12.9986C1.99475 12.449 2.44772 12 3 12V12C3.55228 12 3.99344 12.45 4.06165 12.998C4.55286 16.9453 7.9197 20 12 20C14.5264 20 16.7793 18.8289 18.2454 17H15C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15H20C20.5523 15 21 15.4477 21 16V21C21 21.5523 20.5523 22 20 22C19.4477 22 19 21.5523 19 21V19.1414Z"/></svg>';
const SourceSelectorIcon = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.33333 2.66667C5.33333 2.29848 5.63181 2 6 2H10C10.3682 2 10.6667 2.29848 10.6667 2.66667V5.33333C10.6667 5.70152 10.3682 6 10 6H8.66667V7.33333H10.6667C11.403 7.33333 12 7.93029 12 8.66667V10H13.3333C13.7015 10 14 10.2985 14 10.6667V13.3333C14 13.7015 13.7015 14 13.3333 14H9.33333C8.96514 14 8.66667 13.7015 8.66667 13.3333V10.6667C8.66667 10.2985 8.96514 10 9.33333 10H10.6667V8.66667H5.33333V10H6.66667C7.03486 10 7.33333 10.2985 7.33333 10.6667V13.3333C7.33333 13.7015 7.03486 14 6.66667 14H2.66667C2.29848 14 2 13.7015 2 13.3333V10.6667C2 10.2985 2.29848 10 2.66667 10H4V8.66667C4 7.93029 4.59695 7.33333 5.33333 7.33333H7.33333V6H6C5.63181 6 5.33333 5.70152 5.33333 5.33333V2.66667ZM6.66667 4.66667V3.33333H9.33333V4.66667H6.66667ZM3.33333 12.6667V11.3333H6V12.6667H3.33333ZM10 11.3333V12.6667H12.6667V11.3333H10Z"/></svg>';
const RightsDirectLogo = '<svg width="92" height="32" viewBox="0 0 92 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.62915 28.2251L2.94629 23.1868H1.68202V28.2251H0V16.3091H3.64988C5.52979 16.3091 7.84394 17.2634 7.84394 19.7319C7.84394 21.7579 6.35431 22.7763 4.84268 23.0855L8.73992 28.2251H6.62915ZM3.56193 17.7753H1.68202V21.7206H3.21013C4.84268 21.7206 6.05198 21.1448 6.05198 19.7799C6.05198 18.575 5.05156 17.7753 3.56193 17.7753Z" fill="#00326E" /><path d="M10.125 28.225V19.7158H11.7246V28.225H10.125Z" fill="#00326E" /><path d="M22.2675 27.7456C22.2675 28.6306 22.1246 29.377 21.8113 29.9742C21.0198 31.4564 19.4971 32.0002 17.8481 32.0002C16.4959 32.0002 15.0227 31.627 13.9729 30.8752L14.5885 29.5477C15.3965 30.1075 16.7103 30.5713 17.8151 30.5713C19.3267 30.5713 20.6735 29.8729 20.6735 28.0548V26.8819C20.0413 27.7829 18.92 28.2254 17.8646 28.2254C15.3745 28.2254 13.4946 26.3167 13.4946 23.8696C13.4946 21.641 15.2316 19.5137 17.9141 19.5137C18.931 19.5137 19.9644 19.9562 20.668 20.6546V19.7163H22.262V27.7456H22.2675ZM20.668 22.2328C20.0523 21.401 19.0189 20.9372 18.1229 20.9372C16.0891 20.9372 15.1217 22.4514 15.1217 23.8962C15.1217 25.4264 16.2815 26.7912 18.068 26.7912C19.0134 26.7912 20.2062 26.2314 20.6625 25.2078V22.2328H20.668Z" fill="#00326E" /><path d="M26.2636 21.1129C26.9123 20.1105 27.9457 19.5134 29.122 19.5134C30.3478 19.5134 31.1558 19.9239 31.667 20.5851C32.2661 21.3688 32.4585 22.5097 32.4585 23.8V28.2252H30.8645V23.9706C30.8645 23.1389 30.8315 22.2325 30.4082 21.6194C30.1279 21.2088 29.6552 20.9369 28.8801 20.9369C27.8632 20.9369 26.8958 21.6194 26.2636 22.5684V28.2198H24.6641V15.4614H26.2636V21.1129Z" fill="#00326E" /><path d="M36.5483 21.0758V24.9198C36.5483 25.1437 36.5483 25.3303 36.5648 25.5809C36.6198 26.482 36.9166 27.0098 37.7906 27.0098C38.1424 27.0098 38.4942 26.9085 38.7746 26.7699L39.2143 28.0121C38.7746 28.236 38.1589 28.3853 37.5817 28.3853C36.356 28.3853 35.5974 27.8575 35.2291 27.0578C35.0202 26.5833 34.9488 25.9541 34.9488 25.2877V21.0651H33.7725V19.7056H34.9488V17.6636H36.5429V19.7056H38.9999V21.0651H36.5483V21.0758Z" fill="#00326E" /><path d="M44.777 21.433C44.3757 21.0918 43.6392 20.8039 43.04 20.8039C42.232 20.8039 41.7263 21.2624 41.7263 21.9288C41.7263 22.5739 42.5673 22.8992 43.4083 23.2244C44.5461 23.6509 45.9698 24.28 45.9698 25.7622C45.9698 27.6709 44.4417 28.4333 42.7926 28.4333C41.5998 28.4333 40.4565 27.9748 39.7749 27.1058L40.8962 26.2367C41.4734 26.8339 42.1055 27.1378 42.8091 27.1378C43.6666 27.1378 44.3867 26.7112 44.3867 25.8262C44.3867 25.1597 43.5787 24.8558 42.7047 24.5146C41.5449 24.0721 40.1982 23.5763 40.1982 22.0461C40.1982 20.3294 41.5669 19.5083 43.0235 19.5083C44.0239 19.5083 45.0243 19.8335 45.7279 20.4467L44.777 21.433Z" fill="#00326E" /><path d="M48.1631 16.3091H51.4777C54.5998 16.3091 58.0738 17.9085 58.0738 22.2164C58.0738 26.6256 54.6328 28.2251 51.3018 28.2251H48.1631V16.3091ZM51.1643 17.7753H49.8506V26.7589H50.4278C53.9347 26.7589 56.2874 25.6873 56.2874 22.3657C56.2874 19.3587 54.391 17.7753 51.1643 17.7753Z" fill="#00326E" /><path d="M60.168 28.225V19.7158H61.762V28.225H60.168Z" fill="#00326E" /><path d="M65.868 21.1291C66.3957 20.2121 67.1817 19.5137 68.1327 19.5137C68.501 19.5137 68.7483 19.5457 69.0781 19.615L68.7813 21.2678C68.5175 21.1505 68.2921 21.0971 67.9568 21.0971C67.0608 21.0971 66.4122 21.609 65.868 22.526V28.2254H64.2739V19.7163H65.868V21.1291Z" fill="#00326E" /><path d="M70.9583 24.36C71.0628 25.8262 72.1017 27.1004 73.7837 27.1004C74.9435 27.1004 75.8725 26.6899 76.4002 25.7196L77.56 26.434C76.6805 27.7935 75.4877 28.4227 73.7177 28.4227C70.9253 28.4227 69.3643 26.45 69.3643 23.9655C69.3643 21.4277 71.2771 19.5083 73.7177 19.5083C76.0319 19.5083 77.7194 21.1931 77.7194 23.475C77.7194 23.7629 77.6864 24.1414 77.6479 24.36H70.9583ZM71.0793 23.1178H76.0649C75.9934 21.9075 75.048 20.8359 73.7287 20.8359C72.305 20.8359 71.3926 21.8435 71.0793 23.1178Z" fill="#00326E" /><path d="M85.9204 27.5963C85.2718 28.1081 84.2878 28.428 83.238 28.428C80.7314 28.428 78.7471 26.658 78.7471 23.9708C78.7471 21.4863 80.7644 19.5137 83.3259 19.5137C84.2549 19.5137 85.0959 19.7856 85.7995 20.2441L85.0464 21.5183C84.5572 21.1611 83.8866 20.9425 83.2544 20.9425C81.6769 20.9425 80.3741 22.2861 80.3741 23.9708C80.3741 25.8102 81.7428 26.9992 83.2709 26.9992C83.8481 26.9992 84.6561 26.7433 85.1289 26.402L85.9204 27.5963Z" fill="#00326E" /><path d="M89.3285 21.0758V24.9198C89.3285 25.1437 89.3285 25.3303 89.345 25.5809C89.4 26.482 89.6968 27.0098 90.5763 27.0098C90.9281 27.0098 91.2799 26.9085 91.5602 26.7699L91.9999 28.0121C91.5602 28.236 90.9446 28.3853 90.3674 28.3853C89.1416 28.3853 88.383 27.8575 88.0148 27.0578C87.8059 26.5833 87.7344 25.9541 87.7344 25.2877V21.0651H86.5581V19.7056H87.7344V17.6636H89.334V19.7056H91.7911V21.0651H89.3285V21.0758Z" fill="#00326E" /><path d="M33.8437 5.45951C35.398 5.45951 36.658 4.23736 36.658 2.72976C36.658 1.22215 35.398 0 33.8437 0C32.2893 0 31.0293 1.22215 31.0293 2.72976C31.0293 4.23736 32.2893 5.45951 33.8437 5.45951Z" fill="url(#paint0_linear_1710_61111)" /><path d="M47.0964 8.00773C48.9179 8.00773 50.3945 6.57552 50.3945 4.8088C50.3945 3.04207 48.9179 1.60986 47.0964 1.60986C45.2749 1.60986 43.7983 3.04207 43.7983 4.8088C43.7983 6.57552 45.2749 8.00773 47.0964 8.00773Z" fill="url(#paint1_linear_1710_61111)" /><path d="M60.4645 13.558C62.4378 13.558 64.0374 12.0064 64.0374 10.0925C64.0374 8.17852 62.4378 6.62695 60.4645 6.62695C58.4913 6.62695 56.8916 8.17852 56.8916 10.0925C56.8916 12.0064 58.4913 13.558 60.4645 13.558Z" fill="url(#paint2_linear_1710_61111)" /><path d="M21.4926 8.00774C22.7889 8.00774 23.8398 6.98848 23.8398 5.73116C23.8398 4.47385 22.7889 3.45459 21.4926 3.45459C20.1964 3.45459 19.1455 4.47385 19.1455 5.73116C19.1455 6.98848 20.1964 8.00774 21.4926 8.00774Z" fill="url(#paint3_linear_1710_61111)" /><path d="M11.0485 12.8968C12.1596 12.8968 13.0603 12.0232 13.0603 10.9455C13.0603 9.86779 12.1596 8.99414 11.0485 8.99414C9.93735 8.99414 9.03662 9.86779 9.03662 10.9455C9.03662 12.0232 9.93735 12.8968 11.0485 12.8968Z" fill="url(#paint4_linear_1710_61111)" /><defs><linearGradient id="paint0_linear_1710_61111" x1="33.8425" y1="-0.0271909" x2="33.8425" y2="5.43755" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B" /><stop offset="0.9962" stop-color="#E48E0A" /></linearGradient><linearGradient id="paint1_linear_1710_61111" x1="47.0989" y1="1.58406" x2="47.0989" y2="7.98038" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B" /><stop offset="0.9962" stop-color="#E48E0A" /></linearGradient><linearGradient id="paint2_linear_1710_61111" x1="60.4638" y1="6.59544" x2="60.4638" y2="13.5308" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B" /><stop offset="0.9962" stop-color="#E48E0A" /></linearGradient><linearGradient id="paint3_linear_1710_61111" x1="21.4937" y1="3.43844" x2="21.4937" y2="7.98838" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B" /><stop offset="0.9962" stop-color="#E48E0A" /></linearGradient><linearGradient id="paint4_linear_1710_61111" x1="11.0488" y1="8.98076" x2="11.0488" y2="12.8816" gradientUnits="userSpaceOnUse"><stop stop-color="#FCC30B" /><stop offset="0.9962" stop-color="#E48E0A" /></linearGradient></defs></svg>';
const MoreIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-more"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M14 5a2 2 0 11-4 0 2 2 0 014 0zm0 7a2 2 0 11-4 0 2 2 0 014 0zm-2 9a2 2 0 100-4 2 2 0 000 4z"/></svg>';
const SearchIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-search"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M17.998 11.155a7 7 0 11-13.997-.31 7 7 0 0113.997.31zm.034 5.463a9 9 0 10-1.414 1.414l3.675 3.675a1 1 0 001.414-1.414l-3.675-3.675z"/></svg>';
const BackIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-back"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M11.707 6.293a1 1 0 010 1.414L8.414 11H18a1 1 0 110 2H8.414l3.293 3.293a1 1 0 01-1.414 1.414l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 0z"/></svg>';
const CheckMarkIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-checkmark"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M18.707 7.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L10 14.586l7.293-7.293a1 1 0 011.414 0z"/></svg>';
const SearchResults = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-search-results"><path class="primary" d="M5 2a3 3 0 00-3 3v14a3 3 0 003 3h7a1 1 0 100-2H5a1 1 0 01-1-1V5a1 1 0 011-1h10a1 1 0 011 1v6a1 1 0 102 0V5a3 3 0 00-3-3H5z"/><path class="primary" d="M7 8a1 1 0 000 2h6a1 1 0 100-2H7zM7 12a1 1 0 100 2h6a1 1 0 100-2H7zM7 16a1 1 0 100 2h4a1 1 0 100-2H7z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M20.54 19.13l1.17 1.16a.999.999 0 010 1.42 1 1 0 01-1.42 0l-1.16-1.17A3.46 3.46 0 0114 17.49 3.49 3.49 0 0120 15a3.44 3.44 0 01.54 4.13zm-3.055-.172c.392 0 .77-.15 1.055-.418a1.5 1.5 0 00.46-1.05A1.47 1.47 0 0017.44 16a1.48 1.48 0 00-1 .43 1.46 1.46 0 00-.44 1.06c0 .393.155.77.43 1.05a1.54 1.54 0 001.055.418z"/></svg>';
const BookmarkIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-bookmark"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M5 3a1 1 0 011-1h12a1 1 0 011 1v18a1 1 0 01-1.504.864L12 18.658l-5.496 3.206A1 1 0 015 21V3zm2 1v15.259l4.496-2.623a1 1 0 011.008 0L17 19.26V4H7z"/></svg>';
const CartIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-cart"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M7.171 4.424v.001L7.345 5H20a1 1 0 01.942 1.336l-2.5 7A1 1 0 0117.5 14H9a1 1 0 01-.946-.676l-.231-.674v-.001L5.653 6.324a.994.994 0 01-.012-.037l-.213-.711v-.001L5.255 5H4a1 1 0 010-2h2a1 1 0 01.958.713l.213.711zm11.43 13.377V17.8A1 1 0 0018 16H8.999a1 1 0 00-.6 1.8 2 2 0 103.333.2h3.535A1.99 1.99 0 0015 19a2 2 0 104 0c0-.45-.149-.865-.4-1.2zM17 19zM8 7h10.581l-1.786 5h-7.08L8 7z"/></svg>';
const VariantsIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-variants"><path class="primary" d="M8.7 10a1 1 0 001.41 0 1 1 0 000-1.41l-6.27-6.3a1.004 1.004 0 00-1.42 1.42L8.7 10zM21 14a1 1 0 00-1 1v3.59L15.44 14A1.018 1.018 0 1014 15.44L18.59 20H15a1 1 0 000 2h6c.13-.002.26-.029.38-.08a1 1 0 00.54-.54A.997.997 0 0022 21v-6a1 1 0 00-1-1zm.92-11.38a1 1 0 00-.54-.54A1 1 0 0021 2h-6a1 1 0 000 2h3.59L2.29 20.29a1 1 0 00.325 1.639 1 1 0 001.095-.219L20 5.41V9a1 1 0 002 0V3a.997.997 0 00-.08-.38z"/></svg>';
const ListAddIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-list-add"><path class="primary" d="M4.71 16.29a1 1 0 00-.33-.21 1 1 0 00-.76 0 1 1 0 00-.33.21 1 1 0 00-.21.33 1 1 0 00.21 1.09c.097.088.209.16.33.21a.94.94 0 00.76 0 1.15 1.15 0 00.33-.21 1 1 0 00.21-1.09 1 1 0 00-.21-.33zM9 8h2a1 1 0 100-2H9a1 1 0 000 2zm-4.29 3.29a1 1 0 00-1.09-.21 1.15 1.15 0 00-.33.21 1 1 0 00-.21.33.94.94 0 000 .76c.05.121.122.233.21.33.097.088.209.16.33.21a.94.94 0 00.76 0 1.15 1.15 0 00.33-.21 1.15 1.15 0 00.21-.33.94.94 0 000-.76 1 1 0 00-.21-.33zM14 11H9a1 1 0 000 2h5a1 1 0 000-2zM4.71 6.29a1 1 0 00-.33-.21 1 1 0 00-1.09.21 1.15 1.15 0 00-.21.33.94.94 0 000 .76c.05.121.122.233.21.33.097.088.209.16.33.21a1 1 0 001.09-.21 1.15 1.15 0 00.21-.33.94.94 0 000-.76 1.15 1.15 0 00-.21-.33zM20 16H9a1 1 0 000 2h11a1 1 0 000-2zM21 5h-2V3a1 1 0 10-2 0v2h-2a1 1 0 000 2h2v2a1 1 0 002 0V7h2a1 1 0 100-2z"/></svg>';
const ShareIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-share"><path class="primary" d="M18 14a4 4 0 00-3.08 1.48l-5.1-2.35a3.64 3.64 0 000-2.26l5.1-2.35a4 4 0 10-.85-1.81L8.79 9.14a4 4 0 100 5.72l5.28 2.43A4.166 4.166 0 0014 18a4 4 0 104-4zm0-10a2 2 0 110 4 2 2 0 010-4zM6 14a2 2 0 110-4 2 2 0 010 4zm12 6a2 2 0 110-4 2 2 0 010 4z"/></svg>';
const TagIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-tag"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M2 3a1 1 0 011-1h9a1 1 0 01.726.312l9 9.5a1 1 0 01-.019 1.395l-8.5 8.5a1 1 0 01-1.395.019l-9.5-9A1 1 0 012 12V3zm2 1v7.57l8.481 8.035 7.124-7.124L11.57 4H4z"/></svg>';
const TypesIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-types"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M2 5a3 3 0 013-3h3a3 3 0 013 3v3a3 3 0 01-3 3H5a3 3 0 01-3-3V5zm3-1a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V5a1 1 0 00-1-1H5zm10.68-.875c.75-1.5 2.89-1.5 3.64 0l2.464 4.93C22.46 9.408 21.477 11 19.964 11h-4.928c-1.513 0-2.496-1.592-1.82-2.945l2.464-4.93zm1.798.88l-.009.014-2.464 4.93c-.004.007-.005.013-.005.013v.004c0 .003.002.01.007.018a.04.04 0 00.013.013l.003.002.013.001h4.928l.013-.001.002-.001h.002a.04.04 0 00.012-.014.042.042 0 00.007-.018v-.004l-.005-.013-2.464-4.93c-.005-.01-.009-.014-.009-.014h-.001S17.512 4 17.5 4a.052.052 0 00-.02.004l-.002.001zM6.5 15a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM2 17.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0z"/></svg>';
const ConfigureIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-configure"><path class="primary" d="M4 21a1 1 0 102 0V8h1a1 1 0 000-2H6V3a1 1 0 00-2 0v3H3a1 1 0 000 2h1v13zM11 21a1 1 0 102 0v-3h1a1 1 0 100-2h-1V3a1 1 0 10-2 0v13h-1a1 1 0 100 2h1v3zM19 22a1 1 0 01-1-1V8h-1a1 1 0 110-2h1V3a1 1 0 112 0v3h1a1 1 0 110 2h-1v13a1 1 0 01-1 1z"/></svg>';
const AudioDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.6768 2.04047C12.5183 1.83008 13.3335 2.46656 13.3335 3.33399V10.4801C13.3335 11.5847 12.4381 12.4801 11.3335 12.4801C10.2289 12.4801 9.3335 11.5847 9.3335 10.4801C9.3335 9.37557 10.2289 8.48014 11.3335 8.48014C11.5673 8.48014 11.7916 8.52024 12.0002 8.59394V6.00066L5.3335 7.66732V11.8135C5.3335 12.918 4.43807 13.8135 3.3335 13.8135C2.22893 13.8135 1.3335 12.918 1.3335 11.8135C1.3335 10.7089 2.22893 9.81347 3.3335 9.81347C3.56725 9.81347 3.79164 9.85358 4.00016 9.92728V5.00066C4.00016 4.38883 4.41656 3.85552 5.01012 3.70713L11.6768 2.04047ZM5.3335 6.29296L12.0002 4.62629V3.33399L5.3335 5.00066V6.29296ZM11.3335 9.81347C11.7017 9.81347 12.0002 10.1119 12.0002 10.4801C12.0002 10.8483 11.7017 11.1468 11.3335 11.1468C10.9653 11.1468 10.6668 10.8483 10.6668 10.4801C10.6668 10.1119 10.9653 9.81347 11.3335 9.81347ZM3.3335 11.1468C3.70169 11.1468 4.00016 11.4453 4.00016 11.8135C4.00016 12.1817 3.70169 12.4801 3.3335 12.4801C2.96531 12.4801 2.66683 12.1817 2.66683 11.8135C2.66683 11.4453 2.96531 11.1468 3.3335 11.1468Z" fill="#485B6E"/></svg>';
const ExcelDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.6665 2.00065C2.6665 1.63246 2.96498 1.33398 3.33317 1.33398H8.6665C8.84332 1.33398 9.01288 1.40422 9.13791 1.52925L13.1379 5.52925C13.2629 5.65427 13.3332 5.82384 13.3332 6.00065V14.0007C13.3332 14.3688 13.0347 14.6673 12.6665 14.6673H3.33317C2.96498 14.6673 2.6665 14.3688 2.6665 14.0007V2.00065ZM3.99984 2.66732V13.334H11.9998V6.66732H8.6665C8.29831 6.66732 7.99984 6.36884 7.99984 6.00065V2.66732H3.99984ZM9.33317 3.61013L11.057 5.33398H9.33317V3.61013Z" fill="#485B6E"/><path d="M5.19922 10.157L5.66406 11.1023L6.12891 10.157H6.91016L6.11719 11.5671L6.93164 13.0007H6.14258L5.66406 12.0378L5.18555 13.0007H4.39453L5.21094 11.5671L4.41602 10.157H5.19922Z" fill="#485B6E"/><path d="M9.03711 12.4734V13.0007H7.59961V12.4734H9.03711ZM7.84375 10.157V13.0007H7.1582V10.157H7.84375Z" fill="#485B6E"/><path d="M10.791 12.2449C10.791 12.2006 10.7845 12.1609 10.7715 12.1257C10.7585 12.0893 10.7344 12.0554 10.6992 12.0242C10.6641 11.9929 10.6133 11.9617 10.5469 11.9304C10.4818 11.8979 10.3958 11.864 10.2891 11.8289C10.1641 11.7872 10.0436 11.7403 9.92773 11.6882C9.81185 11.6348 9.70833 11.573 9.61719 11.5027C9.52604 11.4311 9.45378 11.3477 9.40039 11.2527C9.34701 11.1563 9.32031 11.0444 9.32031 10.9167C9.32031 10.7944 9.34766 10.6843 9.40234 10.5867C9.45703 10.4877 9.5332 10.4037 9.63086 10.3347C9.72982 10.2644 9.8457 10.211 9.97852 10.1746C10.1113 10.1368 10.2565 10.1179 10.4141 10.1179C10.6224 10.1179 10.806 10.1544 10.9648 10.2273C11.125 10.2989 11.25 10.4011 11.3398 10.5339C11.431 10.6654 11.4766 10.821 11.4766 11.0007H10.7949C10.7949 10.9291 10.7799 10.866 10.75 10.8113C10.7214 10.7566 10.6777 10.7136 10.6191 10.6824C10.5605 10.6511 10.487 10.6355 10.3984 10.6355C10.3125 10.6355 10.2402 10.6485 10.1816 10.6746C10.123 10.7006 10.0788 10.7358 10.0488 10.78C10.0189 10.823 10.0039 10.8705 10.0039 10.9226C10.0039 10.9656 10.0156 11.0046 10.0391 11.0398C10.0638 11.0736 10.0983 11.1055 10.1426 11.1355C10.1882 11.1654 10.2428 11.1941 10.3066 11.2214C10.3717 11.2488 10.4447 11.2755 10.5254 11.3015C10.6764 11.3497 10.8105 11.4037 10.9277 11.4636C11.0462 11.5222 11.1458 11.5893 11.2266 11.6648C11.3086 11.739 11.3704 11.8236 11.4121 11.9187C11.4551 12.0138 11.4766 12.1212 11.4766 12.241C11.4766 12.3686 11.4518 12.4819 11.4023 12.5808C11.3529 12.6798 11.2819 12.7638 11.1895 12.8328C11.097 12.9005 10.9863 12.9519 10.8574 12.9871C10.7285 13.0222 10.5846 13.0398 10.4258 13.0398C10.2799 13.0398 10.1361 13.0216 9.99414 12.9851C9.85352 12.9473 9.72591 12.8901 9.61133 12.8132C9.49674 12.7351 9.40495 12.6355 9.33594 12.5144C9.26823 12.392 9.23438 12.2468 9.23438 12.0789H9.92188C9.92188 12.1622 9.93294 12.2325 9.95508 12.2898C9.97721 12.3471 10.0098 12.3933 10.0527 12.4285C10.0957 12.4623 10.1484 12.4871 10.2109 12.5027C10.2734 12.517 10.3451 12.5242 10.4258 12.5242C10.513 12.5242 10.5833 12.5118 10.6367 12.4871C10.6901 12.461 10.7292 12.4272 10.7539 12.3855C10.7786 12.3425 10.791 12.2957 10.791 12.2449Z" fill="#485B6E"/></svg>';
const ImageDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 7.33333C6.73638 7.33333 7.33333 6.73638 7.33333 6C7.33333 5.26362 6.73638 4.66667 6 4.66667C5.26362 4.66667 4.66667 5.26362 4.66667 6C4.66667 6.73638 5.26362 7.33333 6 7.33333Z" fill="#485B6E"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3.33333 2C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2H3.33333ZM12.6667 4C12.6667 3.63181 12.3682 3.33333 12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4L3.33333 10.5154L4.85343 9.16424C5.29313 8.7734 5.93702 8.71692 6.43805 9.02524L7.20871 9.4995C7.48891 9.67193 7.853 9.61417 8.06607 9.36349L9.69052 7.45238C10.1949 6.85893 11.0985 6.82236 11.6492 7.3731L12.6667 8.39052V4ZM3.70062 12.6667C3.49777 12.6667 3.33333 12.5022 3.33333 12.2994L5.36892 10.49C5.58877 10.2945 5.91072 10.2663 6.16123 10.4205L6.99693 10.9347C7.55732 11.2796 8.28549 11.1641 8.71164 10.6627L10.2382 8.86672C10.4905 8.57 10.9422 8.55171 11.2176 8.82709L12.6667 10.2761V12C12.6667 12.3682 12.3682 12.6667 12 12.6667H3.70062Z" fill="#485B6E"/></svg>';
const LinkoutDocTypeIcon = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.33333 3.33333C8.96514 3.33333 8.66667 3.03486 8.66667 2.66667C8.66667 2.29848 8.96514 2 9.33333 2H13.3333C13.7015 2 14 2.29848 14 2.66667V6.66667C14 7.03486 13.7015 7.33333 13.3333 7.33333C12.9651 7.33333 12.6667 7.03486 12.6667 6.66667V4.27614L7.13807 9.80474C6.87772 10.0651 6.45561 10.0651 6.19526 9.80474C5.93491 9.54439 5.93491 9.12228 6.19526 8.86193L11.7239 3.33333H9.33333ZM2 4C2 3.63181 2.29848 3.33333 2.66667 3.33333H7.28205C7.65024 3.33333 7.94872 3.63181 7.94872 4C7.94872 4.36819 7.65024 4.66667 7.28205 4.66667H3.33333V12.6667H11.3333V7.94872C11.3333 7.58053 11.6318 7.28205 12 7.28205C12.3682 7.28205 12.6667 7.58053 12.6667 7.94872V13.3333C12.6667 13.7015 12.3682 14 12 14H2.66667C2.29848 14 2 13.7015 2 13.3333V4Z" fill="#485B6E"/></svg>';
const PDFDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.66667 1.33594C2.29848 1.33594 2 1.63441 2 2.0026V14.0026C2 14.3708 2.29848 14.6693 2.66667 14.6693H13.3333C13.7015 14.6693 14 14.3708 14 14.0026V4.66927C14 4.49246 13.9298 4.32289 13.8047 4.19787L11.1381 1.5312C11.013 1.40618 10.8435 1.33594 10.6667 1.33594H2.66667ZM3.33333 13.3359V2.66927H10V4.66927C10 5.03746 10.2985 5.33594 10.6667 5.33594H12.6667V13.3359H3.33333ZM11.7239 4.0026L11.3333 3.61208V4.0026H11.7239ZM4 9.33594V12.6693H4.9023V11.7591H5.34068C6.05784 11.7591 6.54517 11.2856 6.54517 10.551C6.54517 9.80949 6.08551 9.33594 5.4024 9.33594H4ZM4.9023 10.0751H5.16193C5.4556 10.0751 5.63436 10.2368 5.63436 10.5533C5.63436 10.8721 5.4556 11.0338 5.15554 11.0338H4.9023V10.0751ZM6.79764 9.33594V12.6693H8.15961C9.08744 12.6693 9.5918 12.0687 9.5918 10.9599C9.5918 9.91806 9.0768 9.33594 8.15961 9.33594H6.79764ZM7.69994 10.1121H7.98298C8.4171 10.1121 8.67247 10.417 8.67247 10.9783C8.67247 11.5928 8.43413 11.8931 7.98298 11.8931H7.69994V10.1121ZM10.7444 11.4889V12.6693H9.84214V9.33594H12V10.1121H10.7444V10.7543H11.8808V11.4889H10.7444Z" fill="#F63447"/></svg>';
const PowerpointDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.6665 2.00065C2.6665 1.63246 2.96498 1.33398 3.33317 1.33398H8.6665C8.84332 1.33398 9.01288 1.40422 9.13791 1.52925L13.1379 5.52925C13.2629 5.65427 13.3332 5.82384 13.3332 6.00065V14.0007C13.3332 14.3688 13.0347 14.6673 12.6665 14.6673H3.33317C2.96498 14.6673 2.6665 14.3688 2.6665 14.0007V2.00065ZM3.99984 2.66732V13.334H11.9998V6.66732H8.6665C8.29831 6.66732 7.99984 6.36884 7.99984 6.00065V2.66732H3.99984ZM9.33317 3.61013L11.057 5.33398H9.33317V3.61013Z" fill="#485B6E"/><path d="M5.48438 12.0359H4.77734V11.5066H5.48438C5.58073 11.5066 5.65885 11.4903 5.71875 11.4578C5.77865 11.4252 5.82227 11.3803 5.84961 11.323C5.87826 11.2644 5.89258 11.1986 5.89258 11.1257C5.89258 11.0476 5.87826 10.9753 5.84961 10.9089C5.82227 10.8425 5.77865 10.7891 5.71875 10.7488C5.65885 10.7071 5.58073 10.6863 5.48438 10.6863H5.03516V13.0007H4.34961V10.157H5.48438C5.71224 10.157 5.9082 10.1986 6.07227 10.282C6.23763 10.3653 6.36458 10.4799 6.45312 10.6257C6.54167 10.7703 6.58594 10.9356 6.58594 11.1218C6.58594 11.3054 6.54167 11.4656 6.45312 11.6023C6.36458 11.739 6.23763 11.8458 6.07227 11.9226C5.9082 11.9981 5.71224 12.0359 5.48438 12.0359Z" fill="#485B6E"/><path d="M8.08984 12.0359H7.38281V11.5066H8.08984C8.1862 11.5066 8.26432 11.4903 8.32422 11.4578C8.38411 11.4252 8.42773 11.3803 8.45508 11.323C8.48372 11.2644 8.49805 11.1986 8.49805 11.1257C8.49805 11.0476 8.48372 10.9753 8.45508 10.9089C8.42773 10.8425 8.38411 10.7891 8.32422 10.7488C8.26432 10.7071 8.1862 10.6863 8.08984 10.6863H7.64062V13.0007H6.95508V10.157H8.08984C8.31771 10.157 8.51367 10.1986 8.67773 10.282C8.8431 10.3653 8.97005 10.4799 9.05859 10.6257C9.14714 10.7703 9.19141 10.9356 9.19141 11.1218C9.19141 11.3054 9.14714 11.4656 9.05859 11.6023C8.97005 11.739 8.8431 11.8458 8.67773 11.9226C8.51367 11.9981 8.31771 12.0359 8.08984 12.0359Z" fill="#485B6E"/><path d="M10.9375 10.157V13.0007H10.252V10.157H10.9375ZM11.793 10.157V10.6863H9.41602V10.157H11.793Z" fill="#485B6E"/></svg>';
const ItemOfInterestDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.79794 7.02868C5.79794 7.76473 7.3332 7.87333 7.3332 9.6833C7.3332 11.0106 6.37062 12.0001 5.03031 12.0001C3.60472 11.988 2.6665 10.721 2.6665 9.38164C2.6665 7.06488 4.85973 4 6.2244 4C6.56557 4 7.18699 4.24133 7.18699 4.65159C7.18699 5.06185 5.79794 5.77377 5.79794 7.02868Z" fill="#485B6E"/><path d="M11.7979 7.02868C11.7979 7.76473 13.3332 7.87333 13.3332 9.6833C13.3332 11.0106 12.3706 12.0001 11.0303 12.0001C9.60472 11.988 8.6665 10.721 8.6665 9.38164C8.6665 7.06488 10.8597 4 12.2244 4C12.5656 4 13.187 4.24133 13.187 4.65159C13.187 5.06185 11.7979 5.77377 11.7979 7.02868Z" fill="#485B6E"/></svg>';
const OtherDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.3335 3.33398C1.3335 2.22941 2.22893 1.33398 3.3335 1.33398H5.3335C6.43807 1.33398 7.3335 2.22941 7.3335 3.33398V5.33398C7.3335 6.43855 6.43807 7.33398 5.3335 7.33398H3.3335C2.22893 7.33398 1.3335 6.43855 1.3335 5.33398V3.33398ZM3.3335 2.66732C2.96531 2.66732 2.66683 2.96579 2.66683 3.33398V5.33398C2.66683 5.70217 2.96531 6.00065 3.3335 6.00065H5.3335C5.70169 6.00065 6.00016 5.70217 6.00016 5.33398V3.33398C6.00016 2.96579 5.70169 2.66732 5.3335 2.66732H3.3335ZM10.4536 2.08399C10.9535 1.08398 12.3802 1.08399 12.88 2.08399L14.5228 5.37078C14.9734 6.27241 14.3183 7.33398 13.3096 7.33398H10.0241C9.01541 7.33398 8.36023 6.27241 8.81087 5.37078L10.4536 2.08399ZM11.6521 2.67093C11.6521 2.67093 11.6495 2.67369 11.6463 2.68009L10.0035 5.96689C10.0012 5.97163 10.0004 5.97517 10.0004 5.97517L10.0002 5.97775C10.0003 5.97978 10.0012 5.98429 10.0045 5.98971C10.0079 5.99514 10.0115 5.9979 10.0132 5.99887L10.0154 5.9998C10.0154 5.9998 10.0188 6.00065 10.0241 6.00065H13.3096C13.3148 6.00065 13.3182 5.9998 13.3182 5.9998L13.3197 5.99927L13.3205 5.99887C13.3222 5.9979 13.3258 5.99514 13.3291 5.98971C13.3325 5.98429 13.3334 5.97978 13.3335 5.97774L13.3333 5.97517C13.3333 5.97517 13.3325 5.97163 13.3301 5.96689L11.6874 2.68009C11.6842 2.67369 11.6816 2.67093 11.6816 2.67093L11.6806 2.67015C11.6806 2.67015 11.6748 2.66732 11.6668 2.66732C11.6588 2.66732 11.653 2.67015 11.653 2.67015L11.6521 2.67093ZM4.3335 10.0007C3.41302 10.0007 2.66683 10.7468 2.66683 11.6673C2.66683 12.5878 3.41302 13.334 4.3335 13.334C5.25397 13.334 6.00016 12.5878 6.00016 11.6673C6.00016 10.7468 5.25397 10.0007 4.3335 10.0007ZM1.3335 11.6673C1.3335 10.0105 2.67664 8.66732 4.3335 8.66732C5.99035 8.66732 7.3335 10.0105 7.3335 11.6673C7.3335 13.3242 5.99035 14.6673 4.3335 14.6673C2.67664 14.6673 1.3335 13.3242 1.3335 11.6673Z" fill="#485B6E"/></svg>';
const VideoDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.00016 5.87015C6.00016 5.34653 6.57613 5.0273 7.02016 5.30482L10.429 7.43532C10.8467 7.69643 10.8467 8.30487 10.429 8.56598L7.02016 10.6965C6.57613 10.974 6.00016 10.6548 6.00016 10.1312V5.87015ZM7.3335 7.07298L8.81777 8.00065L7.3335 8.92832V7.07298Z" fill="#485B6E"/><path fill-rule="evenodd" clip-rule="evenodd" d="M14.6668 8.00065C14.6668 11.6825 11.6821 14.6673 8.00016 14.6673C4.31826 14.6673 1.3335 11.6825 1.3335 8.00065C1.3335 4.31875 4.31826 1.33398 8.00016 1.33398C11.6821 1.33398 14.6668 4.31875 14.6668 8.00065ZM13.3335 8.00065C13.3335 10.9462 10.9457 13.334 8.00016 13.334C5.05464 13.334 2.66683 10.9462 2.66683 8.00065C2.66683 5.05513 5.05464 2.66732 8.00016 2.66732C10.9457 2.66732 13.3335 5.05513 13.3335 8.00065Z" fill="#485B6E"/></svg>';
const WordDocTypeIcon = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.6665 2.00065C2.6665 1.63246 2.96498 1.33398 3.33317 1.33398H8.6665C8.84332 1.33398 9.01288 1.40422 9.13791 1.52925L13.1379 5.52925C13.2629 5.65427 13.3332 5.82384 13.3332 6.00065V14.0007C13.3332 14.3688 13.0347 14.6673 12.6665 14.6673H3.33317C2.96498 14.6673 2.6665 14.3688 2.6665 14.0007V2.00065ZM3.99984 2.66732V13.334H11.9998V6.66732H8.6665C8.29831 6.66732 7.99984 6.36884 7.99984 6.00065V2.66732H3.99984ZM9.33317 3.61013L11.057 5.33398H9.33317V3.61013Z" fill="#485B6E"/><path d="M5.15234 12.9007H4.52148L4.52539 12.3734H5.15234C5.28255 12.3734 5.39258 12.3421 5.48242 12.2796C5.57357 12.2171 5.64258 12.124 5.68945 12.0003C5.73763 11.8753 5.76172 11.7217 5.76172 11.5394V11.4164C5.76172 11.2796 5.74805 11.1598 5.7207 11.057C5.69466 10.9528 5.6556 10.8662 5.60352 10.7972C5.55143 10.7269 5.48633 10.6742 5.4082 10.639C5.33138 10.6039 5.24284 10.5863 5.14258 10.5863H4.50977V10.057H5.14258C5.33529 10.057 5.51172 10.0902 5.67188 10.1566C5.83333 10.2217 5.97266 10.3154 6.08984 10.4378C6.20833 10.5589 6.29948 10.7028 6.36328 10.8695C6.42839 11.0348 6.46094 11.2184 6.46094 11.4203V11.5394C6.46094 11.7399 6.42839 11.9235 6.36328 12.0902C6.29948 12.2569 6.20898 12.4007 6.0918 12.5218C5.97461 12.6429 5.83594 12.7367 5.67578 12.8031C5.51693 12.8682 5.34245 12.9007 5.15234 12.9007ZM4.91406 10.057V12.9007H4.22852V10.057H4.91406Z" fill="#485B6E"/><path d="M9.22461 11.4222V11.5375C9.22461 11.7549 9.19401 11.9502 9.13281 12.1234C9.07292 12.2953 8.98763 12.4424 8.87695 12.5648C8.76628 12.6859 8.63542 12.779 8.48438 12.8441C8.33333 12.9079 8.16667 12.9398 7.98438 12.9398C7.80078 12.9398 7.63281 12.9079 7.48047 12.8441C7.32943 12.779 7.19792 12.6859 7.08594 12.5648C6.97526 12.4424 6.88932 12.2953 6.82812 12.1234C6.76823 11.9502 6.73828 11.7549 6.73828 11.5375V11.4222C6.73828 11.2048 6.76823 11.0095 6.82812 10.8363C6.88932 10.6631 6.97461 10.516 7.08398 10.3949C7.19466 10.2725 7.32552 10.1794 7.47656 10.1156C7.62891 10.0505 7.79688 10.0179 7.98047 10.0179C8.16276 10.0179 8.32943 10.0505 8.48047 10.1156C8.63281 10.1794 8.76432 10.2725 8.875 10.3949C8.98568 10.516 9.07161 10.6631 9.13281 10.8363C9.19401 11.0095 9.22461 11.2048 9.22461 11.4222ZM8.5293 11.5375V11.4183C8.5293 11.2777 8.51693 11.154 8.49219 11.0472C8.46875 10.9391 8.43359 10.8486 8.38672 10.7757C8.33984 10.7028 8.2819 10.6481 8.21289 10.6117C8.14518 10.5739 8.06771 10.555 7.98047 10.555C7.88932 10.555 7.8099 10.5739 7.74219 10.6117C7.67448 10.6481 7.61784 10.7028 7.57227 10.7757C7.52669 10.8486 7.49219 10.9391 7.46875 11.0472C7.44661 11.154 7.43555 11.2777 7.43555 11.4183V11.5375C7.43555 11.6768 7.44661 11.8005 7.46875 11.9085C7.49219 12.0153 7.52669 12.1058 7.57227 12.18C7.61914 12.2542 7.67643 12.3102 7.74414 12.348C7.81315 12.3858 7.89323 12.4046 7.98438 12.4046C8.07161 12.4046 8.14909 12.3858 8.2168 12.348C8.28451 12.3102 8.34115 12.2542 8.38672 12.18C8.43359 12.1058 8.46875 12.0153 8.49219 11.9085C8.51693 11.8005 8.5293 11.6768 8.5293 11.5375Z" fill="#485B6E"/><path d="M11.1973 11.9378H11.8809C11.8717 12.1358 11.8184 12.3102 11.7207 12.4613C11.623 12.6123 11.4876 12.7302 11.3145 12.8148C11.1426 12.8981 10.9395 12.9398 10.7051 12.9398C10.515 12.9398 10.3451 12.9079 10.1953 12.8441C10.0469 12.7803 9.92057 12.6885 9.81641 12.5687C9.71354 12.4489 9.63477 12.3037 9.58008 12.1332C9.52669 11.9626 9.5 11.7705 9.5 11.557V11.4027C9.5 11.1891 9.52799 10.9971 9.58398 10.8265C9.64128 10.6546 9.72201 10.5088 9.82617 10.389C9.93164 10.2679 10.0579 10.1755 10.2051 10.1117C10.3522 10.0479 10.5156 10.016 10.6953 10.016C10.9427 10.016 11.1517 10.0602 11.3223 10.1488C11.4928 10.2373 11.625 10.3591 11.7188 10.514C11.8125 10.6677 11.8678 10.8428 11.8848 11.0394H11.2012C11.1986 10.9326 11.1803 10.8434 11.1465 10.7718C11.1126 10.6989 11.0592 10.6442 10.9863 10.6078C10.9134 10.5713 10.8164 10.5531 10.6953 10.5531C10.6107 10.5531 10.5371 10.5687 10.4746 10.6C10.4121 10.6312 10.36 10.6807 10.3184 10.7484C10.2767 10.8161 10.2454 10.904 10.2246 11.0121C10.2051 11.1188 10.1953 11.2477 10.1953 11.3988V11.557C10.1953 11.708 10.2044 11.8369 10.2227 11.9437C10.2409 12.0505 10.2702 12.1377 10.3105 12.2054C10.3509 12.2731 10.403 12.3233 10.4668 12.3558C10.5319 12.3871 10.6113 12.4027 10.7051 12.4027C10.8092 12.4027 10.8971 12.3864 10.9688 12.3539C11.0404 12.32 11.0957 12.2692 11.1348 12.2015C11.1738 12.1325 11.1947 12.0446 11.1973 11.9378Z" fill="#485B6E"/></svg>';
const DocumentReadStatus = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.99935" cy="8.00228" r="3.33333" fill="#DCE5E9"/></svg>';
const DocumentNotReadStatus = '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="7.99935" cy="8.00228" r="3.33333" fill="#1479CC"/></svg>';
const CopyrightIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-copyright"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M16 15a2 2 0 01-2 2h-3a3 3 0 01-3-3v-4a3 3 0 013-3h3a2 2 0 012 2v.5a1 1 0 11-2 0V9h-3a1 1 0 00-1 1v4a1 1 0 001 1h3v-.5a1 1 0 112 0v.5zm6-3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-10 8a8 8 0 100-16 8 8 0 000 16z"/></svg>';
const DocumentIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-doc"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M8 4a1 1 0 00-1 1v14a1 1 0 001 1h8a1 1 0 001-1v-9h-3a3 3 0 01-3-3V4H8zm5 1.414L15.586 8H14a1 1 0 01-1-1V5.414zM5 5a3 3 0 013-3h4.414L19 8.586V19a3 3 0 01-3 3H8a3 3 0 01-3-3V5z"/></svg>';
const MailIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-mail"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M19 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V7a3 3 0 00-3-3zM5 6h14a1 1 0 011 1l-8 4.88L4 7a1 1 0 011-1zm15 11a1 1 0 01-1 1H5a1 1 0 01-1-1V9.28l7.48 4.57a1 1 0 001 0L20 9.28V17z"/></svg>';
const SwitchIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-switch"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M7.707 4.707a1 1 0 00-1.414-1.414l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414-1.414L5.414 9H13a1 1 0 100-2H5.414l2.293-2.293zm8.586 14.586a1 1 0 001.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 00-1.414 1.414L18.586 15H11a1 1 0 100 2h7.586l-2.293 2.293z"/></svg>';
const DownloadIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-download"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 2a1 1 0 011 1v11.586l1.293-1.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 111.414-1.414L11 14.586V3a1 1 0 011-1zM3 21a1 1 0 011-1h16a1 1 0 110 2H4a1 1 0 01-1-1z"/></svg>';
const OrderDocIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-order-doc"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M8 4a1 1 0 00-1 1v14a1 1 0 001 1h.674c.356.75.841 1.426 1.427 2H8a3 3 0 01-3-3V5a3 3 0 013-3h4.414L19 8.586v2.669a6.972 6.972 0 00-2-.965V10h-3a3 3 0 01-3-3V4H8zm5 1.414L15.586 8H14a1 1 0 01-1-1V5.414z"/><path class="primary" d="M17.707 16.707a1 1 0 00-1.414-1.414L14.5 17.086l-.793-.793a1 1 0 00-1.414 1.414l1.5 1.5a1 1 0 001.414 0l2.5-2.5z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M15 11a6 6 0 100 12 6 6 0 000-12zm-4 6a4 4 0 118 0 4 4 0 01-8 0z"/></svg>';
const OpenInNewTabIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-open-in-new-tab"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M14 5a1 1 0 110-2h6a1 1 0 011 1v6a1 1 0 11-2 0V6.414l-8.293 8.293a1 1 0 01-1.414-1.414L17.586 5H14zM3 6a1 1 0 011-1h6.923a1 1 0 110 2H5v12h12v-7.077a1 1 0 112 0V20a1 1 0 01-1 1H4a1 1 0 01-1-1V6z"/></svg>';
const CommentsIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-comments"><path class="primary" d="M7 10a1 1 0 011-1h8a1 1 0 010 2H8a1 1 0 01-1-1zM8 13a1 1 0 000 2h6a1 1 0 000-2H8z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4.929 19.071A9.968 9.968 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.987 9.987 0 01-4.154 8.114A9.955 9.955 0 0112 22H4.414c-.89 0-1.337-1.077-.707-1.707L4.93 19.07zm12.145-.886a8 8 0 10-9.857.228c.35.262.417.781.108 1.09L6.828 20H12c1.926 0 3.693-.68 5.074-1.815z"/></svg>';
const DuplicateIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-duplicate"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M10 2a3 3 0 00-3 3v9a3 3 0 003 3h8a3 3 0 003-3V5a3 3 0 00-3-3h-8zM9 5a1 1 0 011-1h8a1 1 0 011 1v9a1 1 0 01-1 1h-8a1 1 0 01-1-1V5z"/><path class="primary" d="M5 9a1 1 0 011-1V6a3 3 0 00-3 3v10a3 3 0 003 3h8a3 3 0 003-3h-2a1 1 0 01-1 1H6a1 1 0 01-1-1V9z"/></svg>';
const PrintIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-print"><path class="primary" d="M14.2 16a1 1 0 01-1 1h-2.4a1 1 0 110-2h2.4a1 1 0 011 1z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M6 6a3 3 0 013-3h6a3 3 0 013 3v1h1a3 3 0 013 3v4a3 3 0 01-3 3h-1v1a3 3 0 01-3 3H9a3 3 0 01-3-3v-1H5a3 3 0 01-3-3v-4a3 3 0 013-3h1V6zm2 1h8V6a1 1 0 00-1-1H9a1 1 0 00-1 1v1zm-2 8v-1a3 3 0 013-3h6a3 3 0 013 3v1h1a1 1 0 001-1v-4a1 1 0 00-1-1H5a1 1 0 00-1 1v4a1 1 0 001 1h1zm10-1a1 1 0 00-1-1H9a1 1 0 00-1 1v4a1 1 0 001 1h6a1 1 0 001-1v-4z"/></svg>';
const StarIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-star"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 2a1 1 0 01.878.521l2.771 5.08 5.03.915a1 1 0 01.528 1.691l-3.636 3.636.915 5.493a1 1 0 01-1.328 1.104L12 18.564 6.842 20.44a1 1 0 01-1.328-1.104l.915-5.493-3.636-3.636a1 1 0 01.528-1.69l5.03-.915 2.771-5.08A1 1 0 0112 2zm0 3.088l-2.122 3.89a1 1 0 01-.7.506l-3.621.659 2.65 2.65a1 1 0 01.28.871l-.719 4.31 3.89-1.414a1 1 0 01.684 0l3.89 1.415-.718-4.31a1 1 0 01.279-.872l2.65-2.65-3.622-.66a1 1 0 01-.699-.504L12 5.089z"/></svg>';
const StarFilledIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-star-filled"><path class="primary" d="M12 2a1 1 0 01.878.521l2.771 5.08 5.03.915a1 1 0 01.528 1.691l-3.636 3.636.915 5.493a1 1 0 01-1.328 1.104L12 18.564 6.842 20.44a1 1 0 01-1.328-1.104l.915-5.493-3.636-3.636a1 1 0 01.528-1.69l5.03-.915 2.771-5.08A1 1 0 0112 2z"/></svg>';
const LibraryViewIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-library-view"><path class="primary" d="M18.309 4.48a2 2 0 00-2.449-1.412l-1.931.517a1.995 1.995 0 00-1.414 2.444l1.396 5.201A9.643 9.643 0 0115.92 11l-1.474-5.488 1.932-.516 1.671 6.226c.814.177 1.58.452 2.284.794L18.308 4.48z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M11.997 5.016v6.847c-.735.327-1.407.729-2 1.173v-8.02H7.999v9.977h.07c-.073.104-.143.21-.21.316C7.378 16.07 7 17.002 7 18c0 .998.379 1.93.858 2.69.06.098.125.194.191.29H8c-.365 0-.706-.098-1-.268-.294.17-.636.267-1 .267h-2C2.895 20.98 2 20.086 2 18.984V7.012c0-1.102.895-1.996 2-1.996h1.999c0-1.102.895-1.995 2-1.995h1.999c1.104 0 2 .893 2 1.995zM6 14.993V7.012h-2v7.981h2zm-2 1.995h2v1.996h-2v-1.996z"/><path class="primary" d="M16 20a2 2 0 100-4 2 2 0 000 4z"/><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M16 23c3.866 0 7-3 7-5s-3.134-5-7-5-7 3-7 5 3.134 5 7 5zm5-5a.61.61 0 00-.035-.143 2.03 2.03 0 00-.207-.416c-.217-.345-.567-.742-1.047-1.121C18.744 15.557 17.42 15 16 15c-1.42 0-2.744.557-3.71 1.32-.48.379-.83.776-1.047 1.12a2.03 2.03 0 00-.208.416A.61.61 0 0011 18a.61.61 0 00.035.143c.036.105.1.246.207.416.217.345.567.742 1.047 1.121.967.763 2.29 1.32 3.711 1.32 1.42 0 2.744-.557 3.71-1.32.48-.379.83-.776 1.047-1.12a2.03 2.03 0 00.208-.416A.61.61 0 0021 18z"/></svg>';
const ClearIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-clear"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707a1 1 0 010-1.414z"/></svg>';
const SettingsIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-settings"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M7.248 4.23a2.578 2.578 0 002.618-1.084 2.578 2.578 0 014.268 0 2.578 2.578 0 002.618 1.084 2.578 2.578 0 013.018 3.018 2.578 2.578 0 001.084 2.619 2.578 2.578 0 010 4.266 2.578 2.578 0 00-1.084 2.62 2.578 2.578 0 01-3.018 3.017 2.578 2.578 0 00-2.618 1.085 2.578 2.578 0 01-4.268 0 2.578 2.578 0 00-2.618-1.085 2.578 2.578 0 01-3.018-3.018 2.578 2.578 0 00-1.084-2.618 2.578 2.578 0 010-4.267 2.578 2.578 0 001.084-2.62A2.578 2.578 0 017.248 4.23zm5.133-.073a.578.578 0 00-.86.111 4.578 4.578 0 01-4.65 1.926.578.578 0 00-.676.676 4.578 4.578 0 01-1.926 4.65.578.578 0 000 .958 4.578 4.578 0 011.926 4.65.578.578 0 00.676.676 4.578 4.578 0 014.65 1.928c.23.338.728.338.957 0a4.578 4.578 0 014.65-1.927.578.578 0 00.677-.676 4.578 4.578 0 011.927-4.65.579.579 0 000-.957 4.576 4.576 0 01-1.927-4.65.578.578 0 00-.676-.677 4.578 4.578 0 01-4.65-1.927.583.583 0 00-.098-.11zM16 12a4 4 0 11-8 0 4 4 0 018 0zm-4 2a2 2 0 100-4 2 2 0 000 4z"/></svg>';
const ErrorIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-error"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0zm-4.293-3.707a1 1 0 010 1.414L13.414 12l2.293 2.293a1 1 0 01-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 01-1.414-1.414L10.586 12 8.293 9.707a1 1 0 011.414-1.414L12 10.586l2.293-2.293a1 1 0 011.414 0z"/></svg>';
const DraggableIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-draggable"><path class="primary" d="M8.5 10a2 2 0 100 4 2 2 0 000-4zm0 7a2 2 0 100 4 2 2 0 000-4zm7-10a2 2 0 100-4 2 2 0 000 4zm-7-4a2 2 0 100 4 2 2 0 000-4zm7 14a2 2 0 100 4 2 2 0 000-4zm0-7a2 2 0 100 4 2 2 0 000-4z"/></svg>';
const FolderOpenIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-folder-open"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M2 7C2 5.34315 3.34315 4 5 4H7.92963C8.93269 4 9.86939 4.5013 10.4258 5.3359L11.2383 6.5547C11.4238 6.8329 11.736 7 12.0704 7H16C17.6569 7 19 8.34315 19 10H22C22.328 10 22.6351 10.1608 22.8219 10.4304C23.0087 10.7 23.0515 11.044 22.9363 11.3511L19.9363 19.3511C19.79 19.7414 19.4168 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM17 10C17 9.44772 16.5523 9 16 9H12.0704C11.0673 9 10.1306 8.4987 9.57422 7.6641L8.76168 6.4453C8.57622 6.1671 8.26399 6 7.92963 6H5C4.44772 6 4 6.44772 4 7V17C4 17.5523 4.44772 18 5 18H5.307L8.06367 10.6489C8.21003 10.2586 8.58316 10 9 10H17ZM7.443 18H18.307L20.557 12H9.693L7.443 18Z"/></svg>';
const GridIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-grid"><path class="primary" d="M21 2H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1zM8 20H4V4h4v16zm6 0h-4V4h4v16zm6 0h-4V4h4v16z"/><path class="primary" d="M2 8h20v2H2V8zM2 14h20v2H2v-2z"/></svg>';
const BellIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-bell"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 2a1 1 0 011 1v1.06c1.262.156 2.27.614 3.045 1.302.954.846 1.464 1.957 1.735 3.016.363 1.419.327 2.965.272 3.87.08.04.159.087.237.139.41.273.734.672.98 1.166.48.959.731 2.396.731 4.447a1 1 0 01-1 1h-3.021c-.04.271-.114.575-.243.885a3.193 3.193 0 01-1.257 1.492C13.84 21.78 13.018 22 12 22s-1.839-.219-2.48-.623a3.193 3.193 0 01-1.256-1.492A3.742 3.742 0 018.021 19H5a1 1 0 01-1-1c0-2.051.251-3.488.73-4.447.247-.494.57-.893.98-1.166.08-.052.158-.099.238-.14-.055-.904-.091-2.45.272-3.87.271-1.06.78-2.17 1.735-3.017.776-.687 1.783-1.145 3.045-1.3V3a1 1 0 011-1zm-1.932 17c.013.039.027.077.043.115.09.216.233.416.478.57.25.159.679.315 1.411.315s1.161-.156 1.411-.314c.245-.155.389-.355.478-.57.016-.039.03-.077.043-.116h-3.864zm-2.1-6.63c.017.253.032.468.032.63a1 1 0 01-1 1 .3.3 0 00-.18.05c-.058.04-.172.14-.3.397-.22.44-.426 1.226-.496 2.553h11.951c-.069-1.327-.274-2.113-.494-2.553-.129-.256-.243-.357-.301-.396A.3.3 0 0017 14a1 1 0 01-1-1c0-.162.015-.377.032-.63.059-.86.148-2.174-.19-3.496-.209-.817-.564-1.518-1.124-2.016C14.173 6.375 13.339 6 12 6c-1.34 0-2.173.374-2.718.857-.56.497-.915 1.199-1.124 2.015-.339 1.323-.249 2.639-.19 3.497z"/></svg>';
const ExitIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-exit"><path class="primary" d="M7 2a3 3 0 00-3 3v3a1 1 0 002 0V5a1 1 0 011-1h10a1 1 0 011 1v14a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 10-2 0v3a3 3 0 003 3h10a3 3 0 003-3V5a3 3 0 00-3-3H7z"/><path class="primary" d="M4.293 12.707A1 1 0 015 11h7.59l-2.3-2.29A1.005 1.005 0 0111 6.996a1.004 1.004 0 01.71.294l4 4c.091.095.162.207.21.33a1 1 0 010 .76 1 1 0 01-.21.33l-4 4a1.002 1.002 0 01-1.639-.325 1 1 0 01.219-1.095l2.3-2.29H5a1 1 0 01-.707-.293z"/></svg>';
const RadioSelectedIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-radio-selected"><path class="primary" d="M12 17a5 5 0 100-10 5 5 0 000 10z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"/></svg>';
const RadioDefaultIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-radio-default"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/></svg>';
const CheckAlternateIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-check-alternate"><path class="primary" d="M14.72 8.79l-4.29 4.3-1.65-1.65a1 1 0 10-1.41 1.41l2.35 2.36a1 1 0 001.41 0l5-5a1.002 1.002 0 10-1.41-1.42zM12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"/></svg>';
const UploadIcon = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-upload"><path class="primary" fill-rule="evenodd" clip-rule="evenodd" d="M12 18a1 1 0 001-1V5.414l1.293 1.293a1 1 0 101.414-1.414l-3-3a1 1 0 00-1.414 0l-3 3a1 1 0 001.414 1.414L11 5.414V17a1 1 0 001 1zm-9 3a1 1 0 001 1h16a1 1 0 100-2H4a1 1 0 00-1 1z"/></svg>';


;// CONCATENATED MODULE: ./src/styles/colors.ts
// http://styles.aws-del-prd.copyright.com/colors
const Colors = {
    primary50: '#edf5fd',
    primary100: '#d6edff',
    primary200: '#aed7f4',
    primary300: '#7abaeb',
    primary400: '#429ce0',
    primary500: '#1479cc',
    primary600: '#005fb3',
    primary700: '#005299',
    primary800: '#004785',
    primary900: '#003270',
    secondary50: '#fff3e5',
    secondary100: '#ffe5c7',
    secondary200: '#fcd4a6',
    secondary300: '#fbb679',
    secondary400: '#f79b55',
    secondary500: '#f28321',
    secondary600: '#cd580a',
    secondary700: '#a84605',
    secondary800: '#893d0b',
    secondary900: '#702d00',
    neutral50: '#f5f8fa',
    neutral100: '#e9eff2',
    neutral200: '#dce6e9',
    neutral300: '#cfdbe3',
    neutral400: '#c1cdd7',
    neutral500: '#abbbc9',
    neutral600: '#6c8293',
    neutral700: '#495c6f',
    neutral800: '#2b3d4f',
    neutral900: '#141c24',
    success50: '#ecf3ed',
    success100: '#c9deca',
    success200: '#a3c7a4',
    success300: '#7db081',
    success400: '#5b9a5e',
    success500: '#38853c',
    success600: '#327735',
    success700: '#29612b',
    success800: '#1e4821',
    success900: '#142f15',
    warning50: '#fff9e5',
    warning100: '#fff1c2',
    warning200: '#ffe68a',
    warning300: '#fdd349',
    warning400: '#fdc50d',
    warning500: '#f6b709',
    warning600: '#efa70b',
    warning700: '#b88700',
    warning800: '#8a6500',
    warning900: '#5c4300',
    error50: '#f8ecec',
    error100: '#edc5c5',
    error200: '#e09a9a',
    error300: '#d37373',
    error400: '#c74d4d',
    error500: '#bb2525',
    error600: '#aa2222',
    error700: '#881b1b',
    error800: '#661515',
    error900: '#440e0e',
    persianGreen50: '#ebfff3',
    persianGreen100: '#d1fae1',
    persianGreen200: '#a8f5cf',
    persianGreen300: '#78e3b6',
    persianGreen400: '#51c8a2',
    persianGreen500: '#21a185',
    persianGreen600: '#188c7e',
    persianGreen700: '#107573',
    persianGreen800: '#0a575c',
    persianGreen900: '#05343e',
    wisteriaPurple50: '#fff0fe',
    wisteriaPurple100: '#fae0f9',
    wisteriaPurple200: '#f3c2f5',
    wisteriaPurple300: '#d999e1',
    wisteriaPurple400: '#b678c4',
    wisteriaPurple500: '#874b9b',
    wisteriaPurple600: '#6d3687',
    wisteriaPurple700: '#512470',
    wisteriaPurple800: '#3b165a',
    wisteriaPurple900: '#230a3d',
    salsaRed50: '#fef4f1',
    salsaRed100: '#fee2d7',
    salsaRed200: '#febdae',
    salsaRed300: '#fc8f83',
    salsaRed400: '#f96666',
    salsaRed500: '#f63145',
    salsaRed600: '#d32746',
    salsaRed700: '#b11b45',
    salsaRed800: '#8e103e',
    salsaRed900: '#520529'
};
/* harmony default export */ var colors = (Colors);

;// CONCATENATED MODULE: ./src/utils/htmlUtils.ts
function getTextWidth(text, font) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) {
        return null;
    }
    if (font) {
        context.font = font;
    }
    const metrics = context.measureText(text);
    return metrics.width;
}
function getFont(element) {
    const prop = ['font-style', 'font-variant', 'font-weight', 'font-size', 'font-family'];
    let font = '';
    for (const x in prop) {
        font += window.getComputedStyle(element, null).getPropertyValue(prop[x]) + ' ';
    }
    return font.trim() || '14px system-ui';
}
function offset(element) {
    var _a, _b;
    if (!element) {
        return { top: 0, left: 0 };
    }
    let top = 0;
    let left = 0;
    let offsetParent = element;
    while (offsetParent) {
        top += (_a = offsetParent.offsetTop) !== null && _a !== void 0 ? _a : 0;
        left += (_b = offsetParent.offsetLeft) !== null && _b !== void 0 ? _b : 0;
        offsetParent = offsetParent.offsetParent;
    }
    return { top, left };
}
/**
 * Position inserted into the document.body dropdown near to root element.
 * @param root HTMLElement
 * @param dropdown HTMLElement inserted into body
 */
function positionDropdown(root, dropdown, options) {
    var _a;
    // TODO: known issue: positioner doesn't properly handle horizontal scrolling
    const rootRect = root.getBoundingClientRect();
    const documentOffset = offset(root);
    const dropdownRect = dropdown.getBoundingClientRect();
    const shadowWidth = 2;
    if ((options === null || options === void 0 ? void 0 : options.adjustDropdownWidth) === false) {
        dropdown.style.width = dropdown.style.width || 'auto';
        let align = (_a = options.align) !== null && _a !== void 0 ? _a : 'auto';
        if (align === 'auto') {
            if (dropdownRect.width + rootRect.left > window.innerWidth) {
                align = 'right';
            }
            else {
                align = 'left';
            }
        }
        if (align === 'left') {
            dropdown.style.left = `${documentOffset.left}px`;
        }
        else {
            dropdown.style.left = `${rootRect.right - dropdownRect.width}px`;
        }
    }
    else {
        dropdown.style.width = `${rootRect.width}px`;
        dropdown.style.left = `${documentOffset.left + shadowWidth}px`;
    }
    if (window.innerHeight > rootRect.bottom + dropdownRect.height) {
        dropdown.style.maxHeight = undefined;
        dropdown.style.top = `${rootRect.bottom + 1}px`;
        dropdown.classList.remove('up');
    }
    else {
        const maxHeight = rootRect.top - 1;
        if (maxHeight < dropdownRect.height) {
            dropdown.style.maxHeight = `${maxHeight}px`;
        }
        const top = rootRect.top - 1 - dropdownRect.height;
        dropdown.style.top = `${top > 0 ? top : 0}px`;
        dropdown.classList.add('up');
    }
}
function createEvent(name, args) {
    try {
        return new Event(name, args);
    }
    catch (e) {
        console.warn(`Creating custom event due to error: ${e}`);
        return new CustomEvent(name, args);
    }
}
function animateAsync(element, keyframes, options) {
    return new Promise(r => {
        element.animate(keyframes, options).onfinish = () => {
            r();
        };
    });
}
/* harmony default export */ var htmlUtils = ({ getTextWidth, getFont, offset, animateAsync });

;// CONCATENATED MODULE: ./src/utils/urlExtensions.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
function toQueryString(obj) {
    if (!obj) {
        return '';
    }
    const searchParams = new URLSearchParams();
    Object.keys(obj).forEach(key => {
        if (obj[key] != undefined) {
            if (Array.isArray(obj[key])) {
                obj[key].forEach((k) => {
                    searchParams.append(key, k); // TODO: currently, only one nested is supported
                });
            }
            else {
                searchParams.append(key, obj[key]);
            }
        }
    });
    return searchParams.toString();
}

// EXTERNAL MODULE: ./src/libs/l10n.js
var l10n = __webpack_require__(916);
;// CONCATENATED MODULE: ./src/utils/localization.ts

function localize(s, ...args) {
    let result = s.toLocaleString();
    if (args) {
        args.unshift(result);
        result = format(result, ...args);
    }
    return result;
}
function format(s, ...args) {
    const replacer = (substring) => {
        const val = args[+substring.slice(1)];
        return val == null ? substring : val;
    };
    return s.replace(/\$\d+/g, replacer);
}

;// CONCATENATED MODULE: ./src/utils/applyCss.ts
function applyCSS(element, css) {
    if (!element || !css) {
        return;
    }
    for (const rule in css) {
        if (css.hasOwnProperty(rule)) {
            element.style[rule] = css[rule];
        }
    }
}

;// CONCATENATED MODULE: ./src/utils/injectStyles.ts
function injectStyles(name, styles) {
    const existingStyles = document.querySelector(`style[data-name=${name}]`);
    if (existingStyles) {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('data-name', name);
    document.head.appendChild(style);
    for (const selector in styles) {
        if (styles.hasOwnProperty(selector)) {
            try {
                style.sheet.insertRule(`${selector} {\n\r${styleToString(styles[selector])}\n\r}`, style.sheet.cssRules.length);
            }
            catch (e) {
                // ignore
            }
        }
    }
}
// https://stackoverflow.com/a/61410824/5197875
function styleToString(style) {
    return Object.keys(style).reduce((acc, key) => acc +
        key
            .split(/(?=[A-Z])/)
            .join('-')
            .toLowerCase() +
        ':' +
        style[key] +
        ';', '');
}

;// CONCATENATED MODULE: ./src/components/filters/inlineParameter.ts


class InlineParameter {
    constructor(options) {
        this._options = options;
        injectStyles('inline-parameter', {
            '.inline-parameter-component': {
                display: 'inline',
                alignItems: 'center',
                lineHeight: '16px'
            },
            '.inline-parameter-component > .inline-parameter-component__separator': {
                marginLeft: '8px',
                width: '1px',
                height: '12px',
                backgroundColor: '#DCE5E9',
                marginBottom: '-2px',
                display: 'inline-block'
            }
        });
    }
    render() {
        const root = document.createElement('div');
        root.classList.add('inline-parameter-component');
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        if (this._options.className) {
            root.classList.add(this._options.className);
        }
        const label = this.renderLabel();
        root.appendChild(label);
        const body = this.renderBody();
        root.appendChild(body);
        const infoContainer = this.renderInfo();
        root.appendChild(infoContainer);
        this.toggleIcon(this._options.icon, this._options.tooltip);
        if (!this._options.hideSeparator) {
            const separator = document.createElement('span');
            separator.classList.add('rup-overline', 'rup-overline--regular', 'inline-parameter-component__separator');
            root.appendChild(separator);
        }
        return root;
    }
    renderLabel() {
        const label = document.createElement('span');
        label.classList.add('rup-overline', 'rup-overline--regular');
        label.innerText = this._options.label + ': ';
        return label;
    }
    renderBody() {
        const value = (this._value = document.createElement('span'));
        value.classList.add('rup-overline', 'rup-overline--medium');
        return value;
    }
    renderInfo() {
        const infoContainer = (this._infoContainer = document.createElement('span'));
        return infoContainer;
    }
    setValue(value, asHTML = false) {
        if (asHTML) {
            this._value.innerHTML = value;
            this._value.setAttribute('title', this._value.innerText);
        }
        else {
            this._value.innerText = value;
            this._value.setAttribute('title', value);
        }
    }
    toggleIcon(icon, tooltip) {
        var _a;
        if (!icon) {
            (_a = this._info) === null || _a === void 0 ? void 0 : _a.remove();
        }
        else {
            this._info = this.createIcon(icon, tooltip);
            this._infoContainer.appendChild(this._info);
        }
    }
    createIcon(icon, tooltip) {
        if (!this._info) {
            this._info = document.createElement('span');
            this._info.classList.add('rup-icon', 'rup-icon--sm', 'tooltip-icon--warning');
            this._info.setAttribute('role', 'tooltip');
            if (tooltip) {
                this._info.setAttribute('title', tooltip);
            }
            this._info.innerHTML = icon;
        }
        this._info.setAttribute('title', tooltip);
        this._info.innerHTML = icon;
        this._value.appendChild(this._info);
        return this._info;
    }
}

;// CONCATENATED MODULE: ./src/components/filters/inlineParametersContainer.ts


class InlineParametersContainer {
    constructor(options) {
        this._options = options;
        injectStyles('inline-parameters-container', {
            '.inline-parameters-container': {
                display: 'inline-block',
                alignItems: 'center',
                flexWrap: 'wrap',
                lineHeight: '16px'
            },
            '.inline-parameters-container > *': {
                marginRight: '8px'
            },
            '.inline-parameters-container > *:last-child': {
                marginRight: '0'
            }
        });
    }
    render() {
        var _a;
        const root = document.createElement('div');
        root.classList.add('inline-parameters-container');
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        if (this._options.className) {
            root.classList.add(this._options.className);
        }
        if ((_a = this._options.children) === null || _a === void 0 ? void 0 : _a.length) {
            this._options.children.forEach(c => root.appendChild(c));
        }
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/header.ts

class Header {
    constructor(options) {
        this._options = options;
    }
    render() {
        const root = document.createElement('header');
        root.className = 'rup-global-header';
        applyCSS(root, this._options.css);
        const items = document.createElement('div');
        root.appendChild(items);
        this._options.items.forEach(i => {
            const item = i.render();
            items.appendChild(item);
        });
        return root;
    }
}

;// CONCATENATED MODULE: ./src/utils/mutationObserver.ts
function observeAppearance(element, callback) {
    if (!element.id) {
        throw new Error('Unique identifier is required for the element');
    }
    const observer = new MutationObserver(mutations => {
        if (mutations.some(r => Array.from(r.addedNodes).some(n => n instanceof HTMLElement && n.querySelector('#' + element.id) === element))) {
            callback();
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    return observer;
}

;// CONCATENATED MODULE: ./src/utils/generateUniqId.ts
let uniqId = 0;
function generateUniqId(prefix, suffix = '') {
    return `${prefix}${uniqId++}${suffix}`;
}

;// CONCATENATED MODULE: ./src/components/header/items/itemBase.ts
class ItemBase {
    constructor(options) {
        this._options = options;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/itemsGroupBase.ts


class ItemsGroupBase extends ItemBase {
    constructor(options) {
        super(options);
    }
    render() {
        const root = this.getRootElement();
        applyCSS(root, this._options.css);
        this.renderItems(root);
        return root;
    }
    renderItems(root) {
        this._options.items
            .filter(i => i)
            .forEach(i => {
            const itemElement = i.render();
            root.appendChild(itemElement);
        });
    }
}

;// CONCATENATED MODULE: ./src/utils/triggerEvent.ts
function triggerEvent(eventName, target) {
    const event = new Event(eventName);
    (target !== null && target !== void 0 ? target : window).dispatchEvent(event);
}

;// CONCATENATED MODULE: ./src/components/common/icon.ts


class Icon {
    constructor(options) {
        this._options = options;
    }
    render() {
        let root;
        if (this._options.iconUrl) {
            root = document.createElement('img');
            root.setAttribute('src', this._options.iconUrl);
            root.addEventListener('load', () => triggerEvent('resize'), { once: true });
        }
        else if (this._options.svg) {
            if (typeof this._options.svg === 'string') {
                const wrapper = document.createElement('div');
                wrapper.innerHTML = this._options.svg;
                root = wrapper.firstElementChild;
            }
            else {
                const o = this._options.svg;
                root = document.createElement('svg');
                root.setAttribute('width', o.width);
                root.setAttribute('height', o.height);
                root.setAttribute('viewBox', o.viewBox);
                root.setAttribute('fill', o.fill);
                root.innerHTML = o.paths.map(p => `<path d="${p.d}" fill="${p.fill}"></path>`).join('');
            }
        }
        else {
            return document.createElement('div');
        }
        applyCSS(root, this._options.css);
        return root;
    }
}

;// CONCATENATED MODULE: ./src/utils/closestParentElement.ts
function closestParentElement(element, selector) {
    if (typeof element.closest === 'function') {
        return element.closest(selector);
    }
    if (!element.matches) {
        return element;
    }
    let parent = element;
    while (parent && !parent.matches(selector)) {
        parent = parent.parentElement;
    }
    return parent;
}

;// CONCATENATED MODULE: ./src/components/header/items/dropdown.ts




class Dropdown extends ItemBase {
    constructor(options) {
        super(options);
        options.classNames = Object.assign({ rootClassName: 'dropdown' }, options.classNames);
        this.handleCloseEvents = this.handleCloseEvents.bind(this);
    }
    render() {
        var _a, _b;
        const root = document.createElement('div');
        root.className = (_b = (_a = this._options.classNames) === null || _a === void 0 ? void 0 : _a.rootClassName) !== null && _b !== void 0 ? _b : '';
        root.setAttribute('title', this._options.title || '');
        applyCSS(root, this._options.css);
        const button = (this._button = this.getButton());
        root.appendChild(button);
        const dropdown = (this._dropdown = this.getDropdown());
        root.appendChild(dropdown);
        button.addEventListener('click', () => {
            this.toggleDropdownList();
            return false;
        });
        return root;
    }
    getButton() {
        var _a, _b;
        const root = document.createElement('button');
        root.className = (_b = (_a = this._options.classNames) === null || _a === void 0 ? void 0 : _a.buttonClassName) !== null && _b !== void 0 ? _b : '';
        root.setAttribute('title', this._options.title || '');
        root.setAttribute('type', 'button');
        root.setAttribute('aria-expanded', 'false');
        root.setAttribute('aria-label', this._options.ariaLabel);
        if (this._options.icon) {
            const icon = new Icon(this._options.icon);
            root.appendChild(icon.render());
        }
        if (this._options.text) {
            const text = document.createTextNode(this._options.text);
            if (this._options.textBeforeIcon) {
                root.prepend(text);
            }
            else {
                root.appendChild(text);
            }
        }
        return root;
    }
    getDropdown() {
        var _a, _b;
        const root = document.createElement('nav');
        root.className = (_b = (_a = this._options.classNames) === null || _a === void 0 ? void 0 : _a.dropdownClassName) !== null && _b !== void 0 ? _b : '';
        root.classList.add('visuallyhidden');
        root.setAttribute('aria-label', this._options.ariaLabel);
        root.setAttribute('aria-labelledby', 'rup-menu-dropdown');
        this.fillWithDropdownItems(root, this._options.items);
        return root;
    }
    fillWithDropdownItems(dropdown, items, isGroupItem) {
        items === null || items === void 0 ? void 0 : items.forEach(i => {
            var _a;
            const item = ((_a = i.items) === null || _a === void 0 ? void 0 : _a.length)
                ? this.getDropdownItemGroupElement(i)
                : this.getDropdownItemElement(i, isGroupItem);
            dropdown.appendChild(item);
        });
    }
    getDropdownItemElement(item, isGroupItem) {
        const root = document.createElement('a');
        if (item.url) {
            root.href = item.url;
        }
        if (typeof item.action === 'function') {
            root.addEventListener('click', item.action);
        }
        if (item.icon) {
            const icon = new Icon(item.icon);
            root.appendChild(icon.render());
        }
        if (item.text) {
            root.innerText = item.text;
        }
        if (item.title) {
            root.setAttribute('title', item.title);
        }
        if (isGroupItem) {
            const listItem = document.createElement('li');
            listItem.appendChild(root);
            return listItem;
        }
        return root;
    }
    getDropdownItemGroupElement(group) {
        var _a, _b;
        const root = document.createElement('ul');
        this.fillWithDropdownItems(root, group.items, true);
        if (group.caption) {
            const wrapper = document.createElement('div');
            const caption = document.createElement('span');
            caption.className = (_b = (_a = this._options.classNames) === null || _a === void 0 ? void 0 : _a.dropdownGroupCaptionClassName) !== null && _b !== void 0 ? _b : '';
            caption.innerText = group.caption;
            wrapper.appendChild(caption);
            wrapper.appendChild(root);
            return wrapper;
        }
        return root;
    }
    toggleDropdownList(hide) {
        const closeEvents = ['mousedown', 'resize'];
        hide = hide == null ? this._button.getAttribute('aria-expanded') === 'true' : hide;
        this._button.setAttribute('aria-expanded', (!hide).toString());
        this._dropdown.classList.toggle('visuallyhidden', hide);
        if (hide) {
            closeEvents.forEach(eventName => window.removeEventListener(eventName, this.handleCloseEvents));
        }
        else {
            closeEvents.forEach(eventName => window.addEventListener(eventName, this.handleCloseEvents));
        }
    }
    handleCloseEvents(e) {
        var _a;
        if (e.target == this._button) {
            return true;
        }
        if (e.type === 'resize') {
            this.toggleDropdownList(true);
        }
        else {
            const root = closestParentElement(e.target, `.${(_a = this._options.classNames) === null || _a === void 0 ? void 0 : _a.rootClassName}`);
            if (root == null) {
                this.toggleDropdownList(true);
            }
        }
        return true;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/applicationMenuGroup.ts







class ApplicationMenuGroup extends ItemsGroupBase {
    constructor(options) {
        super(options);
        this._itemsWidthMap = {};
        this.updateItems = this.updateItems.bind(this);
        window.addEventListener('resize', this.updateItems);
        injectStyles('application-menu-group', {
            '.rup-global-header__application-menu > .rup-global-header__application-menu-dropdown': {
                borderRadius: '0.25rem'
            },
            '.rup-global-header__application-menu > .dropdown:not(.open) > .rup-global-header__application-menu-dropdown-options': {
                display: 'none'
            }
        });
    }
    dispose() {
        window.removeEventListener('resize', this.updateItems);
    }
    getRootElement() {
        const root = (this._root = document.createElement('nav'));
        root.id = generateUniqId('rup-global-header__application-menu');
        root.className = 'rup-global-header__application-menu';
        root.setAttribute('aria-labelledby', 'rup-app-menu-desc');
        observeAppearance(root, this.updateItems);
        return root;
    }
    renderItems(root) {
        super.renderItems(root);
        this.fillItemsMap(root.children);
        const moreButton = this.createMoreButton();
        root.append(moreButton);
    }
    createMoreButton() {
        var _a, _b;
        const dropdown = new Dropdown({
            items: [],
            classNames: {
                rootClassName: 'rup-global-header__application-menu-dropdown',
                buttonClassName: 'rup-global-header__application-menu-dropdown-trigger rup-global-header__application-menu-item',
                dropdownClassName: 'rup-global-header__application-menu-dropdown-options'
            },
            icon: { svg: ChevronDownIcon },
            text: (_a = this._options.moreText) !== null && _a !== void 0 ? _a : 'More',
            textBeforeIcon: true,
            title: (_b = this._options.moreText) !== null && _b !== void 0 ? _b : 'More'
        });
        const root = (this._moreButton = dropdown.render());
        root.classList.add('visuallyhidden');
        this._moreDropdown = root.querySelector('.rup-global-header__application-menu-dropdown-options');
        return root;
    }
    updateItems() {
        const rootWidth = this._root.clientWidth;
        let itemsWidth = 0;
        this._moreDropdown.innerHTML = '';
        let selectMoreButton = false;
        const indexes = this._options.items.map((item, index) => (item == null ? null : index)).filter(i => i != null);
        const totalWidth = indexes.reduce((sum, i) => sum + this._itemsWidthMap[i].width, 0);
        // if all items can't fit in the nav bar more button will be rendered
        if (totalWidth > rootWidth) {
            itemsWidth += this._moreButton.clientWidth;
        }
        indexes.forEach(index => {
            const element = this._itemsWidthMap[index].element;
            itemsWidth += this._itemsWidthMap[index].width;
            if (itemsWidth <= rootWidth) {
                this._moreButton.before(element);
            }
            else {
                this._moreDropdown.append(element);
                selectMoreButton || (selectMoreButton = element.classList.contains('rup-global-header__application-menu-item--selected'));
            }
        });
        this._moreButton.classList.toggle('visuallyhidden', !this._moreDropdown.children.length);
        this._moreButton.classList.toggle('rup-global-header__application-menu-item--selected', selectMoreButton);
    }
    fillItemsMap(items) {
        const tempContainer = document.createElement('div');
        applyCSS(tempContainer, {
            position: 'absolute',
            visibility: 'hidden',
            top: '-9999px',
            display: 'flex'
        });
        document.body.append(tempContainer);
        for (let i = 0; i < items.length; i++) {
            const clone = items[i].cloneNode(true);
            tempContainer.append(clone);
            this._itemsWidthMap[i] = {
                width: tempContainer.lastElementChild.clientWidth,
                element: items[i]
            };
        }
        tempContainer.remove();
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/applicationMenuItem.ts




class ApplicationMenuItem extends ItemBase {
    constructor(options) {
        super(options);
        injectStyles('rup-global-header__application-menu-item', {
            '.rup-global-header__application-menu-item[disabled]': {
                cursor: 'not-allowed',
                color: colors.neutral500
            },
            '.rup-global-header__application-menu-item[disabled]:hover': {
                backgroundColor: 'inherit'
            }
        });
    }
    render() {
        const root = document.createElement('a');
        root.className = 'rup-global-header__application-menu-item';
        applyCSS(root, this._options.css);
        if (this._options.selected) {
            root.classList.add('rup-global-header__application-menu-item--selected');
        }
        root.setAttribute('title', this._options.title || this._options.text || '');
        root.innerText = this._options.text;
        if (!this._options.disabled) {
            if (this._options.url) {
                root.setAttribute('href', this._options.url);
            }
            if (typeof this._options.action === 'function') {
                root.addEventListener('click', this._options.action);
            }
        }
        else {
            root.setAttribute('disabled', 'disabled');
        }
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/appSwitcher.ts

class AppSwitcher extends Dropdown {
    constructor(options) {
        super(Object.assign({ classNames: {
                rootClassName: 'rup-global-header__app-switcher',
                buttonClassName: 'rup-global-header__app-switcher-trigger',
                dropdownClassName: 'rup-global-header__app-switcher-options',
                dropdownGroupCaptionClassName: 'rup-global-header__app-switcher-options-label'
            } }, options));
    }
    getDropdown() {
        const root = super.getDropdown();
        root.setAttribute('aria-labelledby', 'rup-switcher-app');
        root.setAttribute('aria-describedby', 'rup-gc-switcher-desc');
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/controlsGroup.ts

class ControlsGroup extends ItemsGroupBase {
    constructor(options) {
        super(options);
    }
    getRootElement() {
        const root = document.createElement('div');
        root.className = 'rup-global-header__controls';
        root.setAttribute('role', 'navigation');
        root.setAttribute('aria-label', this._options.ariaLabel);
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/globalControlsGroup.ts

class GlobalControlsGroup extends ItemsGroupBase {
    constructor(options) {
        super(options);
    }
    getRootElement() {
        const root = document.createElement('div');
        root.className = 'rup-global-header__global-controls';
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/localControlsGroup.ts

class LocalControlsGroup extends ItemsGroupBase {
    constructor(options) {
        super(options);
    }
    getRootElement() {
        const root = document.createElement('nav');
        root.className = 'rup-global-header__local-controls';
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/iconButton.ts



class IconButton extends ItemBase {
    constructor(options) {
        super(options);
    }
    render() {
        const root = document.createElement('button');
        root.setAttribute('id', this._options.id);
        root.setAttribute('type', 'button');
        root.setAttribute('title', this._options.title || this._options.text || '');
        root.setAttribute('aria-label', this._options.ariaLabel || this._options.text);
        applyCSS(root, this._options.css);
        if (typeof this._options.action === 'function') {
            root.addEventListener('click', this._options.action);
        }
        if (this._options.selected) {
            root.classList.add('selected');
        }
        const icon = new Icon(this._options.icon);
        root.appendChild(icon.render());
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/liveChat.ts


class LiveChat extends ItemBase {
    constructor(options) {
        super(options);
        this.offlineId = 'SFLiveChatOffline';
        options.action = this.open.bind(this);
    }
    render() {
        const button = new IconButton(this._options);
        if (this._options.endpoint &&
            this._options.buttonId &&
            this._options.depId &&
            this._options.orgId &&
            !LiveChat.initialized) {
            LiveChat.initialized = true;
            this.initialize();
        }
        return button.render();
    }
    initialize() {
        const script = document.createElement('script');
        script.onload = () => {
            if (!window.liveagent) {
                return;
            }
            if (!window._laq) {
                window._laq = [];
            }
            window._laq.push(() => {
                window.liveagent.showWhenOnline(this._options.buttonId, document.getElementById(this._options.buttonId));
                window.liveagent.showWhenOffline(this.offlineId, document.getElementById(this.offlineId));
            });
            window.liveagent.addCustomDetail('buttonType', 'Rightsfind');
            window.liveagent.addCustomDetail('firstName', this._options.firstName);
            window.liveagent.addCustomDetail('lastName', this._options.lastName);
            window.liveagent.addCustomDetail('email', this._options.email);
            window.liveagent.init(this._options.endpoint + '/chat', this._options.depId, this._options.orgId);
        };
        script.src = this._options.endpoint + '/content/g/js/45.0/deployment.js';
        document.head.appendChild(script);
        const onlineDiv = document.createElement('div');
        onlineDiv.id = this._options.buttonId;
        onlineDiv.style['display'] = 'none';
        document.body.appendChild(onlineDiv);
        const offlineDiv = document.createElement('div');
        offlineDiv.id = this.offlineId;
        document.body.appendChild(offlineDiv);
    }
    open() {
        if (!window.liveagent) {
            return;
        }
        const online = document.getElementById(this._options.buttonId);
        if (online.style['display'] === 'none') {
            alert(this._options.offlineMessage);
            return;
        }
        const origOpen = window.open;
        this.prepare();
        window.liveagent.startChat(this._options.buttonId);
        window.open = origOpen;
    }
    prepare() {
        const origOpen = window.open;
        window.open = (url, windowName, windowFeatures) => {
            const chatWindowHeight = 500;
            const chatWindowWidth = 500;
            const left = screen.availWidth - chatWindowWidth - 10;
            const top = screen.availHeight - chatWindowHeight - 60;
            windowFeatures =
                'width=' +
                    chatWindowWidth +
                    ',height=' +
                    chatWindowHeight +
                    ',status,resizable,left=' +
                    left +
                    ',top=' +
                    top +
                    'screenX=' +
                    left +
                    ',screenY=' +
                    top;
            return origOpen(url, windowName, windowFeatures);
        };
    }
}
LiveChat.initialized = false;

;// CONCATENATED MODULE: ./src/components/header/items/logo.ts



class Logo extends ItemBase {
    constructor(options) {
        super(options);
    }
    render() {
        const root = document.createElement('a');
        root.className = 'rup-global-header__application-logo';
        if (this._options.url) {
            root.href = this._options.url;
        }
        applyCSS(root, this._options.css);
        const logo = new Icon(this._options.icon);
        root.appendChild(logo.render());
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/header/items/userInfo.ts

class UserInfo extends Dropdown {
    constructor(options) {
        super(Object.assign({ css: Object.assign({ flexShrink: '0' }, options.css), classNames: {
                rootClassName: 'rup-global-header__user-org-menu',
                dropdownClassName: 'rup-global-header__user-org-menu-options',
                buttonClassName: options.icon
                    ? 'rup-global-header__user-org-menu-trigger'
                    : 'rup-global-header__user-menu-trigger'
            } }, options));
    }
    getButton() {
        var _a;
        const root = super.getButton();
        root.setAttribute('data-initials', ((_a = this._options.initials) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || this._options.userName[0].toUpperCase());
        return root;
    }
    getDropdown() {
        const dropdown = super.getDropdown();
        const userInfoElement = this.getUserInfoElement();
        dropdown.insertBefore(userInfoElement, dropdown.firstChild);
        return dropdown;
    }
    getUserInfoElement() {
        const root = document.createElement('div');
        root.className = 'rup-global-header__user-menu-user-info';
        const userName = document.createElement('div');
        userName.className = 'rup-global-header__user-menu-user-name';
        userName.innerText = this._options.userName;
        root.appendChild(userName);
        return root;
    }
}

;// CONCATENATED MODULE: ./src/utils/setTestId.ts
function setTestId(element, testId) {
    if (testId) {
        element.setAttribute('data-test-id', testId);
    }
}

;// CONCATENATED MODULE: ./src/components/menu/items/menuItem.ts

class MenuItem {
    constructor(options) {
        this._options = options;
        this._selected = options.selected;
    }
    get selected() {
        return this._selected;
    }
    get id() {
        return this._options.id;
    }
    render() {
        const root = document.createElement('li');
        root.setAttribute('role', 'treeitem');
        setTestId(root, this._options.testId);
        const link = (this._link = document.createElement('a'));
        root.appendChild(link);
        link.classList.add('rup-side-nav__item');
        this.setContent(link);
        if (this._options.url) {
            link.setAttribute('href', this._options.url);
        }
        if (this._options.action) {
            link.addEventListener('click', () => this._options.action());
        }
        if (this._options.id) {
            link.setAttribute('id', this._options.id);
        }
        if (this._options.selected) {
            this.toggleSelect(this._options.selected);
        }
        return root;
    }
    toggleSelect(select) {
        this._selected = select;
        this._link.classList.toggle('rup-side-nav__item--active', select);
    }
    setContent(container) {
        if (!this._options.content) {
            return;
        }
        if (this._options.asHTML) {
            container.innerHTML = this._options.content;
            container.setAttribute('title', container.innerText);
        }
        else {
            container.innerText = this._options.content;
            container.setAttribute('title', this._options.content);
        }
    }
}

;// CONCATENATED MODULE: ./src/components/menu/items/groupMenuItem.ts




class GroupMenuItem extends MenuItem {
    constructor(options) {
        super(options);
        this.children = options.children;
        // customization still required in order to handle menu items initial state
        injectStyles('menu-group-item', {
            '.rup-side-nav .rup-side-nav__item[aria-expanded="false"] + ul[role="group"]': {
                height: '0',
                opacity: '0'
            }
        });
    }
    get expanded() {
        return this._expanded;
    }
    render() {
        const root = document.createElement('li');
        root.setAttribute('role', 'treeitem');
        const button = (this._toggleButton = document.createElement(this._options.url ? 'a' : 'button'));
        root.appendChild(button);
        button.setAttribute('type', 'button');
        button.setAttribute('aria-expanded', 'false');
        button.classList.add('rup-side-nav__item');
        if (this._options.url) {
            button.setAttribute('href', this._options.url);
        }
        const text = document.createElement('span');
        this.setContent(text);
        button.appendChild(text);
        const icon = new Icon({ svg: ChevronDownIcon });
        this._chevronIcon = icon.render();
        button.appendChild(this._chevronIcon);
        button.addEventListener('click', () => {
            var _a;
            if (this._options.selectable) {
                this.toggleSelect();
            }
            this.toggleExpand(null, true);
            (_a = this._options.action) === null || _a === void 0 ? void 0 : _a.call(this);
        });
        const items = (this._items = document.createElement('ul'));
        root.appendChild(items);
        items.setAttribute('role', 'group');
        this._options.children.forEach(c => {
            const child = c.render();
            items.appendChild(child);
            if (c.selected && !this.expanded) {
                this.toggleSelect(true);
                this.toggleExpand(true, true);
            }
        });
        return root;
    }
    toggleSelect(select) {
        this._selected = select !== null && select !== void 0 ? select : !this._selected;
        this._toggleButton.classList.toggle('rup-side-nav__item--selected', this._selected);
    }
    toggleExpand(expand, animate = false) {
        this._expanded = expand !== null && expand !== void 0 ? expand : !this.expanded;
        if (animate) {
            this.animate();
        }
    }
    animate() {
        const currentlyExpanded = this._toggleButton.getAttribute('aria-expanded') == 'true';
        if (currentlyExpanded == this._expanded) {
            return;
        }
        this._toggleButton.setAttribute('aria-expanded', this._expanded.toString());
        if (this._expanded) {
            this.expand();
        }
        else {
            this.collapse();
        }
    }
    expand() {
        this._chevronIcon.animate([{ transform: 'rotate(0)' }, { transform: 'rotate(180deg)' }], {
            duration: 120,
            fill: 'forwards',
            easing: 'ease-in-out'
        });
        this._items.animate([
            { height: '0', opacity: 0 },
            { height: 'auto', opacity: 1 }
        ], {
            duration: 250,
            fill: 'forwards',
            easing: 'ease-in-out'
        });
    }
    collapse() {
        this._chevronIcon.animate([{ transform: 'rotate(180deg)' }, { transform: 'rotate(0)' }], {
            duration: 120,
            fill: 'forwards',
            easing: 'ease-in-out'
        });
        this._items.animate([
            { height: 'auto', opacity: 1 },
            { height: '0', opacity: 0 }
        ], {
            duration: 200,
            fill: 'forwards',
            easing: 'ease-in-out'
        });
    }
}

;// CONCATENATED MODULE: ./src/components/menu/menuAnimationHandler.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class MenuAnimationHandler {
    constructor(structure, options) {
        this._structure = structure;
        this._options = options;
        this.togglePin = this.togglePin.bind(this);
        this.togglePeek = this.togglePeek.bind(this);
    }
    handleAnimation() {
        this._structure.toggleButton.addEventListener('click', () => {
            var _a;
            const expand = this._structure.root.classList.contains('rup-side-nav--collapsed');
            this.togglePin(expand);
            if (expand) {
                sessionStorage.removeItem(menuStateKey);
            }
            else {
                sessionStorage.setItem(menuStateKey, 'collapsed');
            }
            (_a = this._options.togglePinCallback) === null || _a === void 0 ? void 0 : _a.call(this, expand);
        });
        let hoverTimeout;
        const togglePeek = (expand) => {
            window.clearTimeout(hoverTimeout);
            hoverTimeout = window.setTimeout(() => this.togglePeek(expand), expand ? 350 : 100);
        };
        this._structure.root.addEventListener('mouseenter', () => togglePeek(true));
        this._structure.root.addEventListener('mouseleave', () => togglePeek(false));
        this._structure.header.addEventListener('mouseenter', () => window.clearTimeout(hoverTimeout));
    }
    togglePin(expand) {
        if (this._animationInProgress) {
            return;
        }
        Promise.all([this.animateToggleButtonIconAsync(expand), this.toggleAnimationAsync(expand)]);
        this._structure.root.classList.toggle('rup-side-nav--collapsed', !expand);
        this._structure.root.classList.remove('rup-side-nav--peeked');
    }
    togglePeek(expand) {
        if (this._animationInProgress) {
            return;
        }
        if (this._structure.root.classList.contains('rup-side-nav--collapsed')) {
            this.toggleAnimationAsync(expand);
            this._structure.root.classList.toggle('rup-side-nav--peeked', expand);
        }
    }
    toggleAnimationAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            // toggle only if needed
            if (expand && this._structure.root.classList.contains('rup-side-nav--peeked')) {
                return;
            }
            if (!expand &&
                !this._structure.root.classList.contains('rup-side-nav--peeked') &&
                this._structure.root.classList.contains('rup-side-nav--collapsed')) {
                return;
            }
            this._animationInProgress = true;
            if (expand) {
                yield this.expandAsync();
            }
            else {
                yield this.collapseAsync();
            }
            this._animationInProgress = false;
        });
    }
    collapseAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._structure.root.style.pointerEvents = 'none';
            this._structure.headerLabel.parentElement.style.padding = '1rem 1.25rem 1rem 1.5rem';
            this._structure.headerLabel.parentElement.style.justifyContent = 'space-between';
            const rootAnimation = this.animateRootAsync(false);
            const headerAnimation = this.animateHeaderLabelAsync(false);
            const itemsAnimation = this.animateItemsAsync(false);
            yield Promise.all([rootAnimation, headerAnimation, itemsAnimation]);
            this._structure.headerLabel.classList.add('visuallyhidden');
            this._structure.itemsContainer.classList.add('visuallyhidden');
            this._structure.headerLabel.parentElement.style.padding = '';
            this._structure.headerLabel.parentElement.style.justifyContent = '';
            this._structure.root.style.pointerEvents = 'auto';
        });
    }
    expandAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._structure.headerLabel.classList.remove('visuallyhidden');
            const headerAnimation = this.animateHeaderLabelAsync(true);
            this._structure.itemsContainer.classList.remove('visuallyhidden');
            const itemsAnimation = this.animateItemsAsync(true);
            const rootAnimation = this.animateRootAsync(true);
            yield Promise.all([headerAnimation, itemsAnimation, rootAnimation]);
        });
    }
    animateHeaderLabelAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            return animateAsync(this._structure.headerLabel, [{ opacity: expand ? 0 : 1 }, { opacity: expand ? 1 : 0 }], {
                duration: 250,
                fill: 'forwards',
                easing: 'ease-in-out'
            });
        });
    }
    animateItemsAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            return animateAsync(this._structure.itemsContainer, [{ opacity: expand ? 0 : 1 }, { opacity: expand ? 1 : 0 }], {
                duration: 250,
                fill: 'forwards',
                easing: 'ease-in-out'
            });
        });
    }
    animateRootAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            return animateAsync(this._structure.root, [{ width: expand ? '40px' : '100%' }, { width: expand ? '100%' : '40px' }], {
                duration: 300,
                fill: 'forwards',
                easing: 'ease-in-out'
            });
        });
    }
    animateToggleButtonIconAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            return animateAsync(this._structure.toggleButtonIcon, [{ transform: `rotate(${expand ? '0' : '180deg'})` }], {
                duration: 120,
                fill: 'forwards',
                easing: 'ease-in-out'
            });
        });
    }
}

;// CONCATENATED MODULE: ./src/components/menu/menu.ts






const menuStateKey = 'cdss_menu_state';
class Menu {
    constructor(options) {
        var _a;
        this._options = options;
        this._options.open = (_a = this._options.open) !== null && _a !== void 0 ? _a : !sessionStorage.getItem(menuStateKey);
        // customization still required in order to handle menu initial state
        injectStyles('fixed-menu', {
            '.rup-side-nav': {
                width: '100%'
            },
            '.rup-side-nav.rup-side-nav--collapsed': {
                width: '2.5rem'
            },
            '.rup-side-nav.rup-side-nav--collapsed.rup-side-nav--peeked': {
                width: '100%'
            },
            '.rup-side-nav.rup-side-nav--collapsed .rup-side-nav__header button > svg ': {
                transform: 'rotate(180deg)'
            },
            '.rup-side-nav > .rup-side-nav__menu .rup-side-nav__item': {
                cursor: 'pointer'
            }
        });
    }
    render() {
        const root = document.createElement('aside');
        root.className = 'rup-side-nav';
        root.classList.toggle('rup-side-nav--collapsed', !this._options.open);
        root.setAttribute('role', 'navigation');
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        const header = document.createElement('div');
        root.appendChild(header);
        header.className = 'rup-side-nav__header';
        const headerLabel = (this._headerLabel = document.createElement('span'));
        headerLabel.classList.toggle('visuallyhidden', !this._options.open);
        header.appendChild(headerLabel);
        if (this._options.caption) {
            headerLabel.innerText = this._options.caption;
        }
        const toggleButton = document.createElement('button');
        header.appendChild(toggleButton);
        toggleButton.setAttribute('type', 'button');
        toggleButton.className = 'rup-icon-btn rup-icon-btn--neutral';
        const icon = new Icon({ svg: MenuToggleIcon });
        const toggleButtonIcon = icon.render();
        toggleButton.appendChild(toggleButtonIcon);
        const itemsContainer = document.createElement('nav');
        itemsContainer.classList.add('rup-side-nav__menu');
        itemsContainer.classList.toggle('visuallyhidden', !this._options.open);
        root.appendChild(itemsContainer);
        const items = (this._items = document.createElement('ul'));
        items.setAttribute('role', 'tree');
        itemsContainer.appendChild(items);
        if (this._options.items) {
            this.setItems(this._options.items);
        }
        const animationHandler = new MenuAnimationHandler({ root, header, headerLabel, toggleButton, toggleButtonIcon, itemsContainer }, this._options);
        animationHandler.handleAnimation();
        return root;
    }
    setItems(items) {
        this._items.innerHTML = '';
        items.forEach(i => {
            const item = i.render();
            this._items.appendChild(item);
        });
    }
    setCaption(text) {
        this._headerLabel.innerText = text;
    }
    selectItem(id) {
        this.unselectAll(this._options.items);
        this.selectItemInternal(id, this._options.items);
        this.updateAnimation(this._options.items);
    }
    selectItemInternal(id, items) {
        for (const item of items) {
            const isGroupItem = items instanceof GroupMenuItem;
            if (item.id === id) {
                item.toggleSelect(true);
                if (isGroupItem) {
                    item.toggleExpand(true);
                }
                return true;
            }
            if (isGroupItem) {
                const groupItem = item;
                const hasSelectedChildren = this.selectItemInternal(id, groupItem.children);
                if (hasSelectedChildren) {
                    groupItem.toggleExpand(true);
                    return true;
                }
            }
        }
        return false;
    }
    unselectAll(items) {
        this.iterate(items, i => {
            i.toggleSelect(false);
            if (i instanceof GroupMenuItem) {
                i.toggleExpand(false);
            }
        });
    }
    updateAnimation(items) {
        this.iterate(items, i => {
            if (i instanceof GroupMenuItem) {
                i.animate();
            }
        });
    }
    iterate(items, action) {
        for (const item of items) {
            if (item instanceof GroupMenuItem) {
                const groupItem = item;
                this.iterate(groupItem.children, action);
            }
            action(item);
        }
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/rupInput.ts



class RupInput {
    constructor(options) {
        this._options = options;
    }
    get input() {
        return this._input;
    }
    render() {
        this._root = document.createElement('div');
        this._root.classList.add('rup-input');
        this._root.classList.add('input-wrapper');
        this._root.addEventListener('click', () => this._input.focus());
        setTestId(this._root, this._options.testId);
        applyCSS(this._root, this._options.css);
        if (this._options.prefix) {
            const prefix = document.createElement('span');
            prefix.className = 'prefix';
            prefix.innerText = this._options.prefix;
            this._root.appendChild(prefix);
        }
        this._input = document.createElement('input');
        this._input.className = 'input';
        this._options.id && (this._input.id = this._options.id);
        this._options.name && (this._input.name = this._options.name);
        this._input.value = this._options.value || '';
        this._options.placeholder && (this._input.placeholder = this._options.placeholder);
        this._options.type && (this._input.type = this._options.type);
        this._options.autocomplete && (this._input.autocomplete = this._options.autocomplete);
        this._options.maxLength && (this._input.maxLength = this._options.maxLength);
        if (this._options.disabled) {
            this.toggleDisabled(this._options.disabled);
        }
        this._input.addEventListener('change', e => this.onChangeHandler(e));
        this._input.addEventListener('input', e => this.onInputHandler(e));
        this._input.addEventListener('paste', e => this.onPasteHandler(e));
        this._input.addEventListener('focus', () => this._root.classList.toggle('rup-input--focus', true));
        this._input.addEventListener('blur', () => this._root.classList.toggle('rup-input--focus', false));
        this._root.appendChild(this._input);
        if (this._options.suffix) {
            const suffix = document.createElement('span');
            suffix.className = 'suffix';
            suffix.innerText = this._options.suffix;
            this._root.appendChild(suffix);
        }
        if (this._options.suffix || this._options.prefix) {
            this.resizeInput();
        }
        this.setupAlign();
        return this._root;
    }
    toggleDisabled(disabled) {
        this._input.disabled = disabled;
        this._root.toggleAttribute('disabled', disabled);
    }
    toggleError(hasError) {
        this._root.classList.toggle('rup-input--error', hasError);
    }
    updateValue(value) {
        this._input.value = value == undefined ? '' : value;
        this._input.dispatchEvent(createEvent('input'));
    }
    getValue() {
        return this._input.value;
    }
    getInputElement() {
        return this._input;
    }
    resizeInput() {
        if (!this._options.suffix && !this._options.prefix && !this._options.resizable) {
            return;
        }
        const font = getFont(this._input);
        const textWidth = getTextWidth(this._input.value || this._options.placeholder || '', font) || 1;
        if (this._options.suffix || this._options.prefix) {
            // to move suffix near to the input field
            this._input.style.maxWidth = `${textWidth}px`;
        }
        // need to allocate some additional space to avoid extra resizing
        const extraSpace = 16;
        const containerWidth = textWidth + extraSpace;
        const newInputWidth = this._input.clientWidth < containerWidth ? `${textWidth}px` : 'auto';
        this._input.style.width = newInputWidth;
    }
    dispose() {
        var _a;
        (_a = this._root) === null || _a === void 0 ? void 0 : _a.remove();
    }
    onChangeHandler(e) {
        var _a;
        (_a = this._options.onChange) === null || _a === void 0 ? void 0 : _a.call(e.target, e.target.value);
        this.onInputHandler(e);
    }
    onInputHandler(e) {
        var _a;
        (_a = this._options.onInput) === null || _a === void 0 ? void 0 : _a.call(e.target, e.target.value);
        this.resizeInput();
    }
    onPasteHandler(e) {
        var _a;
        (_a = this._options.onPaste) === null || _a === void 0 ? void 0 : _a.call(e.target, e);
        this.resizeInput();
    }
    setupAlign() {
        if (this._options.align === 'right') {
            applyCSS(this._root, {
                justifyContent: 'flex-end'
            });
        }
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/rupNumberInput.ts





/**
 * We can't just use <input type="number" /> because there might be a difference
 * between the displayed value and the actual value (input.value),
 * and there is no way to get the displayed value from a numeric input.
 * Because of this, our resizing algorithm doesn't work properly
 * because it depends on the content in the input to adjust its width.
 *
 * Once the RUP styles release an input field with suffix and prefix
 * this solution can be re-worked.
 */
class RupNumberInput extends RupInput {
    constructor(options) {
        var _a, _b;
        super(options);
        this._step = (_a = options.step) !== null && _a !== void 0 ? _a : 1;
        this._decimalSeparator = (_b = options.decimalSeparator) !== null && _b !== void 0 ? _b : '.';
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onPaste = this.onPaste.bind(this);
    }
    render() {
        const root = super.render();
        this._input.addEventListener('keydown', this.onKeyPress);
        this._input.addEventListener('paste', this.onPaste);
        if (!this._options.disableStepper) {
            this._stepper = document.createElement('div');
            this._stepper.className = 'stepper';
            this._stepUp = document.createElement('button');
            this._stepUp.classList.add('rup-icon-btn');
            this._stepUp.classList.add('rup-icon-btn--neutral');
            this._stepUp.classList.add('rup-icon-btn--xs');
            this._stepUp.type = 'button';
            const addIcon = new Icon({ svg: AddIcon });
            this._stepUp.appendChild(addIcon.render());
            const handleStepUpMouseDown = () => {
                var _a;
                this.handleMouseUp();
                this.clearInterval();
                this.updateValue((_a = (+this._input.value + this._step)) === null || _a === void 0 ? void 0 : _a.toString());
                this._stepperTimerId = window.setInterval(() => { var _a; return this.updateValue((_a = (+this._input.value + this._step)) === null || _a === void 0 ? void 0 : _a.toString()); }, 300);
            };
            this._stepUp.addEventListener('mousedown', handleStepUpMouseDown);
            this._stepper.appendChild(this._stepUp);
            this._stepDown = document.createElement('button');
            this._stepDown.classList.add('rup-icon-btn');
            this._stepDown.classList.add('rup-icon-btn--neutral');
            this._stepDown.classList.add('rup-icon-btn--xs');
            this._stepDown.type = 'button';
            const minusIcon = new Icon({ svg: MinusIcon });
            this._stepDown.appendChild(minusIcon.render());
            const handleStepDownMouseDown = () => {
                var _a;
                this.handleMouseUp();
                this.clearInterval();
                this.updateValue((_a = (+this._input.value - this._step)) === null || _a === void 0 ? void 0 : _a.toString());
                this._stepperTimerId = window.setInterval(() => { var _a; return this.updateValue((_a = (+this._input.value - this._step)) === null || _a === void 0 ? void 0 : _a.toString()); }, 300);
            };
            this._stepDown.addEventListener('mousedown', handleStepDownMouseDown);
            this._stepper.appendChild(this._stepDown);
            root.appendChild(this._stepper);
        }
        return root;
    }
    handleMouseUp() {
        document.addEventListener('mouseup', () => {
            this.clearInterval();
            this._input.dispatchEvent(createEvent('change'));
        }, { once: true });
    }
    updateValue(value) {
        const numericValue = parseFloat(value);
        if (isNaN(numericValue) && value !== undefined) {
            return;
        }
        super.updateValue(!isNaN(numericValue) ? numericValue.toString() : undefined);
    }
    onInputHandler(e) {
        const value = +this._input.value;
        if (this._options.min != null && (value < this._options.min || this._input.value == null)) {
            this._input.value = this._options.min.toString();
            this._input.dispatchEvent(createEvent('change'));
        }
        if (this._options.max != null && value > this._options.max) {
            this._input.value = this._options.max.toString();
            this._input.dispatchEvent(createEvent('change'));
        }
        super.onInputHandler(e);
        if (!this._options.disableStepper) {
            this._stepUp.disabled = !!(value + this._step > this._options.max);
            this._stepDown.disabled = !!(value - this._step < this._options.min);
            if (this._stepUp.disabled || this._stepDown.disabled) {
                this.clearInterval();
            }
        }
    }
    clearInterval() {
        window.clearInterval(this._stepperTimerId);
        this._stepperTimerId = null;
    }
    setupAlign() {
        super.setupAlign();
        if (this._options.align === 'right') {
            applyCSS(this._stepper, {
                marginLeft: '0'
            });
        }
    }
    isDigit(value) {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].indexOf(value) !== -1;
    }
    onKeyPress(e) {
        if (e.shiftKey) {
            e.preventDefault();
        }
        if (['Backspace', 'Enter', 'Escape', 'Esc', 'Insert', 'Delete', 'Del', 'Decimal'].indexOf(e.key) !== -1 ||
            // Allow: Tab
            e.key === 'Tab' ||
            // Allow: Ctrl+A Ctrl+a
            ((e.key === 'A' || e.key === 'a') && e.ctrlKey) ||
            // Allow: Ctrl+C Ctrl+c
            ((e.key === 'C' || e.key === 'c') && e.ctrlKey) ||
            // Allow: Ctrl+X Ctrl+x
            ((e.key === 'X' || e.key === 'x') && e.ctrlKey) ||
            // Allow: Ctrl+V Ctrl+v
            ((e.key === 'V' || e.key === 'v') && e.ctrlKey) ||
            // Allow: up, down, left, right
            e.key === 'Up' ||
            e.key === 'Down' ||
            e.key === 'Left' ||
            e.key === 'Right' ||
            e.key === 'ArrowUp' ||
            e.key === 'ArrowDown' ||
            e.key === 'ArrowLeft' ||
            e.key === 'ArrowRight') {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number
        if (this.isDigit(e.key)) {
            return;
        }
        // Ensure valid position of the decimal separator
        const currentValue = this._input.value;
        if (e.key === this._decimalSeparator) {
            if (currentValue.indexOf(this._decimalSeparator) === -1 && !isNaN(parseFloat(currentValue))) {
                return;
            }
        }
        // Ensure valid position of the negative symbol
        if (e.key === '-') {
            if (currentValue.indexOf('-') === -1 && this._input.selectionStart === 0) {
                return;
            }
        }
        e.preventDefault();
    }
    onPaste(event) {
        const selectionStart = this._input.selectionStart;
        const selectionEnd = this._input.selectionEnd;
        const pastedText = event.clipboardData.getData('text/plain');
        const newText = this._input.value.substring(0, selectionStart) + pastedText + this._input.value.substring(selectionEnd);
        let cleanText = '';
        let hasDecimalSeparator = false;
        for (let i = 0; i < newText.length; i++) {
            const char = newText[i];
            if (this.isDigit(char) ||
                (i === 0 && char === '-') ||
                (char === this._decimalSeparator && !hasDecimalSeparator)) {
                if (char === this._decimalSeparator) {
                    hasDecimalSeparator = true;
                }
                cleanText += newText[i];
            }
        }
        const numericValue = parseFloat(cleanText);
        if (!isNaN(numericValue)) {
            this._input.value = cleanText;
        }
        event.preventDefault();
        super.onChangeHandler(event);
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/rupSelect.ts


const createRupSelectItem = (value, text) => ({
    value: value.toString(),
    text: text || value.toString()
});
class RupSelect {
    constructor(options) {
        this.getOptionItem = (item) => {
            if (item.items) {
                const group = document.createElement('optgroup');
                group.label = item.text;
                item.items.map(this.getOptionItem).forEach(group.appendChild);
                return group;
            }
            const option = document.createElement('option');
            option.value = item.value;
            option.innerText = item.text || item.value;
            return option;
        };
        this._options = options;
        this._items = options.items;
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }
    render() {
        this._root = document.createElement('div');
        this._root.classList.add('rup-select');
        if (this._options.inline) {
            this._root.classList.add('rup-select--inline');
        }
        this._root.tabIndex = -1;
        applyCSS(this._root, this._options.css);
        this._select = document.createElement('select');
        this._select.id = this._options.id;
        this._select.size = this._options.size;
        if (this._options.disabled) {
            this.toggleDisabled(this._options.disabled);
        }
        setTestId(this._select, this._options.testId);
        const isDropDown = !this._options.size || this._options.size == 1;
        if (isDropDown && this._options.placeholder) {
            const placeholder = document.createElement('option');
            placeholder.disabled = true;
            placeholder.value = '';
            placeholder.innerText = this._options.placeholder;
            this._select.options.add(placeholder);
        }
        this.setItems(this._options.items);
        this._select.value = this._options.value || '';
        this._select.addEventListener('change', this.onChangeHandler);
        this._root.appendChild(this._select);
        if (isDropDown) {
            const selectIcon = document.createElement('span');
            selectIcon.classList.add('rup-select__icon');
            this._root.appendChild(selectIcon);
        }
        return this._root;
    }
    onChangeHandler() {
        if (this._options.onSelectedItemChanged) {
            this._options.onSelectedItemChanged(getItemByValue(this._select.value, this._items));
        }
    }
    dispose() {
        this._select.removeEventListener('change', this.onChangeHandler);
    }
    toggleDisabled(disabled) {
        this._select.disabled = disabled;
    }
    toggleError(hasError) {
        this._select.classList.toggle('rup-input--error', hasError);
    }
    setItems(items) {
        this.clearItems();
        items === null || items === void 0 ? void 0 : items.map(this.getOptionItem).forEach(opt => this._select.options.add(opt));
        this._items = items;
    }
    clearItems() {
        const isDropDown = !this._options.size || this._options.size == 1;
        for (let i = this._select.options.length - 1; i >= (isDropDown && this._options.placeholder ? 1 : 0); i--) {
            this._select.options.remove(i);
        }
    }
    setValue(value) {
        this._select.value = value || '';
    }
    getItems() {
        return this._items;
    }
    getSelectedItem() {
        return getItemByValue(this._select.value, this._items);
    }
}
function itemsComparer(item1, item2) {
    if (!item1 || !item2) {
        return false;
    }
    return (item1 === null || item1 === void 0 ? void 0 : item1.value) === (item2 === null || item2 === void 0 ? void 0 : item2.value);
}
function getItemByValue(value, items) {
    if (value === undefined) {
        return undefined;
    }
    for (const i of items) {
        if (itemsComparer(i, { value })) {
            return i;
        }
        if (i.items) {
            const item = getItemByValue(value, i.items);
            if (item) {
                return item;
            }
        }
    }
    return undefined;
}

// EXTERNAL MODULE: ./node_modules/autocompleter/autocomplete.js
var autocomplete = __webpack_require__(338);
var autocomplete_default = /*#__PURE__*/__webpack_require__.n(autocomplete);
;// CONCATENATED MODULE: ./src/components/common/formItems/rupAutoComplete.ts






class RupAutoComplete {
    constructor(options) {
        this._options = options;
        if (this._options.minLength == null) {
            this._options.minLength = 3;
        }
        this.onInputHandler = this.onInputHandler.bind(this);
        this.onScrollHandler = this.onScrollHandler.bind(this);
        injectStyles('rup-autocomplete', {
            '.autocomplete-container': {
                zIndex: '1301',
                background: '#FFFFFF',
                borderRadius: '8px',
                boxShadow: '0px 8px 12px rgba(0, 0, 0, 0.14), 0px 0px 7px rgba(0, 0, 0, 0.2)',
                padding: '8px 0',
                maxHeight: '304px',
                color: '#141C24',
                fontStyle: 'normal',
                fontWeight: 'normal',
                fontSize: '14px',
                lineHeight: '20px',
                overflow: 'auto'
            },
            '.autocomplete-container.up': {
                boxShadow: '0px -8px 12px rgb(0 0 0 / 14%), 0px 0px 7px rgb(0 0 0 / 20%);'
            },
            '.autocomplete-container__item': {
                padding: '8px 12px',
                cursor: 'pointer'
            },
            '.autocomplete-container__item:hover': {
                background: '#E9EFF2'
            },
            '.autocomplete-container__item--selected': {
                background: '#ECF5FD',
                color: '#1479CC'
            },
            '.autocomplete-container__item--helper': {
                background: '#FFFFFF',
                color: '#6C8293',
                textAlign: 'center',
                pointerEvents: 'none',
                padding: '4px 12px'
            },
            '.rup-autosuggestion.input-wrapper': {
                paddingRight: '0.43rem'
            },
            '.rup-autosuggestion.input-wrapper > .input-wrapper__button': {
                position: 'inherit',
                height: '1rem',
                width: '1rem',
                margin: '0'
            },
            '.rup-autosuggestion.input-wrapper > .rup-icon-btn--clear': {
                marginRight: '8px',
                marginLeft: '12px'
            },
            '.rup-autosuggestion.input-wrapper--disabled > .rup-icon-btn--clear': {
                visibility: 'hidden !important'
            }
        });
    }
    render() {
        var _a, _b;
        const rupInput = (this._rupInput = new RupInput({
            id: this._options.id,
            value: this.getItemStringValue(this._options.value),
            type: this._options.type,
            placeholder: this._options.placeholder,
            suffix: this._options.suffix,
            prefix: this._options.prefix,
            disabled: this._options.disabled,
            autocomplete: 'off',
            resizable: (_a = this._options.resizable) !== null && _a !== void 0 ? _a : true,
            css: this._options.css,
            onInput: this.onInputHandler,
            onChange: this._options.onInputChange,
            testId: this._options.testId
        }));
        const root = (this._root = rupInput.render());
        root.classList.add('rup-autosuggestion');
        this._clearButton = this.createClearButton();
        root.appendChild(this._clearButton);
        root.appendChild(this.createDropdownButton());
        this._autoComplete = autocomplete_default()({
            input: rupInput.input,
            className: 'autocomplete-container',
            minLength: 0,
            debounceWaitMs: (_b = this._options.debounceWaitMs) !== null && _b !== void 0 ? _b : 0,
            preventSubmit: true,
            showOnFocus: true,
            disableAutoSelect: true,
            fetch: (text, update) => {
                var _a;
                if ((text === null || text === void 0 ? void 0 : text.length) < this._options.minLength) {
                    if (this._options.tooShortQueryMessage) {
                        update([{ text: this._options.tooShortQueryMessage, helper: true, value: null }]);
                    }
                    return;
                }
                (_a = this._options.fetchSuggestionsAsync) === null || _a === void 0 ? void 0 : _a.call(this, text).then((items) => {
                    if (!(items === null || items === void 0 ? void 0 : items.length) && this._options.noResultsMessage) {
                        items = [{ text: this._options.noResultsMessage, helper: true }];
                    }
                    update(items);
                });
            },
            onSelect: (item) => {
                this.updateValue(item);
            },
            render: (item) => {
                const div = document.createElement('div');
                div.className = 'autocomplete-container__item';
                if (this.isHelperItem(item)) {
                    div.classList.add('autocomplete-container__item--helper');
                }
                else if (this.isSelectedItem(item)) {
                    div.classList.add('autocomplete-container__item--selected');
                }
                const htmlElement = this.createSuggestionItem(item);
                div.appendChild(htmlElement);
                return div;
            },
            customize: (_input, _inputRect, container) => {
                // to override lib settings
                container.style.maxHeight = '';
                positionDropdown(root, container);
                this._dropdown = container;
            }
        });
        if (this._options.disabled != null) {
            this.toggleDisabled(this._options.disabled);
        }
        if (this._options.value != null) {
            this._selectedItem = this._options.value;
        }
        if (this._options.closeOnScroll === true) {
            window.addEventListener('scroll', this.onScrollHandler, true);
        }
        return root;
    }
    dispose() {
        var _a;
        (_a = this._autoComplete) === null || _a === void 0 ? void 0 : _a.destroy();
        window.removeEventListener('scroll', this.onScrollHandler, true);
    }
    toggleError(hasError) {
        var _a;
        (_a = this._rupInput) === null || _a === void 0 ? void 0 : _a.toggleError(hasError);
    }
    toggleDisabled(disabled) {
        this._root.classList.toggle('input-wrapper--disabled', disabled);
        this._root.toggleAttribute('disabled', disabled);
        this._rupInput.toggleDisabled(disabled);
    }
    updateValue(item) {
        var _a, _b, _c;
        if (!this.compareItems(this._selectedItem, item)) {
            this._selectedItem = item;
            this._rupInput.updateValue(this.getItemStringValue(item));
            this._rupInput.input.blur();
            (_a = this._options.onSelectedItemChanged) === null || _a === void 0 ? void 0 : _a.call(this, item);
            (_c = (_b = this._dropdown) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.removeChild(this._dropdown);
        }
    }
    getSelectedItem() {
        return this._selectedItem;
    }
    onInputHandler(value) {
        this._clearButton.style.visibility = (value === null || value === void 0 ? void 0 : value.length) > 0 ? 'visible' : 'hidden';
    }
    createSuggestionItem(item) {
        var _a;
        if (!item.helper && ((_a = this._options.template) === null || _a === void 0 ? void 0 : _a.suggestionItemTemplate)) {
            return this._options.template.suggestionItemTemplate(item);
        }
        const span = document.createElement('span');
        span.innerText = item.text || item.value.toString();
        return span;
    }
    onScrollHandler(e) {
        var _a;
        const target = e.target;
        if (target.classList.contains('autocomplete-container')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        (_a = this._rupInput.input) === null || _a === void 0 ? void 0 : _a.blur();
        return true;
    }
    createDropdownButton() {
        const dropdownButton = document.createElement('span');
        dropdownButton.classList.add('rup-select__icon');
        dropdownButton.classList.add('input-wrapper__button');
        return dropdownButton;
    }
    createClearButton() {
        var _a;
        const clearButton = document.createElement('button');
        clearButton.classList.add('rup-icon-btn');
        clearButton.classList.add('rup-icon-btn--neutral');
        clearButton.classList.add('rup-icon-btn--xs');
        clearButton.classList.add('input-wrapper__button');
        clearButton.classList.add('rup-icon-btn--clear');
        clearButton.type = 'button';
        const clearIcon = new Icon({ svg: ModalCloseIcon });
        clearButton.appendChild(clearIcon.render());
        clearButton.addEventListener('click', () => this.updateValue(undefined));
        clearButton.style.visibility = ((_a = this._rupInput.getValue()) === null || _a === void 0 ? void 0 : _a.length) > 0 ? 'visible' : 'hidden';
        return clearButton;
    }
    isSelectedItem(item) {
        if (!item || !this._selectedItem) {
            return false;
        }
        return this.compareItems(item, this._selectedItem);
    }
    isHelperItem(item) {
        return item === null || item === void 0 ? void 0 : item.helper;
    }
    compareItems(item1, item2) {
        if (!item1 || !item2) {
            return false;
        }
        if (item1.helper || item2.helper) {
            return false;
        }
        if (this._options.itemsComparer) {
            return this._options.itemsComparer(item1, item2);
        }
        return item1.value == item2.value;
    }
    getItemStringValue(item) {
        return (item === null || item === void 0 ? void 0 : item.text) || (item === null || item === void 0 ? void 0 : item.value.toString());
    }
}

;// CONCATENATED MODULE: ./src/components/footer/simpleFooter.ts


class SimpleFooter {
    constructor(options = {}) {
        this._options = options;
    }
    render() {
        const root = document.createElement('footer');
        root.className = 'rup-footer rup-footer--simple';
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        const content = document.createElement('div');
        root.appendChild(content);
        content.className = 'rup-footer__content';
        const logo = document.createElement('a');
        content.appendChild(logo);
        logo.href = '#logo';
        logo.className = 'rup-footer__logo';
        logo.innerHTML = SimpleFooterLogo;
        const paragraph = document.createElement('p');
        content.appendChild(paragraph);
        const copyright = document.createElement('span');
        paragraph.appendChild(copyright);
        copyright.className = 'rup-footer__copy-right';
        copyright.innerText = `© ${new Date().getFullYear()} Copyright Clearance Center, Inc.`;
        paragraph.innerHTML += '&nbsp;';
        const copyrightText = document.createElement('span');
        paragraph.appendChild(copyrightText);
        copyrightText.className = 'rup-footer__copy-right-text';
        copyrightText.innerText = 'All rights reserved.';
        return root;
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/multiSelect/uniqueItemsMap.ts
class UniqueItemsMap {
    constructor(items) {
        this._initialCollection = [];
        this._map = {};
        this._initialCollection = items;
        items.forEach(i => {
            if (!this._map[i.value]) {
                this._map[i.value] = i;
                return;
            }
            if ('children' in i) {
                const existingGroup = this._map[i.value];
                existingGroup.children = this.createNestedMap([
                    ...existingGroup.children,
                    ...i.children
                ]).items;
            }
        });
    }
    createNestedMap(items) {
        return new UniqueItemsMap(items);
    }
    get(value) {
        return this._map[value];
    }
    set(item) {
        this._map[item.value] = item;
    }
    get selectedItems() {
        return Object.values(this._map).filter(i => i.selected);
    }
    get items() {
        // Cannot use Object.values here because we have to safe initial order
        return this._initialCollection.map(i => this._map[i.value]);
    }
    markSelected(selectedItems) {
        const selectedItemsMap = new UniqueItemsMap(selectedItems);
        // update selection
        Object.values(this._map).forEach(i => {
            i.selected = !!selectedItemsMap.get(i.value);
            if ('children' in i) {
                i.children.forEach(c => (c.selected = !!selectedItemsMap.get(c.value)));
            }
        });
        // enrich with selected items
        selectedItems.forEach(i => {
            i.selected = true; // ensure selection
            this._map[i.value] = i;
        });
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/multiSelect/sortedUniqueItemsMap.ts

class SortedUniqueItemsMap extends UniqueItemsMap {
    constructor(items) {
        super(items);
    }
    createNestedMap(items) {
        return new SortedUniqueItemsMap(items);
    }
    itemsComparer(x, y) {
        if (x.default !== y.default) {
            return x.default ? -1 : 1;
        }
        if (x.selected !== y.selected) {
            return x.selected ? -1 : 1;
        }
        return (x.text || x.value).localeCompare(y.text || y.value);
    }
    get items() {
        return Object.values(this._map).sort(this.itemsComparer);
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/multiSelect/selection.ts





// The value of max selection height equals to average between height values for 1 and 2 rows, so it won't likely break in case of minor control style adjustments.
const MaxSelectionHeight = 50;
class Selection {
    constructor(options) {
        this.onSelectionObserve = this.onSelectionObserve.bind(this);
        this._options = options;
        injectStyles('rup-multiselect__selection', {
            '.rup-multiselect__selection': {
                padding: '0',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                boxSizing: 'border-box',
                minHeight: '34px',
                maxHeight: '134px',
                overflow: 'hidden',
                cursor: 'text'
            },
            '.rup-multiselect__selection__tag-container': {
                padding: '1px 2px',
                margin: '0',
                display: 'flex',
                flexWrap: 'wrap',
                maxWidth: '100%',
                width: '100%'
            },
            '.rup-multiselect__selection__tag-container > .rup-tag': {
                margin: '2px',
                maxWidth: '216px',
                cursor: 'pointer'
            },
            '.rup-multiselect__selection__tag-container > .rup-tag > .rup-tag__text': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis'
            }
        });
    }
    get selectedItems() {
        return this._selectedItems || [];
    }
    render() {
        if (this._observer != null) {
            this.dispose();
        }
        const root = document.createElement('div');
        root.classList.add('rup-multiselect__selection');
        const tagsContainer = (this._selectionTagsContainer = document.createElement('div'));
        tagsContainer.classList.add('rup-multiselect__selection__tag-container');
        root.appendChild(tagsContainer);
        root.addEventListener('click', () => {
            this._options.toggleDropdown(true);
        });
        this._observer = new ResizeObserver(this.onSelectionObserve);
        this._observer.observe(this._selectionTagsContainer);
        return root;
    }
    updateSelection(selectedItems, sort = true) {
        const itemsMap = sort ? new SortedUniqueItemsMap(selectedItems) : new UniqueItemsMap(selectedItems);
        selectedItems = this._selectedItems = itemsMap.items;
        const tags = this._selectionTagsContainer.querySelectorAll('.rup-tag');
        tags.forEach(tag => this._selectionTagsContainer.removeChild(tag));
        const insertTag = (tag) => {
            this._selectionTagsContainer.appendChild(tag);
        };
        for (let i = 0; i < selectedItems.length; i++) {
            const item = selectedItems[i];
            const tag = this.renderTag(item);
            insertTag(tag);
            if (this._selectionTagsContainer.clientHeight > MaxSelectionHeight) {
                this._selectionTagsContainer.removeChild(tag);
                const moreTag = this.createMoreTag(selectedItems.length - i);
                insertTag(moreTag);
                while (this._selectionTagsContainer.clientHeight > MaxSelectionHeight) {
                    this._selectionTagsContainer.removeChild(moreTag.previousSibling);
                    moreTag.innerText = this._options.getMoreText(selectedItems.length - --i);
                }
                break;
            }
        }
    }
    createMoreTag(moreItems) {
        const tag = document.createElement('div');
        tag.classList.add('rup-tag');
        tag.innerText = this._options.getMoreText(moreItems);
        tag.addEventListener('click', () => this._options.toggleDropdown(true));
        return tag;
    }
    renderTag(item) {
        var _a, _b;
        const tagId = encodeURIComponent(`tag-${item.value}`);
        const existingTag = this._selectionTagsContainer.querySelector(`[id="${tagId}"]`);
        if (existingTag) {
            return existingTag;
        }
        const tag = document.createElement('div');
        tag.classList.add('rup-tag');
        tag.setAttribute('data-value', item.value);
        tag.setAttribute('id', tagId);
        // we have to use a text wrapper here in order to support text truncation
        const tagText = document.createElement('span');
        tagText.classList.add('rup-tag__text');
        tagText.innerText = (_b = (_a = item.shortText) !== null && _a !== void 0 ? _a : item.text) !== null && _b !== void 0 ? _b : item.value;
        tag.appendChild(tagText);
        if (item.default) {
            return tag;
        }
        const removeButton = document.createElement('button');
        removeButton.className = 'rup-tag__close rup-icon-btn rup-icon-btn--neutral rup-icon-btn--xs';
        removeButton.setAttribute('type', 'button');
        const removeButtonIcon = new Icon({ svg: ModalCloseIcon });
        removeButton.appendChild(removeButtonIcon.render());
        removeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.cancelBubble = true;
            this._options.toggleItems([item]);
            this._options.removeItem();
        });
        tag.appendChild(removeButton);
        return tag;
    }
    onSelectionObserve() {
        this.updateSelection(this._selectedItems);
    }
    dispose() {
        var _a;
        (_a = this._observer) === null || _a === void 0 ? void 0 : _a.disconnect();
        this._observer = null;
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/multiSelect/dropdown.ts
var dropdown_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








const nbspRegex = new RegExp(String.fromCharCode(160), 'g');
class dropdown_Dropdown {
    constructor(options) {
        this._options = options;
        this.handleScroll = this.handleScroll.bind(this);
        injectStyles('rup-multiselect__dropdown', {
            '.rup-multiselect__dropdown': {
                position: 'absolute',
                background: '#FFFFFF',
                borderRadius: '8px',
                visibility: 'hidden',
                zIndex: '1301',
                boxShadow: '0px 8px 12px rgb(0 0 0 / 14%), 0px 0px 7px rgb(0 0 0 / 20%)',
                padding: '8px 0px',
                maxWidth: '560px'
            },
            '.rup-multiselect__dropdown.open': {
                visibility: 'visible'
            },
            '.rup-multiselect__dropdown.open.up': {
                boxShadow: '0px -8px 12px rgb(0 0 0 / 14%), 0px 0px 7px rgb(0 0 0 / 20%);'
            },
            '.rup-multiselect__dropdown__list': {
                maxHeight: '252px',
                overflow: 'auto'
            },
            '.rup-multiselect__dropdown__list__item': {
                padding: '8px 12px',
                boxSizing: 'border-box',
                cursor: 'pointer',
                wordBreak: 'break-word'
            },
            '.rup-multiselect__dropdown__list__item:hover': {
                backgroundColor: '#E5E5E5'
            },
            '.rup-multiselect__dropdown__list__item--group': {
                padding: '0px 12px'
            },
            '.rup-multiselect__dropdown__list__item--group:hover': {
                backgroundColor: 'transparent'
            },
            '.rup-multiselect__dropdown__list__item--group > div': {
                padding: '6px'
            },
            '.rup-multiselect__dropdown__list__item__nested-list': {
                padding: '0 18px'
            },
            '.rup-multiselect__no-results': {
                color: '#4C5961',
                padding: '4px 12px',
                display: 'block'
            },
            '.rup-multiselect__dropdown > .rup-loader': {
                width: '100%',
                margin: '0'
            },
            '.rup-multiselect__dropdown__searchbox': {
                margin: '8px 12px'
            }
        });
    }
    get itemsTree() {
        return this._itemsTree;
    }
    get query() {
        var _a, _b;
        return ((_b = (_a = this.selectionInput) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.replace(nbspRegex, ' ')) || '';
    }
    clearQuery() {
        if (this.selectionInput) {
            this.selectionInput.value = '';
            this.selectionInput.blur();
        }
    }
    render() {
        const root = (this.root = document.createElement('div'));
        if (!this._options.disableSearch) {
            const searchBox = document.createElement('div');
            searchBox.classList.add('rup-multiselect__dropdown__searchbox');
            searchBox.classList.add('rup-search');
            const searchIcon = document.createElement('span');
            searchIcon.classList.add('rup-search__icon');
            searchIcon.classList.add('rup-icon');
            searchIcon.classList.add('rup-icon--sm');
            const icon = new Icon({ svg: SearchIcon });
            searchIcon.appendChild(icon.render());
            searchBox.appendChild(searchIcon);
            const searchInput = (this.selectionInput = document.createElement('input'));
            searchInput.classList.add('rup-input');
            if (this._options.searchText) {
                searchInput.setAttribute('placeholder', this._options.searchText);
            }
            searchInput.setAttribute('type', 'search');
            searchBox.appendChild(searchInput);
            root.appendChild(searchBox);
            searchInput.addEventListener('input', () => { var _a; return (_a = this._options.onQueryChanged) === null || _a === void 0 ? void 0 : _a.call(this, this.query); });
        }
        root.classList.add('rup-multiselect__dropdown');
        const ul = (this._dropdownList = document.createElement('ul'));
        root.appendChild(ul);
        ul.classList.add('rup-multiselect__dropdown__list');
        this.handleItemClick(ul);
        this.handleInfinityScroll(ul);
        window.addEventListener('scroll', this.handleScroll, true);
        const noResultsMessage = (this._noResultsMessage = document.createElement('span'));
        noResultsMessage.classList.add('rup-multiselect__no-results');
        noResultsMessage.classList.add('visuallyhidden');
        noResultsMessage.innerText = this._options.noResultsText;
        root.appendChild(noResultsMessage);
        const loading = (this._loading = document.createElement('span'));
        loading.classList.add('rup-loader');
        loading.classList.add('visuallyhidden');
        root.appendChild(loading);
        return root;
    }
    dispose() {
        var _a;
        (_a = this.root.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(this.root);
        window.removeEventListener('scroll', this.handleScroll, true);
    }
    isOpen() {
        return this.root.classList.contains('open');
    }
    toggleDropdown(open) {
        var _a;
        const prevOpen = this.isOpen();
        this.root.classList.toggle('open', open == undefined ? undefined : open);
        open = this.root.classList.contains('open');
        if (open) {
            this.positionDropdown();
            this._dropdownList.scrollTop = 0;
        }
        else if (prevOpen) {
            // call the handler only if the dropdown was really closed.
            (_a = this._options.onDropdownClosed) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        return open;
    }
    toggleLoading(visible) {
        this._loading.classList.toggle('visuallyhidden', !visible);
    }
    toggleNoResultsMessage(visible) {
        this._noResultsMessage.classList.toggle('visuallyhidden', !visible);
    }
    updateDropdown(items, selectedItems, query, sort) {
        const itemsMap = sort ? new SortedUniqueItemsMap(items) : new UniqueItemsMap(items);
        selectedItems = query
            ? // always show default value if it is selected
                selectedItems.filter(i => i.default || (i.text || i.value).toUpperCase().includes(query.toUpperCase()))
            : selectedItems;
        if (selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length) {
            itemsMap.markSelected(selectedItems);
        }
        items = this._itemsTree = itemsMap.items;
        this.renderItems(items);
    }
    appendItems(items, selectedItems, query) {
        this._itemsTree = this._itemsTree.concat(items);
        this.updateDropdown(this._itemsTree, selectedItems, query, false);
    }
    renderItems(itemsTree) {
        let prevElement;
        const visibleItemsMap = {};
        itemsTree.forEach(i => {
            let element;
            if ('children' in i) {
                element = this.renderDropdownGroupItem(i);
                i.children.forEach(c => (visibleItemsMap[c.value] = c));
            }
            else {
                element = this.renderDropdownItem(i);
                visibleItemsMap[i.value] = i;
            }
            if (prevElement) {
                prevElement.after(element);
            }
            else {
                this._dropdownList.insertBefore(element, this._dropdownList.firstChild);
            }
            prevElement = element;
        });
        // removing extra <li> from the dropdown
        const lis = this._dropdownList.querySelectorAll('li:not(.rup-multiselect__dropdown__list__item--group)');
        const valuableItems = getValuableItems(itemsTree);
        if (lis.length != valuableItems.length) {
            lis.forEach(li => {
                var _a;
                const itemValue = li.getAttribute('data-value');
                if (!visibleItemsMap[itemValue]) {
                    const list = li.parentElement;
                    list.removeChild(li);
                    // removing nested list without items
                    if (list.classList.contains('rup-multiselect__dropdown__list__item__nested-list')) {
                        if (!((_a = list.children) === null || _a === void 0 ? void 0 : _a.length)) {
                            list.parentElement.parentElement.removeChild(list.parentElement);
                        }
                    }
                }
            });
        }
        this.toggleNoResultsMessage(!itemsTree.length);
        this.positionDropdown();
    }
    renderDropdownGroupItem(group) {
        group.selected = group.children.some(c => c.selected);
        const groupItem = {
            text: group.text,
            value: group.value,
            selected: group.selected
        };
        const groupElement = this.renderDropdownItem(groupItem, 'checkbox');
        groupElement.classList.add('rup-multiselect__dropdown__list__item--group');
        let nestedList = groupElement.querySelector('ul.rup-multiselect__dropdown__list__item__nested-list');
        if (!nestedList) {
            nestedList = document.createElement('ul');
            nestedList.classList.add('rup-multiselect__dropdown__list__item__nested-list');
            groupElement.appendChild(nestedList);
        }
        group.children.forEach(i => {
            const element = this.renderDropdownItem(i, group.type);
            nestedList.appendChild(element);
        });
        return groupElement;
    }
    renderDropdownItem(item, type = 'checkbox') {
        const id = encodeURIComponent(`dropdown-item-${item.value}`);
        const inputId = encodeURIComponent(`input-${item.value}`);
        const existingElement = this._dropdownList.querySelector(`[id="${id}"]`);
        if (existingElement) {
            const input = existingElement.querySelector(`[id="${inputId}"]`);
            input.setAttribute('checked', (!!item.selected).toString());
            input.checked = !!item.selected;
            return existingElement;
        }
        const li = document.createElement('li');
        li.classList.add('rup-multiselect__dropdown__list__item');
        li.setAttribute('data-value', item.value);
        li.setAttribute('id', id);
        item.testId && li.setAttribute('data-test-id', item.testId);
        if (item.selected) {
            li.classList.add('rup-multiselect__dropdown__list__item--selected');
        }
        const itemContainer = document.createElement('div');
        li.appendChild(itemContainer);
        itemContainer.classList.add(type === 'checkbox' ? 'rup-checkbox' : 'rup-radio');
        const input = document.createElement('input');
        itemContainer.appendChild(input);
        input.setAttribute('id', inputId);
        input.setAttribute('type', type);
        input.setAttribute('checked', (!!item.selected).toString());
        input.checked = !!item.selected;
        const label = document.createElement('label');
        itemContainer.appendChild(label);
        label.setAttribute('for', inputId);
        if (this._options.labelTemplate) {
            label.appendChild(this._options.labelTemplate(item));
        }
        else {
            label.innerText = item.text || item.value;
        }
        return li;
    }
    handleScroll(e) {
        if (!this._options.closeOnScroll) {
            this.positionDropdown();
            return;
        }
        const close = () => {
            var _a;
            this.root.classList.remove('open');
            this.root.classList.remove('up');
            (_a = this._options.onDropdownClosed) === null || _a === void 0 ? void 0 : _a.call(this);
        };
        const targetElement = e.target;
        if (targetElement instanceof Document) {
            close();
            return;
        }
        const inputElement = this.selectionInput;
        if (inputElement === null || inputElement === void 0 ? void 0 : inputElement.isEqualNode(targetElement)) {
            return;
        }
        const target = closestParentElement(targetElement, 'div.rup-multiselect__dropdown');
        if (!target || !this.root.isEqualNode(target)) {
            close();
        }
    }
    handleItemClick(ul) {
        ul.addEventListener('click', e => {
            let target = e.target;
            if (target.tagName !== 'li') {
                target = closestParentElement(target, 'li');
            }
            if (!target) {
                return;
            }
            e.preventDefault();
            if (target.classList.contains('rup-multiselect__dropdown__list__item--group')) {
                this.handleGroupElementClick(target);
            }
            else {
                this.handleItemElementClick(target);
            }
        });
    }
    handleGroupElementClick(groupElement) {
        const groupId = groupElement.getAttribute('data-value');
        const group = this._itemsTree.find(ig => ig.value === groupId);
        const goingToBeSelected = !group.selected;
        if (group.type === 'radio') {
            if (goingToBeSelected) {
                // only first item must become selected
                group.children.forEach(i => (i.selected = true));
                group.children[0].selected = false;
                this._options.toggleItems(group.children);
            }
            else {
                // all items must become deselected
                group.children.forEach(i => (i.selected = true));
                this._options.toggleItems(group.children);
            }
        }
        else {
            if (goingToBeSelected) {
                // all items must become selected
                group.children.forEach(i => (i.selected = false));
                this._options.toggleItems(group.children);
            }
            else {
                // all items must become deselected
                group.children.forEach(i => (i.selected = true));
                this._options.toggleItems(group.children);
            }
        }
    }
    handleItemElementClick(itemElement) {
        var _a;
        const targetValue = itemElement.getAttribute('data-value');
        const valuableItems = getValuableItems(this.itemsTree);
        const item = valuableItems.find(i => i.value === targetValue);
        const goingToBeSelected = !item.selected;
        const groupElement = (_a = itemElement === null || itemElement === void 0 ? void 0 : itemElement.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (groupElement === null || groupElement === void 0 ? void 0 : groupElement.classList.contains('rup-multiselect__dropdown__list__item--group')) {
            const groupId = groupElement.getAttribute('data-value');
            const group = this._itemsTree.find(ig => ig.value === groupId);
            if (group.type === 'radio') {
                if (goingToBeSelected) {
                    // all other items must become deselected
                    group.children.forEach(i => (i.selected = true));
                    item.selected = false;
                    this._options.toggleItems(group.children);
                }
                else {
                    // ignore click on selected radio item
                }
            }
            else {
                // just toggle the item
                this._options.toggleItems([item]);
            }
        }
        else {
            // just toggle the item
            this._options.toggleItems([item]);
        }
    }
    handleInfinityScroll(ul) {
        ul.addEventListener('scroll', (e) => dropdown_awaiter(this, void 0, void 0, function* () {
            var _a;
            e.preventDefault();
            e.stopPropagation();
            if (ul.offsetHeight + ul.scrollTop + 10 >= ul.scrollHeight) {
                try {
                    (_a = this._options.onScrollEnd) === null || _a === void 0 ? void 0 : _a.call(this);
                }
                catch (_b) {
                    // ignore
                }
            }
            return false;
        }));
    }
    positionDropdown() {
        positionDropdown(this._options.mainControl, this.root);
    }
}

;// CONCATENATED MODULE: ./src/components/common/formItems/multiSelect/multiSelect.ts
var multiSelect_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








class MultiSelect {
    constructor(options) {
        this._defaultItems = [];
        this._options = options;
        this.toggleError = this.toggleError.bind(this);
        this.toggleItems = this.toggleItems.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.hideOnOutsideClick = this.hideOnOutsideClick.bind(this);
        this.handleQueryChangeAsync = this.handleQueryChangeAsync.bind(this);
        injectStyles('rup-multiselect', {
            '.rup-multiselect': {
                padding: '0',
                margin: '0',
                position: 'relative',
                boxSizing: 'border-box',
                paddingRight: '32px'
            },
            '.rup-multiselect > .rup-select__icon': {
                pointerEvents: 'all',
                // in order to show always on top
                top: '9px',
                bottom: 'auto',
                right: '0.43rem'
            },
            '.rup-multiselect.rup-multiselect--disabled': {
                cursor: 'not-allowed',
                backgroundColor: colors.neutral100
            }
        });
    }
    render() {
        this.resetInternalState();
        const root = (this._root = document.createElement('div'));
        root.classList.add('rup-input');
        root.classList.add('rup-multiselect');
        setTestId(root, this._options.testId);
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        this._selection = new Selection({
            toggleDropdown: this.toggleDropdown,
            toggleItems: this.toggleItems,
            removeItem: () => { var _a; return (_a = this._options.onItemRemoved) === null || _a === void 0 ? void 0 : _a.call(this); },
            getMoreText: this._options.getMoreText
        });
        root.appendChild(this._selection.render());
        const dropdownButton = document.createElement('span');
        dropdownButton.classList.add('rup-select__icon');
        root.appendChild(dropdownButton);
        dropdownButton.addEventListener('click', e => {
            e.preventDefault();
            e.cancelBubble = true;
            this.toggleDropdown();
            return false;
        });
        this._dropdown = new dropdown_Dropdown({
            labelTemplate: this._options.labelTemplate,
            toggleItems: this.toggleItems,
            mainControl: this._root,
            searchText: this._options.searchText,
            noResultsText: this._options.noResultsText,
            onDropdownClosed: () => {
                var _a;
                this._dropdown.clearQuery();
                (_a = this._options.onDropdownClosed) === null || _a === void 0 ? void 0 : _a.call(this);
            },
            onScrollEnd: this.getScrollEndHandler(),
            closeOnScroll: this._options.closeOnScroll,
            disableSearch: this._options.disableSearch,
            onQueryChanged: this.handleQueryChangeAsync
        });
        if (!this._options.dropdownParentSelector) {
            document.body.appendChild(this._dropdown.render());
        }
        else {
            const dropdownParentSelectorContainer = document.querySelector(this._options.dropdownParentSelector);
            if (!dropdownParentSelectorContainer) {
                throw new Error(`Error while trying to find dropdown container with selector '${this._options.dropdownParentSelector}'.`);
            }
            dropdownParentSelectorContainer.appendChild(this._dropdown.render());
        }
        if (this._options.disabled) {
            this.toggleDisabled(this._options.disabled);
        }
        this.setItems(this._options.items, this._options.defaultItems);
        ['resize', 'mousedown'].forEach(event => window.addEventListener(event, this.hideOnOutsideClick));
        return root;
    }
    resetInternalState() {
        var _a, _b, _c, _d;
        ['resize', 'mousedown'].forEach(event => window.removeEventListener(event, this.hideOnOutsideClick));
        (_a = this._dropdown) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this._selection) === null || _b === void 0 ? void 0 : _b.dispose();
        (_d = (_c = this._root) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.removeChild(this._root);
    }
    dispose() {
        this.resetInternalState();
    }
    toggleError(error) {
        this._root.classList.toggle('rup-input--error', error);
    }
    toggleDisabled(disabled) {
        this._options.disabled = disabled;
        this._root.classList.toggle('rup-multiselect--disabled', disabled);
    }
    getSelectedItems() {
        return this._selection.selectedItems;
    }
    selectItems(values) {
        // collect dropdown items with selected ones in case selected values were filtered out by the query
        const valuableItems = new UniqueItemsMap([
            ...getValuableItems(this._dropdown.itemsTree),
            ...this._selection.selectedItems
        ]).items;
        const items = values === null || values === void 0 ? void 0 : values.map(v => valuableItems.find(i => i.value === v)).filter(i => !!i);
        if ((values === null || values === void 0 ? void 0 : values.length) > 0 && (items === null || items === void 0 ? void 0 : items.length) !== values.length) {
            throw new Error('You can select items only from the list.');
        }
        if (!this.needUpdate(items)) {
            return;
        }
        this._selection.updateSelection(items);
        this._dropdown.updateDropdown(this._dropdown.itemsTree, items, this._dropdown.query);
    }
    setItems(items, defaultItems) {
        var _a;
        this._options.items = items;
        const valuableItems = getValuableItems(items);
        this._defaultItems = (defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.length) ? defaultItems : (_a = valuableItems === null || valuableItems === void 0 ? void 0 : valuableItems.filter(i => i.default)) !== null && _a !== void 0 ? _a : [];
        let selectedItems = valuableItems.filter(i => i.selected);
        if (!selectedItems.length && this._options.defaultIfNothing) {
            selectedItems = valuableItems.filter(i => i.default);
            selectedItems.forEach(i => (i.selected = true));
        }
        this._selection.updateSelection(selectedItems);
        this._dropdown.updateDropdown(items, this._selection.selectedItems, null);
        this._fetchResult = null;
    }
    toggleDropdown(open) {
        if (this._options.disabled) {
            return;
        }
        const previouslyOpen = this._dropdown.isOpen();
        open = this._dropdown.toggleDropdown(open);
        this._root.classList.toggle('rup-input--focus', open);
        if (open && !previouslyOpen) {
            this.getDropdownItemsAsync(this._dropdown.query).then(items => this._dropdown.updateDropdown(items, this._selection.selectedItems, this._dropdown.query, !this._options.originalOrder));
        }
    }
    toggleItems(items) {
        var _a;
        items === null || items === void 0 ? void 0 : items.forEach(i => (i.selected = !i.selected));
        const selectedItemsMap = new UniqueItemsMap([...this._selection.selectedItems, ...items]);
        let newSelectedItems = selectedItemsMap.selectedItems;
        if (!newSelectedItems.length && this._options.defaultIfNothing) {
            newSelectedItems = this._defaultItems;
            newSelectedItems.forEach(i => (i.selected = true));
        }
        else if (this._options.defaultIfNothing) {
            if (items.some(i => i.default && i.selected)) {
                newSelectedItems = newSelectedItems.filter(i => i.default);
            }
            else {
                newSelectedItems = newSelectedItems.filter(i => !i.default);
            }
        }
        if (!this.needUpdate(newSelectedItems)) {
            return;
        }
        this._selection.updateSelection(newSelectedItems);
        this._dropdown.updateDropdown(this._dropdown.itemsTree, newSelectedItems, this._dropdown.query);
        (_a = this._options.onSelectionChanged) === null || _a === void 0 ? void 0 : _a.call(this, this._selection.selectedItems);
    }
    hideOnOutsideClick(e) {
        if (e.type === 'resize') {
            if (!this._options.closeOnScroll) {
                this._dropdown.positionDropdown();
            }
            else {
                this.toggleDropdown(false);
            }
            return;
        }
        if (this._root === e.target) {
            return;
        }
        if (this._dropdown.root === e.target) {
            return;
        }
        const root = closestParentElement(e.target, '.rup-multiselect');
        if (root && root === this._root) {
            return;
        }
        const dropdown = closestParentElement(e.target, '.rup-multiselect__dropdown');
        if (dropdown && dropdown === this._dropdown.root) {
            return;
        }
        this.toggleDropdown(false);
    }
    handleQueryChangeAsync(query) {
        return multiSelect_awaiter(this, void 0, void 0, function* () {
            window.clearTimeout(this._queryChangeTimer);
            this._queryChangeTimer = window.setTimeout(() => multiSelect_awaiter(this, void 0, void 0, function* () {
                const items = yield this.getDropdownItemsAsync(query);
                this._dropdown.updateDropdown(items, this._selection.selectedItems, query, true);
            }), 500);
        });
    }
    getScrollEndHandler() {
        let inProgress = false;
        return () => multiSelect_awaiter(this, void 0, void 0, function* () {
            var _a;
            if (inProgress) {
                return;
            }
            if (!this._options.fetchItemsAsync) {
                return;
            }
            // Just a double check because the "total" could be a string
            const valuableItems = getValuableItems(this._dropdown.itemsTree);
            if (((_a = this._fetchResult) === null || _a === void 0 ? void 0 : _a.total) == valuableItems.length) {
                return;
            }
            inProgress = true;
            const items = yield this.getDropdownItemsAsync(this._dropdown.query, valuableItems.length);
            if (items === null || items === void 0 ? void 0 : items.length) {
                this._dropdown.appendItems(items, this._selection.selectedItems, this._dropdown.query);
            }
            inProgress = false;
        });
    }
    getDropdownItemsAsync(query, skip) {
        return multiSelect_awaiter(this, void 0, void 0, function* () {
            if (!this._options.fetchItemsAsync) {
                const items = this._options.items || [];
                return query
                    ? filterTree(items, i => i.default || (i.text || i.value).toUpperCase().includes(query.toUpperCase()))
                    : items;
            }
            try {
                this._dropdown.toggleLoading(true);
                this._fetchResult = yield this._options.fetchItemsAsync(query, skip || 0);
                return this._fetchResult.items;
            }
            catch (_a) {
                // ignore
                return [];
            }
            finally {
                this._dropdown.toggleLoading(false);
            }
        });
    }
    needUpdate(newSelectedItems) {
        return ((newSelectedItems || [])
            .map(i => i.value)
            .sort()
            .toString() !==
            this._selection.selectedItems
                .map(i => i.value)
                .sort()
                .toString());
    }
}
function getValuableItems(tree) {
    let result = [];
    tree.forEach(i => {
        if ('children' in i) {
            result = result.concat(i.children);
        }
        else {
            result.push(i);
        }
    });
    return result;
}
function filterTree(tree, filter) {
    let result = [];
    tree.forEach(i => {
        if ('children' in i) {
            const filteredChild = i.children.filter(filter);
            if (filteredChild) {
                result.push(Object.assign(Object.assign({}, i), { children: filteredChild }));
            }
            result = result.concat(i.children);
        }
        else if (filter(i)) {
            result.push(i);
        }
    });
    return result;
}

;// CONCATENATED MODULE: ./src/components/common/notification.ts



var Types;
(function (Types) {
    Types["Information"] = "information";
    Types["Success"] = "success";
    Types["Warning"] = "warning";
    Types["Error"] = "error";
})(Types || (Types = {}));
class RupNotification {
    constructor(options) {
        this._options = options;
        injectStyles('rup-notification', {
            '.rup-notification--close': {
                display: 'none'
            }
        });
    }
    render() {
        this._root = document.createElement('div');
        this._root.classList.add('rup-notification');
        switch (this._options.type) {
            case Types.Success:
                this._root.classList.add('rup-notification--success');
                break;
            case Types.Warning:
                this._root.classList.add('rup-notification--warning');
                break;
            case Types.Error:
                this._root.classList.add('rup-notification--error');
                break;
            default:
                break;
        }
        this._root.setAttribute('aria-label', 'notification label');
        this._root.setAttribute('aria-describedby', 'alert_desc-1');
        if (this._options.icon) {
            this._root.appendChild(this.renderIcon());
        }
        const textContainer = document.createElement('p');
        textContainer.setAttribute('id', 'alert_desc-1');
        textContainer.classList.add('rup-notification__content');
        textContainer.innerHTML = this._options.text;
        this._root.appendChild(textContainer);
        if (this._options.secondaryButtonText) {
            this._root.appendChild(this.renderSecondaryButton());
        }
        if (this._options.primaryButtonText) {
            this._root.appendChild(this.renderPrimaryButton());
        }
        if (this._options.closeButton) {
            this._root.appendChild(this.renderCloseButton());
        }
        return this._root;
    }
    renderIcon() {
        const span = document.createElement('span');
        span.classList.add('rup-notification__icon');
        span.classList.add('rup-icon');
        let icon;
        switch (this._options.type) {
            case Types.Information:
                icon = new Icon({ svg: InfoIcon });
                break;
            case Types.Success:
                icon = new Icon({ svg: CheckMarkIcon });
                break;
            case Types.Warning:
                icon = new Icon({ svg: WarningIcon });
                break;
            case Types.Error:
                icon = new Icon({ svg: DangerIcon });
                break;
            default:
                break;
        }
        span.appendChild(icon.render());
        return span;
    }
    renderCloseButton() {
        const closeButton = document.createElement('button');
        closeButton.classList.add('rup-notification__close');
        closeButton.classList.add('rup-icon-btn');
        closeButton.classList.add('rup-icon-btn--neutral');
        closeButton.classList.add('rup-icon-btn--sm');
        closeButton.setAttribute('type', 'button');
        const icon = new Icon({ svg: CancelIcon });
        closeButton.appendChild(icon.render());
        closeButton.addEventListener('click', () => this._root.classList.toggle('rup-notification--close', true));
        return closeButton;
    }
    renderPrimaryButton() {
        const primaryButton = document.createElement('button');
        primaryButton.classList.add('rup-notification__btn');
        primaryButton.classList.add('rup-btn');
        primaryButton.classList.add('rup-btn--contained');
        primaryButton.setAttribute('type', 'button');
        primaryButton.textContent = this._options.primaryButtonText;
        primaryButton.addEventListener('click', this._options.onPrimaryButtonClick);
        return primaryButton;
    }
    renderSecondaryButton() {
        const secondaryButton = document.createElement('button');
        secondaryButton.classList.add('rup-notification__btn');
        secondaryButton.classList.add('rup-btn');
        secondaryButton.setAttribute('type', 'button');
        secondaryButton.textContent = this._options.secondaryButtonText;
        secondaryButton.addEventListener('click', this._options.onSecondaryButtonClick);
        return secondaryButton;
    }
}

;// CONCATENATED MODULE: ./src/components/actionsBar/actionsBar.ts



class ActionsBar {
    constructor(options) {
        this._options = options;
        this.updateItems = this.updateItems.bind(this);
        this.resizeHandler = this.resizeHandler.bind(this);
        window.addEventListener('resize', this.resizeHandler);
        injectStyles('actions-bar', {
            '.actions-bar': {
                display: 'flex',
                flex: '1',
                justifyContent: 'flex-end',
                alignItems: 'center'
            },
            '.actions-bar > *': {
                margin: '0 6px'
            },
            '.actions-bar__more': {
                display: 'flex'
            },
            '.actions-bar__more > .rup-icon-btn > svg.icon-more': {
                transform: 'rotate(90deg)'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn': {
                padding: '12px',
                outline: 'none !important',
                borderRadius: '0',
                borderColor: 'transparent !important',
                width: '100%',
                justifyContent: 'flex-start'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-checkbox': {
                padding: '6px 12px'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-checkbox > label': {
                width: '100%'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn:not([disabled])': {
                color: '#485B6E'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn:hover': {
                backgroundColor: '#E9EFF2'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn:active': {
                backgroundColor: '#E9EFF2'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn > svg': {
                display: 'none'
            },
            '.actions-bar__more > .dropdown-menu > li .rup-btn > .icon': {
                display: 'none'
            }
        });
    }
    render() {
        const root = (this._root = document.createElement('div'));
        if (this._options.className) {
            root.className = this._options.className;
        }
        root.classList.add('actions-bar');
        if (this._options.css) {
            applyCSS(root, this._options.css);
        }
        this._options.items.forEach(i => {
            root.prepend(i);
        });
        const more = (this._moreButton = this.createMoreButton());
        root.prepend(more);
        this.updateItems();
        return root;
    }
    dispose() {
        window.removeEventListener('resize', this.resizeHandler);
        this._root.remove();
    }
    // TODO: migrate to the RUP dropdown once it will be released
    createMoreButton() {
        const root = document.createElement('div');
        root.classList.add('dropdown', 'pull-right', 'actions-bar__more', 'visuallyhidden');
        const button = document.createElement('button');
        root.append(button);
        button.classList.add('rup-icon-btn', 'rup-icon-btn--sm', 'dropdown-toggle');
        button.setAttribute('data-toggle', 'dropdown');
        button.setAttribute('type', 'button');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = MoreIcon;
        const dropdown = (this._moreDropdown = document.createElement('ul'));
        root.append(dropdown);
        dropdown.classList.add('dropdown-menu');
        return root;
    }
    resizeHandler() {
        this.updateItems(false);
    }
    updateItems(force = true) {
        if (!this._root || !this._root.parentElement) {
            return;
        }
        const maxVisibleItems = this.getNonCollapsedItemsCount();
        if (!force && this._prevMaxVisibleItems === maxVisibleItems) {
            return;
        }
        this._prevMaxVisibleItems = maxVisibleItems;
        const visibleItems = this._options.items.filter(i => i && window.getComputedStyle(i).display !== 'none');
        if (maxVisibleItems >= visibleItems.length) {
            this._moreButton.classList.add('visuallyhidden');
            visibleItems.forEach(i => this._moreButton.after(i));
        }
        else {
            visibleItems.slice(0, maxVisibleItems).forEach(i => this._moreButton.after(i));
            this._moreDropdown.innerHTML = '';
            visibleItems.slice(maxVisibleItems).forEach(i => {
                const li = document.createElement('li');
                li.append(i);
                this._moreDropdown.append(li);
            });
            this._moreButton.classList.toggle('visuallyhidden', visibleItems.length <= maxVisibleItems);
        }
    }
    getNonCollapsedItemsCount() {
        if (!this._options.widthSteps || !this._options.widthSteps.length) {
            return this._options.items.length;
        }
        const width = window.innerWidth;
        for (const step of this._options.widthSteps) {
            if ((!step.from || step.from <= width) &&
                (!step.to || width <= step.to) &&
                (!step.condition || step.condition())) {
                return step.itemsCount;
            }
        }
        return this._options.items.length;
    }
}

;// CONCATENATED MODULE: ./src/utils/downloadFile.ts
function downloadBlob(blobData, getHeader, defaultFileName) {
    const fileName = getFileNameFromResponseOrDefault(getHeader, defaultFileName);
    const blob = new Blob([blobData], { type: getHeader('content-type') });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('style', 'display: none');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
}
function getFileNameFromResponseOrDefault(getHeader, defaultName) {
    const contentDisposition = getHeader('content-disposition');
    if (!contentDisposition) {
        return defaultName;
    }
    const regexUtf8 = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
    const matchesUtf8 = regexUtf8.exec(contentDisposition);
    if ((matchesUtf8 === null || matchesUtf8 === void 0 ? void 0 : matchesUtf8.length) >= 2) {
        let fileName = matchesUtf8[1];
        fileName = decodeURIComponent(fileName);
        fileName = fileName.replace(/["']/g, '');
        return fileName;
    }
    const regex = /filename=([^;$]+)/;
    const matches = regex.exec(contentDisposition);
    if ((matches === null || matches === void 0 ? void 0 : matches.length) >= 2) {
        let fileName = matches[1];
        fileName = fileName.replace(/["']/g, '');
        return fileName;
    }
    return defaultName;
}

;// CONCATENATED MODULE: ./src/utils/encodeFileToBase64Async.ts
function encodeFileToBase64Async(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = function (ev) {
            try {
                const base64 = btoa(ev.target.result);
                const base64File = new File([base64], file.name, { type: file.type });
                resolve(base64File);
            }
            catch (err) {
                reject(err);
            }
        };
        reader.onerror = () => {
            reject(new Error(`Cannot read the file '${file.name}'.`));
        };
    });
}

;// CONCATENATED MODULE: ./src/utils/analytics.ts
const parameterTokenLabels = {
    account: 'Account',
    businessUnitType: 'Business Unit Type',
    businessUnits: 'Business Unit',
    usageMetric: 'UsageType',
    usageType: 'UsageType',
    breakEvenThreshold: 'Bethreshold',
    usageConversionRate: 'UsageConversion',
    site: 'Site',
    dataSet: 'DataSet',
    startPeriod: 'Dates',
    endPeriod: 'Dates',
    topResult: 'TopResults',
    resource: 'Resource',
    publisherName: 'Publisher',
    publicationDefinition: 'Publication',
    publisher: 'Vendor',
    publishers: 'Publishers',
    publication: 'Publication',
    fiscalYear: 'FY',
    run: 'Run',
    export: 'Export'
};
const actionTokenLabels = {
    pin: 'Pin',
    toggle: 'Toggle',
    chartType: 'ChartType',
    articleBusinessUnitType: 'LT',
    articleId: 'AS',
    user: 'User',
    drilldown: 'Drilldown',
    export: 'Export',
    import: 'Import',
    editMode: 'EditMode',
    createWB: 'CreateWorkingBudget',
    copyForecasted: 'CopyForecasted',
    applyPercent: 'Apply%',
    showPsa: 'DocDel',
    showBE: 'TitleBE',
    createFinal: 'CreateFinal',
    resetGlobalParameters: 'ResetGlobalParameters',
    applyGlobalParameters: 'ApplyGlobalParameters',
    // Budget
    markAsActual: 'MarkAsActual',
    useForNextYear: 'UseForNextYear',
    rename: 'Rename',
    audit: 'Audit',
    duplicate: 'duplicate',
    delete: 'Delete',
    createAB: 'CreateActualBudget'
};
const componentTokenLabels = {
    RO: 'ReportOptions'
};
class GoogleAnalyticsService {
    constructor() {
        this._optionsToken = 'RO';
    }
    // send the parameter change event
    sendOptionEvent(category, parameterName) {
        const parameterLabel = parameterTokenLabels[parameterName];
        if (category && parameterLabel) {
            this.sendEvent(category, this._optionsToken, parameterLabel);
        }
    }
    sendActionEvent(category, actionToken) {
        const actionLabel = actionTokenLabels[actionToken];
        if (category && actionLabel) {
            this.sendEvent(category, actionLabel);
        }
    }
    sendEvent(category, action, label) {
        if (!category) {
            return;
        }
        const labelText = category.concat(action ? `_${action}` : '').concat(label ? `_${label}` : '');
        try {
            ga('send', {
                hitType: 'event',
                eventCategory: category,
                eventAction: action,
                eventLabel: labelText
            });
        }
        catch (e) {
            // ignore
            console.log(e);
            debugger;
        }
    }
    sendPageView(pageToken) {
        try {
            ga('send', 'pageview', pageToken !== null && pageToken !== void 0 ? pageToken : window.location.href);
        }
        catch (e) {
            // ignore
        }
    }
}

;// CONCATENATED MODULE: ./src/utils/globalFilters.ts
class GlobalFilters {
}
GlobalFilters.defaultBreakEvenThreshold = 1;
GlobalFilters.defaultUsageConversionRate = 1;
GlobalFilters.defaultUsageTypes = [
    '[Measures].[Pdf Usage Count]',
    '[Measures].[Html Usage Count]',
    '[Measures].[Unique Item Requests]'
];

;// CONCATENATED MODULE: ./src/index.ts



































const SelectUtils = {
    itemsComparer: itemsComparer,
    getItemByValue: getItemByValue,
    createRupSelectItem: createRupSelectItem
};


}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map